
function bulletin_create(item,courses_this, courses_that, dataProgram) {


     

    var sLANG = 'FR'
    
   // var bullData = bulletin_top()
    
    var bullData = fnc_bull_return_text( "(==SECTION TABLE COLLEGE)\n","(==COLLEGE TABLE SECTION)\n" , sLANG)
    bullData += fnc_bull_return_section_otherSchools(courses_that)
    
    bullData += fnc_bull_return_text( "CHARGER_COLLEGES\n","LOAD_COLLEGES\n", sLANG)
    bullData += fnc_bull_return_text( "INITIALISER_PILE\n","INITIALIZE_STACK\n", sLANG)
    
    bullData += fnc_bull_return_text( "(==SECTION PARAMETRES IMPRESSION)\n","(==PRINT PARAMETERS SECTION)\n", sLANG)
    bullData += "(.92)\n"
    bullData += "(.87)\n"
    bullData += "(.50)\n"
    bullData += "(N)\n"
    bullData += "(0)\n"
    

var details = sessionStorage.getItem('collegeInfo').split("|")

    bullData += fnc_bull_return_text("(==SECTION ENTETE COLLEGE)\n","(==COLLEGE HEADING SECTION)\n",sLANG)
    bullData += "(" + details[0] + ")\n"
    bullData += "(" + details[1] + ")\n"
    bullData += "(" + details[2] + ")\n"
    bullData += "(" + details[3] + ")\n"
    bullData += "()\n"
    bullData += "()\n"
    bullData += "(" + details[4] + ")\n" // SCHOOL CODE
    bullData += "(0)\n"
    bullData += "(0)\n"
    
    bullData += fnc_bull_return_text("(==SECTION ADRESSE ETUDIANT)\n","(==STUDENT ADDRESS SECTION)\n",sLANG)
    bullData += "(" + item.student_lNAME + "," + item.student_fNAME + ")\n"
    bullData += "(" + (item.student_apt + ' ' + item.student_Address).trim() + ")\n"
    bullData += "(" + (item.student_City + '  ' + item.Province).trim() + ")\n"
    bullData += "(" + item.student_Postal + ")\n"
    bullData += "()\n"
    bullData += "()\n"
    bullData += fnc_bull_return_text("(==SECTION IDENTIFICATION ETUDIANT)\n","(==STUDENT IDENTIFICATION SECTION)\n",sLANG)
    bullData += "(" + item.student_NumAdmission + ")\n" // NUM ADMIN 
    bullData += "(" + item.student_CodePerm + ")\n" // CODE PERM
    
    bullData += "(" + item.student_Birthday + ")\n" // BIRTHDAY
    bullData += "()\n" 
    bullData += "(" + dataProgram[0].prog_CODE + ")\n" // PROGRAM CODE 
    bullData += "(" + dataProgram[0].prog_TITRE_F + ")\n" // PROGRAM TITLE 
    bullData += "()\n" 
    bullData += "()\n" 
    bullData += "()\n" 
    bullData += "()\n" 
    bullData += "(AEC)\n" 
    
    bullData += "(10)\n" // UNITS
    bullData += "(2010)\n" // REGIME
    
    bullData += fnc_bull_return_text("(SESSIONNEL)\n","(TERM)\n",sLANG) // 
    
    
    
    // COURSES THIS
    bullData += fnc_bull_return_section_courses_this(courses_this,sLANG)
    // COURSES OTHER
    bullData += fnc_bull_return_section_courses_other(courses_that,sLANG)
    // OBJECTIVES
    bullData += fnc_bull_return_section_objectives_other(courses_that,sLANG)
    // SANCTIONS
    bullData += fnc_bull_return_section_sanction(courses_that,sLANG)
    
    bullData += "(==SECTION AUTRES EPREUVES)\n" // IMPORTANT
    // Épreuve  synthèse
    bullData += fnc_bull_return_section_epreuve(courses_that,"Épreuve  synthèse",sLANG)
    // Épreuve  ministerielle
    bullData += fnc_bull_return_section_epreuve(courses_that,"Épreuve  ministerielle",sLANG)
    
    
    
    //bullData += "(==SECTION AUTRES COURS)\n" // 
    bullData += fnc_bull_return_text("(==SECTION INFORMATIONS COMPLEMENTAIRES)\n","(==COMPLEMENTARY INFORMATION SECTION)\n",sLANG) // 
    bullData += "(Non)\n"
    bullData += "(Directeur général et des études)\n"
    bullData += "(LARRY)\n"
    bullData += "(" + '' + ")\n" // date bulletin
    bullData += "(Sans Objet)\n"
    bullData += "(Sans Verdict)\n"
    
    bullData += "(N)\n"
    bullData += fnc_bull_return_text("TRAITER_ETUDIANT\n","PROCESS_STUDENT\n",sLANG)
    
    

    return bullData

    
    }


    function fnc_bull_return_section_otherSchools(cours) {
        var bullData = '';
    
        const result = [];
        const map = new Map();
        for (const item of cours) {
            if(!map.has(item.other_SchoolCode)){
                map.set(item.other_SchoolCode, true);    // set any value to Map
                result.push({
                    code: item.other_SchoolCode,
                    name: item.other_SchoolName
                });
            }
        }
    if (result.length > 0) {
        bullData += "(==COLLEGE)\n"
        result.forEach(function(data){
            bullData += "(" + data.code + ")\n"
            bullData += "(" + data.name + ")\n"
            bullData += "()\n" // 
            bullData += "()\n" // 
        })
    }
        return bullData;
    } // END SECTION SANCTION
    
   function fnc_bull_return_section_sanction(cours,sLANG) {
        var self = this;
        var bullData = '';
        bullData += fnc_bull_return_text("(==SECTION AUTRES SANCTIONS)\n","(==OTHER CERTIFICATIONS SECTION)\n",sLANG)
        cours.forEach(function(data){
        if (data.other_SchoolName == "Sanction") {
            bullData += fnc_bull_return_text("(==AUTRE SANCTION)\n","(==OTHER CERTIFICATION)\n",sLANG)
            bullData += "(" + data.other_Remark + ")\n"
            bullData += "(" + data.other_CourseCode + ")\n"
            bullData += "(" + data.other_CourseTitleFrench + ")\n"
            bullData += "()\n" // 
            bullData += "(" + fnc_bull_return_session(data.other_Session, sLANG) + "-" + data.other_Annee + ")\n"
            bullData += "(" + data.other_SchoolCode + ")\n"
            bullData += "()\n" // 
        }
        })
        return bullData;
    } // END SECTION SANCTION
    
    function fnc_bull_return_section_epreuve(cours, eType,sLANG) {
        var self = this;
        var bullData = '';
        cours.forEach(function(data){
        if (data.other_SchoolName == eType) {
            bullData += fnc_bull_return_text("(==TITRE AUTRE EPREUVE)\n","(==OTHER EXAMINATIONS SECTION)\n",sLANG)
            bullData += "(" + eType + ")\n"
            bullData += fnc_bull_return_text("(==AUTRE EPREUVE)\n","(==OTHER EXAMINATION)\n",sLANG)
            bullData += "(" + data.other_CourseCode + ")\n"
            bullData += "(" + data.other_CourseTitleFrench + ")\n"
            bullData += "(" + data.other_Remark + ")\n"
            bullData += "(" + fnc_bull_return_session(data.other_Session, sLANG) + "-" + data.other_Annee + ")\n"
            bullData += "()\n" //
            bullData += "()\n" // 
        }
        })
        return bullData;
    } // END SECTION Épreuve
    
    function fnc_bull_return_section_objectives_other(cours,sLANG) {
        var self = this;
        var bullData = '';
        bullData += fnc_bull_return_text("(==SECTION AUTRES OBJECTIFS)\n","(==OTHER OBJECTIVES SECTION)\n",sLANG)
        cours.forEach(function(data){
        if (data.other_SchoolName == 'comp') {
            bullData += fnc_bull_return_text("(==AUTRE OBJECTIF)\n","(==OTHER OBJECTIVE)\n",sLANG)
            bullData += "(" + data.other_CourseCode + ")\n"
            bullData += "(" + data.other_CourseTitleFrench + ")\n"
            bullData += "()\n" //
            bullData += "(" + data.other_Remark + ")\n"
            bullData += "(" + fnc_bull_return_session(data.other_Session,sLANG) + "-" + data.other_Annee + ")\n"
            bullData += "(" + data.other_SchoolCode + ")\n" //
            bullData += "()\n" // 
        }
        })
        return bullData;
    } // END SECTION OBJECTIVE OTHER
    
    function fnc_bull_return_section_courses_other(cours,sLANG) {
        var self = this;
        var bullData = '';
        bullData += fnc_bull_return_text("(==SECTION AUTRES COURS)\n","(===OTHER COURSES SECTION)\n",sLANG)
        cours.forEach(function(data){
        if (data.other_CourseCode.length == 8 && data.other_CourseAverage !== "* ") {
            bullData += fnc_bull_return_text("(==COURS SESSIONNEL)\n","(==TERM COURSE)\n",sLANG)
            bullData += "(" + data.other_CourseCode + ")\n"
            bullData += "(" + data.other_CourseTitleFrench + ")\n"
            bullData += "(" + data.other_Mark + ")\n"
            bullData += "(" + data.other_CourseAverage + ")\n"
            bullData += "(" + data.other_CourseUnits + ")\n"
            bullData += "(" + data.other_Remark + ")\n"
            bullData += "(" + fnc_bull_return_session(data.other_Session,sLANG) + "-" + data.other_Annee + ")\n"
            bullData += "(" + data.other_SchoolCode + ")\n"
        }
        })
        return bullData;
    } // END SECTION COURSES OTHER
    
    function fnc_bull_return_section_courses_this(cours,sLANG) {
        var self = this;
        var bullData = '';
        bullData += fnc_bull_return_text("(==SECTION COURS SESSIONNELS)\n","(==PROGRAM COURSES SECTION)\n",sLANG)
        cours.forEach(function(data){
           
            bullData += fnc_bull_return_text("(==COURS SESSIONNEL)\n","(==TERM COURSE)\n",sLANG)
            bullData += "(" + data.cour_CODE + ")\n"
            bullData += "(" + data.cour_TITRE_F + ")\n"
            bullData += "(" + data.cs_MARK + ")\n"
            bullData += "(" + data.group_AVG + ")\n"
            if (data.cs_REMARK != 'EC') {bullData += "(" + data.cour_UNITS + ")\n"} else {bullData += "()\n"}
            bullData += "(" + data.cs_REMARK + ")\n"
            bullData += "(" + fnc_bull_return_session(data.group_SESS,sLANG) + "-" + data.group_ANN + ")\n"
            bullData += "()\n"
        })
        return bullData;
    } // END SECTION COURSES THIS
    
    
    function fnc_bull_return_text(sFR, sAN, sLANG) {
        if (sLANG == 'FR') {
            return sFR;
        } else {
            return sAN;
        }
    } // END GET TEXT (FRENCH/ENGLISH)

    function fnc_bull_return_session(sSESS, sLANG) {
        if (sLANG !== 'FR') {
            if (sSESS == "H") {
                return "W"
            } else if (sSESS == "E") {
                return "S"
            } else {
                return "A"
            }
        } else {
            return sSESS;
        }
    } // END GET SESSION (FRENCH/ENGLISH)



function bulletin_top() {
    return `
    %-12345X@PJL JOB 
@PJL RDYMSG DISPLAY = "< Bulletin >" 
@PJL ENTER LANGUAGE = POSTSCRIPT 
%---------------------------------------------------------------
% Version: 9.62 27/01/2011
%---------------------------------------------------------------
%!PS-Adobe-3.0 
%%Title: Bulletin 
%%Creator: Simon Daigneault 
%%CreationDate: 03-02-1997 
%%For: Cegep de Trois-Rivieres 
%%Pages: 1 
%%PageOrder: Special 
%%DocumentNeededResources: font CommercialScript-WP 
%%BoundingBox: 0 0 612 792 
%%EndComments 
%%BeginProlog 
  /A0001  {  /A0002 exch def  /A0003 exch def  /A0004 A0003 findfont def  /A0005 A0004 maxlength dict def  A0004  {  1 %
 index  /A0006 ne  {  1 index /Encoding eq {  dup  length array  copy  A0005 3 1 roll  put  }{  A0005 3 1 roll put  %
 }ifelse  }{  pop pop  }ifelse  }forall  A0005 begin  Encoding 8#341/aacute put  Encoding 8#351/eacute put  Encoding %
 8#355/iacute put  Encoding 8#363/oacute put  Encoding 8#372/uacute put  Encoding 8#301/Aacute put  Encoding 8#311/Eacute %
 put  Encoding 8#315/Iacute put  Encoding 8#323/Oacute put  Encoding 8#332/Uacute put  Encoding 8#340/agrave put  Encoding %
 8#350/egrave put  Encoding 8#354/igrave put  Encoding 8#362/ograve put  Encoding 8#371/ugrave put  Encoding 8#300/Agrave %
 put  Encoding 8#310/Egrave put  Encoding 8#314/Igrave put  Encoding 8#322/Ograve put  Encoding 8#331/Ugrave put  Encoding %
 8#344/adieresis put  Encoding 8#353/edieresis put  Encoding 8#357/idieresis put  Encoding 8#366/odieresis put  Encoding %
 8#374/udieresis put  Encoding 8#377/ydieresis put  Encoding 8#304/Adieresis put  Encoding 8#313/Edieresis put  Encoding %
 8#317/Idieresis put  Encoding 8#326/Odieresis put  Encoding 8#334/Udieresis put  Encoding 8#342/acircumflex put  Encoding %
 8#352/ecircumflex put  Encoding 8#356/icircumflex put  Encoding 8#364/ocircumflex put  Encoding 8#373/ucircumflex put  %
 Encoding 8#302/Acircumflex put  Encoding 8#312/Ecircumflex put  Encoding 8#316/Icircumflex put  Encoding 8#324/Ocircumflex %
 put  Encoding 8#333/Ucircumflex put  Encoding 8#347/ccedilla put  Encoding 8#307/Ccedilla put  /FontName A0002 100 string %
 cvs def  end  A0002 A0005 definefont  pop  }bind def  /A0052 1 def  /Times-Bold  /Times-Bold-French A0001  %
 /Times-BoldItalic  /Times-BoldItalic-French A0001  /Times-Roman  /Times-Roman-French A0001  /Courier  /Courier-French %
 A0001  /Courier-Bold  /Courier-Bold-French A0001  /Times-Roman-French findfont 10 scalefont setfont  /Courier  %
 /Courier-French A0001  /Times-Roman-French findfont 10 scalefont setfont  /A0063  {  A0282 0 eq  {currentfont  /FontMatrix %
 get  3 get  1000 mul  }  {A0282  }ifelse  }bind def  /A0065  {  currentfont  /FontMatrix get  0 get  1000 mul  }bind def  %
 /A0066  {  /A0067 exch def  /A0068 0 def  /A0069 0 def  /A0070 false def  0 1 A0067 length 1 sub  {  /A0071 exch def  %
 A0067 A0071 1 getinterval ( ) ne  {  A0070 not  {/A0068 A0071 def  /A0070 true def }if  /A0069 A0071 def  }if  }for  A0069 %
 0 ne  {/A0069 A0069 1 add def }if  A0067 A0068 A0069 A0068 sub getinterval  }bind def  /A0072  {  /A0073 exch def  gsave  %
 currentpoint  /A0074 exch def  /A0075 exch def  /A0074 A0074 2 sub def  A0073 show  currentpoint  /A0076 exch def  /A0077 %
 exch def  /A0076 A0076 2 sub def  /A0077 A0077 2 sub def  /A0077 A0077 2 add def  A0075 A0074 moveto  A0077 A0076 lineto  %
 stroke  grestore  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 moveto  }bind def  /A0078  {  /A0073 exch %
 def  gsave  currentpoint  /A0079 exch def  /A0080 exch def  /A0079 A0079 2 sub def  A0073 show  currentpoint  /A0081 exch %
 def  /A0082 exch def  /A0081 A0081 2 sub def  /A0082 A0082 2 sub def  /A0082 A0082 2 add def  A0080 A0079 moveto  A0082 %
 A0081 lineto  stroke  grestore  currentpoint  /A0081 exch def  /A0082 exch def  A0082 A0081 moveto  }bind def  /A0083  {  %
 /A0073 exch def  gsave  currentpoint  /A0079 exch def  /A0080 exch def  /A0079 A0079 2 sub def  A0073 ashow  currentpoint  %
 /A0081 exch def  /A0082 exch def  /A0081 A0081 2 sub def  /A0082 A0082 2 sub def  /A0082 A0082 2 add def  A0080 A0079 %
 moveto  A0082 A0081 lineto  stroke  grestore  currentpoint  /A0081 exch def  /A0082 exch def  A0082 A0081 moveto  }bind %
 def  /A0084  {  4 -2 roll  moveto  1 index  0 rlineto  0 exch rlineto  neg 0 rlineto  closepath  setlinewidth  setgray  %
 exec  0 setgray  }bind def  /A0085  {  /A0086 exch def  /A0087 exch def  /A0088 exch def  /A0089 exch def  /A0090 exch %
 def  /A0091 exch def  /A0092 exch def  /A0093 exch def  /A0094 exch def  /A0095 exch def  /A0096 exch def  /A0097 exch %
 def  /A0098 exch def  /A0099 A0095 A0091 sub A0092 sub def  /A0100 A0097 A0092 add def  A0093 (F) eq  {  gsave  A0098  %
 A0100 A0096 A0063 sub A0099 A0090 A0089 A0106  /A0101 A0096 currentpoint exch pop sub def  /A0102 A0096 A0094 A0101 sub 2 %
 div sub A0063 sub def  grestore  A0088 1 ne  {  gsave  {fill }A0088 A0087 A0097 A0096 A0095 A0094 neg A0084  grestore  %
 }if  A0087 0 ne  {  gsave  {stroke }A0086 A0087 A0097 A0096 A0095 A0094 neg A0084  grestore  }if  A0088 1 ne  {  A0098  %
 A0100 A0102 A0099 A0090 A0089 A0106  }if  }  {  /A0102 A0096 A0063 A0094 add sub def  A0098  A0100 A0102 A0099 A0090 A0089 %
 A0106  A0088 1 ne  {  gsave  {fill }A0088 A0087 A0097 A0096 A0095  A0096 currentpoint exch pop sub  A0094 add neg A0084  %
 grestore  }if  A0087 0 ne  {  gsave  {stroke }A0086 A0087 A0097 A0096 A0095  A0096 currentpoint exch pop sub  A0094 add %
 neg A0084  grestore  }if  A0088 1 ne  {  A0098  A0100 A0102 A0099 A0090 A0089 A0106  }if  }ifelse  }bind def  /A0103  {  %
 /A0104 A0112 def  /A0073 exch def  A0110 1 eq  {  A0073 stringwidth pop neg  A0112 add 0 rmoveto  }if  A0110 2 eq  {  %
 A0112 2 div 0 rmoveto  A0073 stringwidth pop 2 div neg 0 rmoveto  }if  Souligne_pb500 (O) eq  {  A0073 A0078  }  {  A0073 %
 show  }ifelse  }bind def  /A0105  {  /A0104 A0112 def  /A0073 exch def  Souligne_pb500 (O) eq  {  A0073 A0083  }  {  A0073 %
 ashow  }ifelse  }bind def  /A0106  {  /A0107 0 def  /A0108 0 def  dup  type  /stringtype ne  {  /A0110 exch def  }if  dup  %
 type  /stringtype ne  {  /A0111 exch def  /A0112 exch def  /A0113 exch def  /A0114 exch def  }if  mark exch  A0114 A0113 %
 moveto  dup stringwidth pop  A0112 gt  {  dup dup  length 1 sub 0 1 3 -1 roll  {  dup  1 exch  4 1 roll  getinterval  dup  %
 stringwidth pop  /A0107 exch A0107 add def  ( ) eq  {  A0107 A0112 gt  {  pop  exit  }if  /A0108 exch def  }{  pop  %
 }ifelse  dup  }for  /A0115 true def  }{  dup length  /A0108 exch def  /A0115 false def  /A0116 (O) def  }ifelse  dup 0 %
 A0108 getinterval  A0110 3 ne  {  A0103  }  {  dup stringwidth pop  neg A0112 add  1 index length 1 sub div  dup A0111  %
 A0065 mul gt  {  pop  A0103  }{  0  3 -1 roll  A0105  }ifelse  }ifelse  /A0113 A0113 A0063 2 add sub def  A0115 true eq  %
 {  dup  length  A0108 1 add  sub  A0108 1 add  exch  getinterval  A0106  }if  cleartomark  }bind def  /A0117  {  (EC) %
 A0118 eq  {/A0118 (EC) def }if  (EA) A0118 eq  {/A0118 (EA) def }if  (EQ) A0118 eq  {/A0118 (EQ) def }if  (RE) A0118 eq  %
 {/A0118 (RE) def }if  (E) A0118 eq  {/A0118 (EC) def }if  (I) A0118 eq  {/A0118 (IN) def }if  }bind def  /A0119  {  %
 /Times-Roman-French findfont 18 scalefont setfont  A0578 380 add A0076 A0343 (SESSIONNEL) eq  {9 }{19 }ifelse add moveto  %
 1 setgray  500 0 rlineto  0 -50 rlineto  -500 0 rlineto  closepath  fill  0 setgray  0 0 moveto   %
(Votre bulletin est retenu, veuillez vous présenter au bureau du registraire.)  A0578 A0076 A0343 (SESSIONNEL) eq  {20 }{10 %
 }ifelse sub  572 50 (V) 10 10 0.2 2 .85 .30 0 A0085  /Times-Roman-French findfont 10 scalefont setfont  }bind def  %
 /impression_message_pile  {gsave  40 A0146  /A0121 exch def  /A0122 exch def  /A0123 exch def  A0122 A0121 moveto  160 350 %
 275 .80 0 Psigle  A0123 show  grestore  }bind def  /A0124  {  gsave  /A0125 exch def  /A0126 exch def  /A0127 exch def  %
 /A0128 exch def  A0126 A0127 lineto  A0126 A0125 lineto  A0128 A0125 lineto  closepath  stroke  grestore  }bind def  %
 /A0129  {  /A0130 exch def  A0130 setgray  /A0131 A0076 def  /A0132 A0077 def  gsave  /A0125 exch def  /A0126 exch def  %
 /A0127 exch def  A0130 A0470 eq  {/A0127 A0127 0.5 add def  /A0126 A0126 0.3 add def }if  /A0128 exch def  A0212 not  {  %
 A0127 A0134 gt  {/A0127 A0134 def  /A0133 A0127 def }if  }if  /A0077 A0128 def  /A0076 A0127 def  A0077 A0076 moveto  %
 A0126 A0127 lineto  A0126 A0125 lineto  A0128 A0125 lineto  fill  grestore  0 setgray  A0128 50 lt A0127 720 lt and  %
 {A0128 A0127 moveto  A0128 A0125 lineto  stroke }if  A0212 not  {  /A0077 A0132 def  /A0076 A0131 def  A0077 A0076 moveto  %
 /A0134 A0125 def  }if  /A0135 A0125 def  }bind def  /A0136  {  currentpoint  /A0137 exch def  /A0138 exch def  gsave  %
 /A0139 exch def  /A0140 exch def  /A0141 exch def  /A0142 exch def  /A0143 exch def  A0139 setgray  /A0144 A0143 def  %
 /A0145 A0142 def  A0144 A0145 moveto  A0141 A0142 lineto  A0141 A0140 lineto  A0143 A0140 lineto  fill  grestore  0 %
 setgray  A0138 A0137 moveto  }bind def  /A0146  {  /A0147 exch def  /Times-Bold-French findfont  A0147 scalefont  setfont  %
 }bind def  /A0148  {  /A0147 exch def  /Times-Roman-French findfont  A0147 scalefont  setfont  }bind def  /A0149  {  A0335 %
 1 gt  {  (Page )show  A0316 A0428 cvs show  ( de ) show  A0335 A0428 cvs show  }if  }bind def  /A0150  {  /A0151 exch def  %
 /A0152 exch def  /A0153 A0152 length def  /A0154 A0151 length def  /A0155 A0153 A0154 add def  /A0156 A0155 string def  %
 A0156 0 A0152 putinterval  A0156 A0153 A0151 putinterval  A0156  }bind def  /A0157  {  /A0158 exch def  /A0159 exch def  %
 /A0160 exch def  A0160 () ne  {1 1 A0160 length A0159 exch sub  {pop  /A0160 A0158 A0160 A0150 def }for  }if  A0160  }bind %
 def  /A0161  {  /A0162 exch def  /A0163 exch def  A0163 () ne  {  /A0164 () def  /A0165 7 string def  /A0166 7 string def  %
 /A0167 7 string def  /A0168 7 string def  A0162 2 2 getinterval cvi 67 ge  {/A0169 19000000 def }  {/A0169 20000000 def %
 }ifelse  /A0169 A0169 A0162 2 2 getinterval cvi 10000 mul add def  A0162 0 1 getinterval (H) eq  {/A0170 A0169 101 add def %
 }if  A0162 0 1 getinterval (E) eq  {/A0170 A0169 601 add def }if  A0162 0 1 getinterval (A) eq  {/A0170 A0169 821 add def %
 }if  /A0171 false def  /A0172 1 def  {  /A0173 A0172 A0165 cvs A0163 A0150 def  A0570 A0173 known  {  A0570 A0173 get  dup %
 dup  /A0174 exch length def  /A0175 exch A0174 16 sub 8 getinterval cvi def  /A0176 exch A0174 8 sub 8 getinterval cvi %
 def  A0170 A0175 lt  {/A0164 A0173 def }if  A0170 A0176 gt A0171 not and  {/A0171 true def  /A0164 A0173 def }if  A0164 () %
 eq  {/A0164 A0173 def }if  A0170 A0175 ge  A0170 A0176 le and  {  /A0164 A0173 def  exit  }if  /A0172 A0172 1 add def  }  %
 {  exit  }ifelse  }loop  /A0177 7 string def  /A0163 A0164 def  /A0178 false def  /A0179 false def  A0163 A0284 () eq  %
 {/A0179 true def }if  A0163 length 0 gt  A0163 A0284 () ne and  A0331 -1 gt and  {  0 1 A0331  {/A0180 exch def A0466 %
 A0180 get  /A0181 exch def  A0181 A0163 eq  {  /A0178 true def exit  }  {  A0181 1 6 getinterval  A0163 1 6 getinterval %
 eq  {  A0181 0 1 getinterval  A0163 0 1 getinterval lt  {  A0466 A0180 A0163 put  /A0178 true def  }  {  /A0164 A0181 def  %
 /A0178 true def  }ifelse  }if  }ifelse  }for  }if  A0179  {/A0178 true def }if  A0178  }  {  /A0178 true def  A0178  %
 }ifelse  }bind def  /A0182  {  /A0158 exch def  /A0159 exch def  /A0160 exch def  A0160 () ne  {1 1 A0160 length A0159 %
 exch sub  {pop  /A0160 A0160 A0158 A0150 def }for  }if  A0160  }bind def  /A0183  {  A0316 1 eq  {/A0076 A0076 30 sub def %
 }if  /A0184 A0076 def  /A0185 () def  /A0186 () def  /A0187 () def  /A0187 A0494 ( \() A0150 def  /A0187 A0187 A0493 A0150 %
 def  /A0187 A0187 (\)) A0150 def  A0498  {  /A0188 A0187 def  /A0187 A0187 ( et ) A0150 def  /A0187 A0187 A0499 A0150 def  %
 /A0187 A0187 ( \() A0150 def  /A0187 A0187 A0497 A0150 def  /A0187 A0187 (\)) A0150 def  A0187 1000 1000 A0063 add 570 5 (V) %
 0 0 0.2 2 1 0 0 A0085  /A0189 currentpoint exch pop def  A0189 990 lt  {  /A0187 A0188 def  /A0187 A0187 (|et|) A0150 def  %
 /A0187 A0187 A0499 A0150 def  /A0187 A0187 ( \() A0150 def  /A0187 A0187 A0497 A0150 def  /A0187 A0187 (\)) A0150 def  %
 }if  }if  A0495 () ne  {/A0187 A0187 (|) A0150 def  /A0187 A0187 A0495 A0150 def }if  A0496 () ne  {/A0187 A0187 (|) A0150 %
 def  /A0187 A0187 A0496 A0150 def }if  0 1 A0187 length 1 sub  {  /A0190 exch def  A0187 A0190 1 getinterval (|) ne  %
 {/A0186  A0186 A0187 A0190 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0185 A0185 A0186 A0150 def  %
 /A0185 A0185 ( ) A0150 def  /A0192 A0076 def  A0186 A0077 A0076 A0063 add 570 5 (V) 0 0 0.2 2 1 0 0 A0085  /A0076 %
 currentpoint exch pop def  /A0076 A0076 10 sub def  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  /A0185 A0185 A0186 %
 A0150 def  currentpoint  /A0191 exch def pop  A0186 A0077 A0076 A0063 add 570 5 (V) 0 0 0.2 2 1 0 0 A0085  /A0076 %
 currentpoint exch pop def  A0343 (SESSIONNEL) eq  {7 }{14 }ifelse  /A0193 A0076 3 -1 roll sub def  A0077 A0076 moveto  %
 /A0194 A0184 A0076 sub 16 add def  }bind def  /A0195  {gsave  /A0077 A0578 def  A0316 1 eq  {/A0076 A0076 40 sub def }if  %
 /A0196 A0076 def  A0077 A0076 moveto  /Times-Bold-French findfont 10 scalefont setfont  14 A0146  1 setgray  A0183  /A0077 %
 A0578 def  A0077 A0076 A0194 add 7 sub moveto  A0077 A0076 A0194 add 7 sub 592 A0076 7 sub A0471 A0129  /Times-Bold-French %
 findfont 10 scalefont setfont  14 A0146  1 setgray  /A0076 A0196 def  A0077 A0076 moveto  A0183  grestore  /A0077 A0578 %
 def  /A0076 A0193 25 sub def  A0578 A0193 moveto  10 A0148  /A0197 false def  }bind def  /A0198  {  /A0077 A0581 def  %
 /A0076 A0582 def  A0077 A0076 moveto  (Code de l'établissement : )show  A0480 show  /A0076 A0076 30 sub def  A0077 A0076 %
 moveto  (N) show  7 A0148  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 3.5 add moveto  (o) show  A0077 3 %
 add A0076 moveto  10 A0148  ( de demande d'admission : ) show  A0489 show  /A0077 A0581 def  A0077  /A0076 A0076 15 sub %
 def A0076 moveto  (Code permanent : ) show  A0490 show  /A0199 false def  /A0077 A0581 def  A0077  /A0076 A0076 15 sub def %
 A0076 moveto  (Date de naissance : ) show  A0491 show  }bind def  /A0200  {  0.3 setlinewidth  A0580 5 sub A0579 2 add %
 moveto  -10 0 rlineto  0 -10 rlineto  stroke  A0580 5 sub A0579 67 sub moveto  -10 0 rlineto  0 10 rlineto  stroke  A0580 %
 272 add A0579 2 add moveto  10 0 rlineto  0 -10 rlineto  stroke  A0580 272 add A0579 67 sub moveto  10 0 rlineto  0 10 %
 rlineto  stroke  /A0077 A0580 def  /A0076 A0579 def  A0077 A0076 moveto  /A0077 A0580 def  A0077  /A0076 A0076 10 sub def %
 A0076 moveto  A0483 show  /A0077 A0580 def  A0077  /A0076 A0076 10 sub def A0076 moveto  A0484 show  /A0077 A0580 def  %
 A0077  /A0076 A0076 10 sub def A0076 moveto  A0485 show  /A0077 A0580 def  A0077  /A0076 A0076 10 sub def A0076 moveto  %
 A0486 show  /A0077 A0580 def  A0077  /A0076 A0076 10 sub def A0076 moveto  A0487 show  /A0077 A0580 def  A0077  /A0076 %
 A0076 10 sub def A0076 moveto  A0488 show  }bind def  /A0201  {  210 145 230 A0469 20 Psigle  A0578 A0577 50 sub 35 0 0 %
 Psigle  /A0076 750 def  A0481 0 eq  {  /A0077 A0578 sigle_existe  {43 }{0 }ifelse add def  A0077 A0076 moveto  A0474 show  %
 A0077  /A0076 A0076 10 sub def A0076 moveto  A0475 show  A0077  /A0076 A0076 10 sub def A0076 moveto  A0476 show  A0077  %
 /A0076 A0076 10 sub def A0076 moveto  A0477 show  A0077  /A0076 A0076 10 sub def A0076 moveto  A0478 show  A0077  /A0076 %
 A0076 10 sub def A0076 moveto  A0479 show  }  {/A0077 A0481 def  /A0076 A0482 def  A0077 A0076 moveto  A0474 show  A0077  %
 /A0076 A0076 10 sub def A0076 moveto  A0475 show  A0077  /A0076 A0076 10 sub def A0076 moveto  A0476 show  A0077  /A0076 %
 A0076 10 sub def A0076 moveto  A0477 show  A0077  /A0076 A0076 10 sub def A0076 moveto  A0478 show  A0077  /A0076 A0076 10 %
 sub def A0076 moveto  A0479 show  }ifelse  }bind def  /A0202  {gsave  /A0203 556 def  /A0204 A0577 16 add def  A0203 A0204 %
 moveto  8 A0148  A0149  grestore  /Times-Bold-French findfont 14 scalefont setfont  280 A0577 14 sub moveto  16 A0146   %
(BULLETIN D'ÉTUDES COLLÉGIALES) show  currentpoint  /A0204 exch def  /A0203 exch def  /A0203 A0203 5 add def  /A0204 A0204 %
 10 sub def  275 A0577 5 add moveto  275 A0577 5 add A0203 A0204 A0124  /A0205 A0577 5 add A0204 sub def  /A0206 A0203 275 %
 sub def  275 A0577 5 add moveto  -5 -5 rlineto  000 A0205 neg rlineto  5 5 rlineto  closepath  fill  stroke  275 A0577 5 %
 add A0205 sub moveto  -5 -5 rlineto  A0206 000 rlineto  5 5 rlineto  closepath  fill  stroke  10 A0148  %
 /Times-Roman-French findfont 10 scalefont setfont  }bind def  /A0207  {  currentpoint  /A0076 exch def  /A0077 exch def  %
 A0314 not  {/A0076 A0076 3 sub def  /A0135 A0076 def }if  A0077 A0076 moveto  A0218 not  {/A0208 A0076 60 sub def  /A0209 %
 false def A0422  A0077 A0076 A0077 460 add A0076 60 sub A0124  /A0133 A0076 60 sub def }if  A0221 (Objectif) eq  {  A0077 %
 A0076 A0077 460 add A0076 25 sub A0471 A0129  14 A0146  1 setgray  A0500 (AEC) eq  A0500 (Aec) eq or  A0500 (AEc) eq or  %
 A0500 (aec) eq or  A0500 (aEC) eq or  A0500 (aeC) eq or  A0500 (AeC) eq or  A0500 (aEc) eq or  { %
(Objectifs du programme d'études) }  {A0498 not  {(Objectifs du programme d'études par composantes de formation) }  { %
(Objectifs des programmes d'études par composantes de formation) }ifelse }ifelse  A0316 1 eq  {  A0077 10 add A0076 10 sub %
 A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  }  {  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085   %
(\(suite\)) currentpoint exch 1.5 add exch 20 add 55 5 (V) 0 0 0.2 0 1 0 0 A0085  }ifelse  0 setgray  }if  /A0210 false %
 def  A0221 (Autre objectif) eq  {  /A0211 true def  /A0212 true def  A0077 A0076 A0077 460 add A0076 25 sub A0471 A0129  %
 /A0212 false def  A0218  {480 A0076 592 A0076 35 sub A0470 A0129  /A0134 A0076 35 sub def }if  /Times-Bold-French findfont %
 14 scalefont setfont  A0411 not  {  A0436 A0588 gt  {(Autres objectifs atteints) }{(Autre objectif atteint) }ifelse  1 %
 setgray  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  /A0077 A0578 def  A0077 A0076 moveto  0 %
 setgray  0 -60 rlineto  572 0 rlineto  0 60 rlineto  currentpoint  /A0076 exch def pop  stroke  A0343 (OBJECTIF) eq  %
 {/A0077 A0077 460 add def  /A0213 0 def }{/A0077 A0077 380 add def  /A0213 80 def }ifelse  A0077 112 add A0213 add A0076 %
 moveto  1 setgray  -112 A0213 sub 0 rlineto  0 -35 rlineto  112 A0213 add 0 rlineto  closepath  fill  stroke  0 setgray  %
 A0077 A0076 moveto  A0343 (OBJECTIF) eq  { /A0210 true def  A0077 A0076 A0077 112 add A0076 60 sub A0124  A0077 A0076 %
 A0077 30 add A0076 60 sub A0124  A0077 A0076 A0077 59 add A0076 60 sub A0124  480 A0076 61 sub 592 A0076 75 sub A0470 %
 A0129  6 A0146  /A0077 A0077 15 add def  /A0076 A0076 50 sub def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 %
 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  %
 A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate   %
(établissement) show  -90 rotate  }  {A0077 A0076 A0077 192 add A0076 60 sub A0124  A0077 A0076 A0077 020 add A0076 60 sub %
 A0124  A0077 A0076 A0077 050 add A0076 60 sub A0124  A0077 A0076 A0077 080 add A0076 60 sub A0124  A0077 A0076 A0077 110 %
 add A0076 60 sub A0124  A0077 A0076 A0077 139 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 A0076 60 sub %
 put  6 A0146  /A0077 A0077 12 add def  /A0076 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  A0077 A0076 %
 moveto  90 rotate  (Note sur 100) show  -90 rotate  /A0077 A0077 21 add def  /A0076 A0215 10 add def  A0077 A0076 moveto  %
 90 rotate  (Moyenne) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (du groupe) show  -90 %
 rotate  /A0077 A0077 27 add def  A0077 A0076 moveto  90 rotate  (Unités) show  -90 rotate  /A0077 A0077 30 add def  A0077 %
 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) %
 show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add %
 def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }ifelse  10 A0146  /A0077 A0578 3 add def  A0077 %
 A0076 2 add moveto  A0077 A0076 -8 add moveto  /A0133 A0076 -10 add def  10 A0146  /A0077 A0578 3 add def  A0077 A0076 2 %
 add moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'objectif) show  A0077 67 add A0076 2 add moveto  (Énoncé de) %
 show  A0077 67 add A0076 -8 add moveto  (l'objectif) show  /A0216 currentpoint exch pop 15 sub def  currentpoint  /A0076 %
 exch def pop  10 A0148  }  {  A0436 A0588 gt  {(Autres objectifs atteints \(suite\)) }{(Autre objectif atteint \(suite\)) %
 }ifelse  1 setgray  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  }ifelse  1 setgray  0 setgray  %
 }if  A0221 (Epreuve) eq  {  /A0211 true def  /A0212 true def  A0077 A0076 A0077 460 add A0076 25 sub A0471 A0129  /A0212 %
 false def  A0218  {480 A0076 592 A0076 35 sub A0470 A0129  /A0134 A0076 35 sub def }if  /Times-Bold-French findfont 14 %
 scalefont setfont  A0344 not  {  A0432 A0586 2 add gt  {(Épreuves) }{(Épreuve) }ifelse  }  {  A0432 A0586 gt  { %
(Épreuves \(suite\)) }{(Épreuve \(suite\)) }ifelse  }ifelse  1 setgray  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 %
 0.2 0 1 0 0 A0085  0 setgray  }if  A0221 (Autre sanction) eq  {  /A0211 true def  /A0212 true def  A0077 A0076 moveto  %
 A0077 A0076 A0077 460 add A0076 25 sub A0471 A0129  /A0212 false def  A0218  {480 A0076 592 A0076 35 sub A0470 A0129  %
 /A0134 A0076 35 sub def }if  /Times-Bold-French findfont 14 scalefont setfont  A0353 not  {  A0434 A0587 gt  { %
(Autres sanctions obtenues) }{(Autre sanction obtenue) }ifelse  }  {  A0434 A0587 gt  {(Autres sanctions obtenues \(suite\)) %
 }{(Autre sanction obtenue \(suite\)) }ifelse  }ifelse  1 setgray  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 %
 1 0 0 A0085  0 setgray  }if  A0221 (Autre epreuve) eq  {  /A0211 true def  /A0212 true def  A0077 A0076 A0077 460 add %
 A0076 25 sub A0471 A0129  /A0212 false def  A0218  {480 A0076 592 A0076 35 sub A0470 A0129  /A0134 A0076 35 sub def }if  %
 /Times-Bold-French findfont 14 scalefont setfont  A0365 not  {  A0438 A0589 2 add gt  {(Autres épreuves) }{(Autre épreuve) %
 }ifelse  }  {  A0438 A0589 gt  {(Autres épreuves \(suite\)) }{(Autre épreuve \(suite\)) }ifelse  }ifelse  1 setgray  A0077 %
 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  0 setgray  }if  A0218 not  {  A0210 not  {  /A0077 A0077 %
 460 add def  A0077 A0076 moveto  A0077 A0076 A0077 112 add A0076 60 sub A0124  A0077 A0076 A0077 30 add A0076 60 sub %
 A0124  A0077 A0076 A0077 59 add A0076 60 sub A0124  480 A0076 61 sub 592 A0076 75 sub A0470 A0129  6 A0146  /A0077 A0077 %
 15 add def  /A0076 A0076 50 sub def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  %
 A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) %
 show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }if  A0221  %
(Objectif) eq  A0221 (Autre objectif) eq or  {  A0210 not  {  10 A0146  /A0077 A0578 3 add def  A0077 A0076 2 add moveto   %
(Code de ) show  A0077 A0076 -8 add moveto  (l'objectif) show  A0077 67 add A0076 2 add moveto  (Énoncé de) show  A0077 67 %
 add A0076 -8 add moveto  (l'objectif) show  /A0216 currentpoint exch pop 15 sub def  /A0217 currentpoint exch pop def  10 %
 A0148  }if  }if  A0221 (Epreuve) eq  A0221 (Autre epreuve) eq or  {  10 A0146  /A0077 A0578 3 add def  A0077 A0076 2 add %
 moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'épreuve) show  A0077 70 add A0076 2 add moveto  (Titre de) show  %
 A0077 70 add A0076 -8 add moveto  (l'épreuve) show  10 A0148  }if  A0221 (Autre sanction) eq  {  10 A0146  /A0077 A0578 3 %
 add def  A0077 A0076 -8 add moveto  (Description de la sanction) show  10 A0148  }if  A0221 (Cours sessionnel) ne  A0221  %
(Cours suivi) ne and  A0221 (Autre cours) ne and  {/A0218 true def }if  }if  /A0076 A0134 10 sub def  A0077 A0076 moveto  %
 10 A0148  /A0212 true def  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 10 add 592 A0076 8 sub A0245 sub 5 sub  A0470 %
 A0129  /A0212 false def  A0425 (Epreuve) eq  A0316 1 eq and  {/A0076 A0076 15 add def }if  A0221 (Autre sanction) eq  %
 A0316 1 ne and  {/A0076 A0076 5 sub def }if  A0221 (Autre epreuve) eq  A0316 1 eq and  {/A0076 A0076 10 add def }if  A0221  %
(Objectif) eq  {/A0076 A0076 5 sub def }if  A0221 (Autre objectif) eq  {A0316 1 ne A0344 not or  {/A0076 A0076 20 add def %
 }if }if  A0221 (Autre objectif) eq  {A0316 1 eq A0344 and  {/A0076 A0076 5 add def }if }if  A0221 (Objectif) eq  {A0316 1 %
 ne  {/A0076 A0076 10 sub def }if }if  }bind def  /A0219  {  currentpoint  /A0076 exch def  /A0077 exch def  gsave  1 %
 setgray  A0077 380 add A0076 1 sub moveto  800 0 rlineto  0 -60 rlineto  -800 0 rlineto  closepath  fill  0 setgray  %
 grestore gsave  A0343 (SESSIONNEL) eq  {A0221 (Rien) eq  A0317 or  {/A0076 A0076 10 sub def  A0077 A0076 moveto }if A0077 %
 A0076 moveto  }  {A0317  {/A0076 A0076 2 sub def  A0077 A0076 moveto }if  }ifelse  A0077 A0076 A0077 380 add A0076 60 sub %
 A0124  A0343 (OBJECTIF) eq  {  A0077 A0076 A0317  {.15 sub }if A0077 380 add A0076 25 sub A0471 A0129  /A0134 A0076 60 sub %
 def  15 A0146  1 setgray  /Times-Bold-French findfont 14 scalefont setfont  A0221 (Cours sessionnel) eq  {  A0336 not  {  %
 A0440  A0590 gt  {(Cours suivis) }{(Cours suivi) }ifelse  }  {  A0440  A0590 gt  {(Cours suivis \(suite\)) }{ %
(Cours suivi \(suite\)) }ifelse  }ifelse  }if  A0221 (Cours suivi) eq  {  A0338 not  {  A0442  A0590 gt  {A0498  { %
(Cours des programmes d'études) }  {(Cours du programme d'études) }ifelse  }  {A0498  {(Cours des programmes d'études) }  { %
(Cours du programme d'études) }ifelse  }ifelse  }  {  A0442  A0590 gt  {A0498  {(Cours des programmes d'études \(suite\)) %
 }  {(Cours du programme d'études \(suite\)) }ifelse  }  {A0498  {(Cours des programmes d'études \(suite\)) }  { %
(Cours du programme d'études \(suite\)) }ifelse  }ifelse  }ifelse  }if  A0221 (Autre cours) eq  {  A0340 not  {  A0444  %
 A0590 gt  {(Autres cours) }{(Autre cours) }ifelse  }  {  A0444  A0590 gt  {(Autres cours \(suite\)) }{ %
(Autre cours \(suite\)) }ifelse  }ifelse  }if  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  %
 /Times-Roman-French findfont 10 scalefont setfont  0 setgray  }if  /A0077 A0077 380 add def  A0077 A0076 moveto  A0077 %
 A0076 A0077 192 add A0076 60 sub A0124  A0077 A0076 A0077 020 add A0076 60 sub A0124  A0077 A0076 A0077 050 add A0076 60 %
 sub A0124  A0077 A0076 A0077 080 add A0076 60 sub A0124  A0077 A0076 A0077 110 add A0076 60 sub A0124  A0077 A0076 A0077 %
 139 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 A0076 60 sub put  6 A0146  /A0077 A0077 12 add def  /A0076 %
 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  A0077 A0076 moveto  90 rotate  (Note sur 100) show  -90 %
 rotate  /A0077 A0077 21 add def  /A0076 A0215 10 add def  A0077 A0076 moveto  90 rotate  (Moyenne) show  -90 rotate  %
 /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (du groupe) show  -90 rotate  /A0077 A0077 27 add def  A0077 A0076 %
 moveto  90 rotate  (Unités) show  -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 %
 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  %
 A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate   %
(établissement) show  -90 rotate  grestore  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 moveto  A0440 0 gt  %
 A0442 0 gt or  A0444 0 gt or  A0343 (SESSIONNEL) eq and  {gsave  A0221 (Rien) eq  A0317 or  {  /A0076 A0076 10 sub def  %
 A0077 A0076 moveto }if  A0077 A0076 A0077 A0343 (SESSIONNEL) eq  {379.5 }{460 }ifelse  add A0076 25 sub A0471 A0129  %
 /A0220 true def  1 setgray  A0077 8 add A0076 15 sub moveto  /Times-Bold-French findfont 14 scalefont setfont  A0221 (Rien) %
 eq  A0440 0 gt and  A0221 (Cours sessionnel) eq or  {  A0336 not  {  A0440 A0590 gt  {(Cours suivis) }  {(Cours suivi) %
 }ifelse  }  {  A0440 A0590 gt  {(Cours suivis \(suite\)) }  {(Cours suivi \(suite\)) }ifelse  }ifelse  /A0221  %
(Cours sessionnel) def  show  }if  A0221 (Rien) eq  A0442 0 gt and  A0221 (Cours suivi) eq or  {  A0338 not  {  A0442  %
 A0590 gt  {A0498  {(Cours des programmes d'études) }  {(Cours du programme d'études) }ifelse  }  {A0498  { %
(Cours des programmes d'études) }  {(Cours du programme d'études) }ifelse  }ifelse  }  {  A0442  A0590 gt  {A0498  { %
(Cours des programmes d'études \(suite\)) }  {(Cours du programme d'études \(suite\)) }ifelse  }  {A0498  { %
(Cours des programmes d'études \(suite\)) }  {(Cours du programme d'études \(suite\)) }ifelse  }ifelse  }ifelse  /A0221  %
(Cours suivi) def  show  }if  A0221 (Rien) eq  A0444 0 gt and  A0221 (Autre cours) eq or  {  A0340 not  {  A0444 A0590 gt  { %
(Autres cours) }  {(Autre cours) }ifelse  }  {  A0444 A0590 gt  {(Autres cours \(suite\)) }  {(Autre cours \(suite\)) %
 }ifelse  }ifelse  /A0221 (Autre cours) def  show  }if  /Times-Roman-French findfont 10 scalefont setfont  0 setgray  %
 grestore  }if  /A0076 A0076 25 sub def  /A0077 A0077 3 add def  A0077 A0076 moveto  /A0076 A0076 32 sub def  A0077 A0076 %
 moveto  10 A0146  A0440 0 gt  A0442 0 gt or  A0444 0 gt or  {(Code du cours) show }if  8 0 rmoveto  A0440 0 gt  A0442 0 gt %
 or  A0444 0 gt or  {(Titre du cours) show }  {  A0221 (Autre sanction) eq  {-8 -10 rmoveto  ( ) show  }if  A0221  %
(Autre epreuve) eq  {  /A0077 A0578 3 add def  A0077 A0076 2 add moveto  ( ) show  A0077 A0076 -8 add moveto  ( ) show  %
 A0077 70 add A0076 2 add moveto  ( ) show  A0077 70 add A0076 -8 add moveto  ( ) show  }if  }ifelse  10 A0148  /A0077 %
 A0578 def  A0343 (SESSIONNEL) eq  A0221 (Cours sessionnel) eq or  A0221 (Cours suivi) eq or  A0221 (Autre cours) eq or  %
 {400 }{480 }ifelse A0215 moveto  A0343 (SESSIONNEL) eq  A0221 (Cours sessionnel) eq or  A0221 (Cours suivi) eq or  A0221  %
(Autre cours) eq or  {400 }{480 }ifelse A0215 592 A0215 13 sub  A0470 A0129  /A0133 A0215 def  /A0076 A0215 10 sub def  %
 A0077 A0076 moveto  /A0197 true def  }bind def  /A0222  {  /A0211 true def  A0220 not  A0343 (SESSIONNEL) eq and  {/A0076 %
 A0076 60 add def }if  A0077 A0076 moveto  /A0212 true def  A0077 A0076 A0077 A0343 (SESSIONNEL) eq  {379.5 }{460 }ifelse  %
 add A0076 25 sub A0471 A0129  /A0212 false def  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 moveto  A0343 (SESSIONNEL) %
 eq  {  A0220  {A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 25 sub  A0470 A0129  }if  }  {  A0343 (SESSIONNEL) %
 eq  {400 }{480 }ifelse A0076 592 A0076 25 sub  A0470 A0129  }ifelse  /A0077 A0578 10 add def  /A0076 A0076 15 sub def  %
 A0077 A0076 moveto  1 setgray  /Times-Bold-French findfont 14 scalefont setfont  A0344 not  {A0432 8 gt  {(Épreuves) }{ %
(Épreuve) }ifelse show  /A0077 A0578 def  A0343 (OBJECTIF) eq  {/A0076 A0076 15 add def }{A0076 639 gt  {/A0076 A0076 15.4 %
 add def }{/A0076 A0076 15 add def }ifelse }ifelse  A0077 A0076 moveto  0 setgray  0 -60 rlineto  572 0 rlineto  0 60 %
 rlineto  currentpoint  /A0076 exch def pop  stroke  A0343 (OBJECTIF) eq  {/A0077 A0077 460 add def  /A0213 0 def }{/A0077 %
 A0077 380 add def  /A0213 80 def }ifelse  A0077 112 add A0213 add A0076 moveto  1 setgray  -112 A0213 sub 0 rlineto  0 -26 %
 rlineto  112 A0213 add 0 rlineto  closepath  fill  stroke  0 setgray  A0077 A0076 moveto  A0343 (OBJECTIF) eq  {A0077 %
 A0076 A0077 112 add A0076 60 sub A0124  A0077 A0076 A0077 30 add A0076 60 sub A0124  A0077 A0076 A0077 59 add A0076 60 sub %
 A0124  480 A0076 61 sub 592 A0076 75 sub A0470 A0129  6 A0146  /A0077 A0077 15 add def  /A0076 A0076 50 sub def  A0077 %
 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) %
 show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add %
 def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }  {A0077 A0076 A0077 192 add A0076 60 sub A0124  %
 A0077 A0076 A0077 020 add A0076 60 sub A0124  A0077 A0076 A0077 050 add A0076 60 sub A0124  A0077 A0076 A0077 080 add %
 A0076 60 sub A0124  A0077 A0076 A0077 110 add A0076 60 sub A0124  A0077 A0076 A0077 139 add A0076 60 sub A0124  /A0214 %
 A0214 1 add def  A0451 A0214 A0076 60 sub put  6 A0146  /A0077 A0077 12 add def  /A0076 A0076 60 sub def  /A0215 A0076 %
 def  /A0076 A0076 10 add def  A0077 A0076 moveto  90 rotate  (Note sur 100) show  -90 rotate  /A0077 A0077 21 add def  %
 /A0076 A0215 10 add def  A0077 A0076 moveto  90 rotate  (Moyenne) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 %
 moveto  90 rotate  (du groupe) show  -90 rotate  /A0077 A0077 27 add def  A0077 A0076 moveto  90 rotate  (Unités) show  %
 -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  %
 A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) %
 show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }ifelse  10 %
 A0146  /A0077 A0578 3 add def  A0077 A0076 2 add moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'épreuve) show  %
 A0077 70 add A0076 2 add moveto  (Titre de) show  A0077 70 add A0076 -8 add moveto  (l'épreuve) show  10 A0148  }  {A0432 %
 8 gt  {(Épreuves \(suite\)) }{(Épreuve \(suite\)) }ifelse show  0 setgray  10 A0146  /A0077 A0578 3 add def  /A0076 A0076 %
 35 sub def  A0077 A0076 moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'épreuve) show  A0077 70 add A0076 2 add %
 moveto  (Titre de) show  A0077 70 add A0076 -8 add moveto  (l'épreuve) show  10 A0148  }ifelse  /Times-Roman-French %
 findfont 10 scalefont setfont  0 setgray  /A0220 true def  /A0077 A0578 def  A0343 (OBJECTIF) eq  {/A0076 A0076 15 sub def %
 }{/A0076 A0076 22 sub def }ifelse  A0077 A0076 moveto  /A0197 true def  }bind def  /A0223  {  /A0076 A0076 11 add def  %
 A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 moveto  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 30 sub %
 A0470 A0129  /A0133 A0076 20 sub def  /A0076 A0076 25 sub def  A0077 A0076 moveto  0 setgray  /Times-BoldItalic-French %
 findfont 10 scalefont setfont  A0224 -1 eq  A0225 -1 eq and  {  /A0224 0 def  /A0225 0 def  0 1 A0432  {/A0226 exch def  %
 A0431 A0226 get dup  (Épreuve uniforme) eq  {/A0224 1 def  /A0225 0 def }if  (Épreuve synthèse) eq  {/A0224 0 def  /A0225 %
 1 def }if  A0431 A0226 get (==EPREUVE) eq  {  A0224 1 eq  {/A0227  A0227 1 add def }if  A0225 1 eq  {/A0228  A0228 1 add %
 def }if  }if  }for  }if  A0229 (synthèse) search  {pop pop pop  A0228 1 eq  {/A0229 (Épreuve synthèse) def }  {/A0229  %
(Épreuves synthèses) def }ifelse  }  {pop }ifelse  A0229 (uniforme) search  {pop pop pop  A0227 1 eq  {/A0229  %
(Épreuve uniforme) def }  {/A0229 (Épreuves uniformes) def }ifelse  }  {pop }ifelse  A0229 show  /Times-Roman-French %
 findfont 10 scalefont setfont  0 setgray  /A0077 A0578 def  /A0076 A0076 14 sub def  A0077 A0076 moveto  /A0230 true def  %
 }bind def  /A0231  {  /A0211 true def  A0343 (SESSIONNEL) eq  A0220 not and  {/A0076 A0076 60 add def }{/A0076 A0076 0.5 %
 sub def }ifelse  A0077 A0076 moveto  /A0212 true def  A0077 A0076 A0077 A0343 (SESSIONNEL) eq  {379.5 }{460 }ifelse  add %
 A0076 25 sub A0471 A0129  /A0212 false def  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 moveto  A0343 (SESSIONNEL) eq  %
 {  A0220  {A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 1 add 592 A0076 24 sub  A0470 A0129  }if  }  {  A0343  %
(SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 24 sub  A0470 A0129  }ifelse  /A0077 A0578 10 add def  /A0076 A0076 15 %
 sub def  A0077 A0076 moveto  1 setgray  /Times-Bold-French findfont 14 scalefont setfont  A0353 not  {A0434 8 gt  { %
(Autres sanctions obtenues) }{(Autre sanction obtenue) }ifelse show  /A0077 A0578 def  /A0076 A0076 15.5 add def  A0077 %
 A0076 moveto  0 setgray  0 -60 rlineto  572 0 rlineto  0 60 rlineto  currentpoint  /A0076 exch def pop  stroke  A0343  %
(OBJECTIF) eq  {/A0077 A0077 460 add def  /A0213 0 def }{/A0077 A0077 380 add def  /A0213 80 def }ifelse  A0077 112 add %
 A0213 add A0076 moveto  1 setgray  -112 A0213 sub 0 rlineto  0 -25 rlineto  112 A0213 add 0 rlineto  closepath  fill  %
 stroke  0 setgray  A0077 A0076 moveto  A0343 (OBJECTIF) eq  {A0077 A0076 A0077 112 add A0076 60 sub A0124  A0077 A0076 %
 A0077 30 add A0076 60 sub A0124  A0077 A0076 A0077 59 add A0076 60 sub A0124  480 A0076 61 sub 592 A0076 75 sub A0470 %
 A0129  6 A0146  /A0077 A0077 15 add def  /A0076 A0076 50 sub def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 %
 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  %
 A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate   %
(établissement) show  -90 rotate  }  {A0077 A0076 A0077 192 add A0076 60 sub A0124  A0077 A0076 A0077 020 add A0076 60 sub %
 A0124  A0077 A0076 A0077 050 add A0076 60 sub A0124  A0077 A0076 A0077 080 add A0076 60 sub A0124  A0077 A0076 A0077 110 %
 add A0076 60 sub A0124  A0077 A0076 A0077 139 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 A0076 60 sub %
 put  6 A0146  /A0077 A0077 12 add def  /A0076 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  A0077 A0076 %
 moveto  90 rotate  (Note sur 100) show  -90 rotate  /A0077 A0077 21 add def  /A0076 A0215 10 add def  A0077 A0076 moveto  %
 90 rotate  (Moyenne) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (du groupe) show  -90 %
 rotate  /A0077 A0077 27 add def  A0077 A0076 moveto  90 rotate  (Unités) show  -90 rotate  /A0077 A0077 30 add def  A0077 %
 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) %
 show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add %
 def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }ifelse  10 A0146  /A0077 A0578 3 add def  A0077 %
 A0076 2 add moveto  A0077 A0076 -8 add moveto  /A0133 A0076 -10 add def  (Description de la sanction) show  currentpoint  %
 /A0076 exch def pop  /A0076 A0076 15 sub def  10 A0148  }  {A0434 8 gt  {(Autres sanctions obtenues \(suite\)) }  { %
(Autre sanction obtenue \(suite\)) }ifelse show  0 setgray  10 A0146  /A0077 A0578 3 add def  /A0076 A0076 35 sub def  %
 A0077 A0076 moveto  A0077 A0076 -8 add moveto  (Description de la sanction) show  currentpoint  /A0076 exch def pop  %
 /A0076 A0076 15 sub def  10 A0148  }ifelse  /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0220 true def  %
 /A0077 A0578 def  A0077 A0076 moveto  /A0197 true def  }bind def  /A0232  {  /A0211 true def  A0343 (SESSIONNEL) eq  A0220 %
 not and  {/A0076 A0076 60 add def }if  A0077 A0076 moveto  A0367  {/A0076 A0076 10 add def  /A0212 true def }if  A0367 %
 not  {400 A0076 592 A0076 25 sub A0470 A0136 }if  A0077 A0076 A0077 A0343 (SESSIONNEL) eq  {379.5 }{460 }ifelse  add A0076 %
 25 sub A0471 A0129  A0367  {/A0076 A0076 10 sub def  /A0212 false def }if  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse  %
 A0076 moveto  A0343 (SESSIONNEL) eq  {  A0220  {A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 25 sub  A0470 %
 A0129  }if  }  {  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 25 sub  A0470 A0129  }ifelse  /A0077 A0578 10 %
 add def  A0367  {/A0076 A0076 5 sub def }{/A0076 A0076 15 sub def }ifelse  A0077 A0076 moveto  1 setgray  %
 /Times-Bold-French findfont 14 scalefont setfont  A0365 not  {A0438 8 gt  {(Autres épreuves) }{(Autre épreuve) }ifelse %
 show  /A0077 A0578 def  /A0076 A0076 15 add def  A0077 A0076 moveto  0 setgray  0 -60 rlineto  572 0 rlineto  0 60 %
 rlineto  currentpoint  /A0076 exch def pop  stroke  A0343 (OBJECTIF) eq  {/A0077 A0077 460 add def  /A0213 0 def }{/A0077 %
 A0077 380 add def  /A0213 80 def }ifelse  A0077 112 add A0213 add A0076 moveto  1 setgray  -112 A0213 sub 0 rlineto  0 -25 %
 rlineto  112 A0213 add 0 rlineto  closepath  fill  stroke  0 setgray  A0077 A0076 moveto  A0343 (OBJECTIF) eq  {A0077 %
 A0076 A0077 112 add A0076 60 sub A0124  A0077 A0076 A0077 30 add A0076 60 sub A0124  A0077 A0076 A0077 59 add A0076 60 sub %
 A0124  480 A0076 61 sub 592 A0076 75 sub A0470 A0129  6 A0146  /A0077 A0077 15 add def  /A0076 A0076 50 sub def  A0077 %
 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Trimestre) %
 show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add %
 def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }  {A0077 A0076 A0077 192 add A0076 60 sub A0124  %
 A0077 A0076 A0077 020 add A0076 60 sub A0124  A0077 A0076 A0077 050 add A0076 60 sub A0124  A0077 A0076 A0077 080 add %
 A0076 60 sub A0124  A0077 A0076 A0077 110 add A0076 60 sub A0124  A0077 A0076 A0077 139 add A0076 60 sub A0124  /A0214 %
 A0214 1 add def  A0451 A0214 A0076 60 sub put  6 A0146  /A0077 A0077 12 add def  /A0076 A0076 60 sub def  /A0215 A0076 %
 def  /A0076 A0076 10 add def  A0077 A0076 moveto  90 rotate  (Note sur 100) show  -90 rotate  /A0077 A0077 21 add def  %
 /A0076 A0215 10 add def  A0077 A0076 moveto  90 rotate  (Moyenne) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 %
 moveto  90 rotate  (du groupe) show  -90 rotate  /A0077 A0077 27 add def  A0077 A0076 moveto  90 rotate  (Unités) show  %
 -90 rotate  /A0077 A0077 30 add def  A0077 A0076 moveto  90 rotate  (Remarque) show  -90 rotate  /A0077 A0077 30 add def  %
 A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) %
 show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  }ifelse  10 %
 A0146  /A0077 A0578 3 add def  A0077 A0076 2 add moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'épreuve) show  %
 A0077 70 add A0076 2 add moveto  (Titre de) show  A0077 70 add A0076 -8 add moveto  (l'épreuve) show  10 A0148  %
 currentpoint  /A0076 exch def pop  /A0076 A0076 10 sub def  }  {A0438 8 gt  {(Autres épreuves \(suite\)) }{ %
(Autre épreuve \(suite\)) }ifelse show  0 setgray  10 A0146  /A0077 A0578 3 add def  /A0076 A0076 35 sub def  A0077 A0076 %
 moveto  (Code de ) show  A0077 A0076 -8 add moveto  (l'épreuve) show  A0077 70 add A0076 2 add moveto  (Titre de) show  %
 A0077 70 add A0076 -8 add moveto  (l'épreuve) show  10 A0148  currentpoint  /A0076 exch def pop  /A0076 A0076 10 sub def  %
 }ifelse  /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0220 true def  /A0077 A0578 def  A0343 (OBJECTIF) %
 ne  {/A0076 A0076 4 sub def }if  A0077 A0076 moveto  /A0197 true def  }bind def  /A0233  {  /A0076 A0076 11 add def  A0343  %
(SESSIONNEL) eq  {400 }{480 }ifelse A0076 moveto  A0343 (SESSIONNEL) eq  {400 }{480 }ifelse A0076 592 A0076 30 sub A0470 %
 A0129  /A0133 A0076 20 sub def  /A0076 A0076 25 sub def  A0077 A0076 moveto  0 setgray  /Times-BoldItalic-French findfont %
 10 scalefont setfont  /A0234 0 def  /A0235 0 def  /A0236 false def  /A0237 false def  0 1 A0438  {/A0226 exch def  A0437 %
 A0226 get  (==TITRE AUTRE EPREUVE) eq  {  A0437 A0226 1 add get  (Épreuve) search  {pop pop pop  A0437 A0226 1 add get   %
(synthèse) search  {pop pop pop  /A0236 true def  /A0237 false def  }  {pop }ifelse  }  {pop }ifelse  A0437 A0226 1 add %
 get  (Épreuve) search  {pop pop pop  A0437 A0226 1 add get  (uniforme) search  {pop pop pop  /A0236 false def  /A0237 true %
 def  }  {pop }ifelse  }  {pop }ifelse  }if  A0437 A0226 get  (==AUTRE EPREUVE) eq A0236 and  {/A0234  A0234 1 add def }if  %
 A0437 A0226 get  (==AUTRE EPREUVE) eq A0237 and  {/A0235  A0235 1 add def }if  }for  A0238 (synthèse) search  {pop pop %
 pop  A0234 1 eq  {/A0238 (Épreuve synthèse) def }  {/A0238 (Épreuves synthèses) def }ifelse  }  {pop }ifelse  A0238  %
(uniforme) search  {pop pop pop  A0235 1 eq  {/A0238 (Épreuve uniforme) def }  {/A0238 (Épreuves uniformes) def }ifelse  }  %
 {pop }ifelse  A0238 show  /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0077 A0578 def  /A0076 A0076 %
 14.5 sub def  A0077 A0076 moveto  /A0230 true def  }bind def  /A0239  {  /A0240 false def  currentpoint exch pop 700 gt  %
 {20 A0134 10 sub moveto  /A0240 true def }if  currentpoint  /A0076 exch def  /A0077 exch def  A0374 A0240 not and  {/A0076 %
 A0076 10 sub def }if  gsave  1 setgray  A0077 380 add A0076 1 sub moveto  800 0 rlineto  0 -60 rlineto  -800 0 rlineto  %
 closepath  fill  0 setgray  grestore gsave  A0077 A0076 moveto  A0077 A0076 A0077 380 add A0076 60 sub A0124  A0077 A0076 %
 A0077 380 add A0076 25 sub A0471 A0129  /A0134 A0076 60 sub def  15 A0146  1 setgray  /Times-Bold-French findfont 14 %
 scalefont setfont  A0379 not  {  A0448  A0593 gt  {(Niveaux de maîtrise en langue seconde) }  { %
(Niveau de maîtrise en langue seconde) }ifelse  }  {  A0448  A0593 gt  {(Niveaux de maîtrise en langue seconde \(suite\)) %
 }  {(Niveau de maîtrise en langue seconde \(suite\)) }ifelse  }ifelse  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 %
 0.2 0 1 0 0 A0085  /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0077 A0077 380 add def  A0077 A0076 %
 moveto  A0077 A0076 A0077 192 add A0076 60 sub A0124  A0077 A0076 A0077 110 add A0076 60 sub A0124  A0077 A0076 A0077 139 %
 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 A0076 60 sub put  6 A0146  /A0077 A0077 10.5 add def  /A0076 %
 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  /A0077 A0077 15 add def  A0077 A0076 moveto  90 rotate   %
(Niveau) show  -90 rotate  /A0077 A0077 18 add def  A0077 A0076 moveto  90 rotate  (Élémentaire) show  -90 rotate  /A0077 %
 A0077 9 add def  A0077 A0076 moveto  90 rotate  (\(1 à 4\)) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  %
 90 rotate  (Intermédiaire) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (\(5 à 8\)) show  -90 %
 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (Avancé) show  -90 rotate  /A0077 A0077 9 add def  A0077 %
 A0076 moveto  90 rotate  (\(9 à 12\)) show  -90 rotate  /A0077 A0077 38 add def  A0077 A0076 moveto  90 rotate  (Trimestre) %
 show  -90 rotate  /A0077 A0077 35 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add %
 def  A0077 A0076 moveto  90 rotate  (établissement) show  -90 rotate  grestore  currentpoint  /A0076 exch def  /A0077 exch %
 def  /A0076 A0076 40 sub def  /A0077 A0077 3 add def  30 A0076 moveto  10 A0148   %
(L'évaluation des niveaux de maîtrise en langue seconde est en cours d'expérimentation) show  /A0076 A0076 18 sub def  %
 A0077 A0076 moveto  10 A0146  (Habileté) show  10 A0148  /A0077 A0578 def  A0077 380 add A0215 moveto  A0077 380 add A0215 %
 592 A0215 13 sub A0470 A0129  /A0133 A0215 def  /A0076 A0215 10 sub def  A0077 A0076 moveto  /A0197 true def  }bind def  %
 /A0241  {  /A0240 false def  currentpoint exch pop 700 gt  {20 A0134 10 sub moveto  /A0240 true def }if  currentpoint  %
 /A0076 exch def  /A0077 exch def  A0374 A0240 not and  {/A0076 A0076 10 sub def }if  gsave  1 setgray  A0077 380 add A0076 %
 1 sub moveto  800 0 rlineto  0 -60 rlineto  -800 0 rlineto  closepath  fill  0 setgray  grestore gsave  A0077 A0076 %
 moveto  A0077 A0076 A0077 462.5 add A0076 60 sub A0124  A0077 A0076 A0077 462.5 add A0076 25 sub A0471 A0129  /A0134 A0076 %
 60 sub def  15 A0146  1 setgray  /Times-Bold-French findfont 14 scalefont setfont  A0386 not  {  A0446  A0591 gt  { %
(Stages réalisés en alternance travail-études) }  {(Stage réalisé en alternance travail-études) }ifelse  }  {  A0446  A0591 %
 gt  {(Stages réalisés en alternance travail-études \(suite\)) }  {(Stage réalisé en alternance travail-études \(suite\)) %
 }ifelse  }ifelse  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  /Times-Roman-French findfont 10 %
 scalefont setfont  0 setgray  /A0077 482.5 def  A0077 A0076 moveto  A0077 A0076 A0077 109.5 add A0076 60 sub A0124  A0077 %
 A0076 A0077 27.5 add A0076 60 sub A0124  A0077 A0076 A0077 55 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 %
 A0076 60 sub put  6 A0146  /A0077 A0077 10.5 add def  /A0076 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  %
 A0077 A0076 moveto  90 rotate  (Nombre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate  (d'heures) %
 show  -90 rotate  /A0077 A0077 23.5 add def  A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 38 %
 add def  A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate   %
(établissement) show  -90 rotate  grestore  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 moveto  /A0076 %
 A0076 25 sub def  /A0077 A0077 3 add def  A0077 A0076 moveto  /A0076 A0076 32 sub def  A0077 A0076 moveto  10 A0146   %
(Code du stage) show  10 0 rmoveto  (Titre du stage) show  10 A0148  /A0077 A0578 def  482.5 A0215 moveto  482.5 A0215 592 %
 A0215 13 sub A0470 A0129  /A0133 A0215 def  /A0076 A0215 10 sub def  A0077 A0076 moveto  /A0197 true def  }bind def  %
 /A0242  {  /A0240 false def  currentpoint exch pop 700 gt  {20 A0134 10 sub moveto  /A0240 true def }if  currentpoint  %
 /A0076 exch def  /A0077 exch def  A0374 A0240 not and  {/A0076 A0076 10 sub def }if  gsave  1 setgray  A0077 380 add A0076 %
 1 sub moveto  800 0 rlineto  0 -60 rlineto  -800 0 rlineto  closepath  fill  0 setgray  grestore gsave  A0077 A0076 %
 moveto  A0077 A0076 A0077 490.5 add A0076 60 sub A0124  A0077 A0076 A0077 490.5 add A0076 25 sub A0471 A0129  /A0134 A0076 %
 60 sub def  15 A0146  1 setgray  /Times-Bold-French findfont 14 scalefont setfont  A0391 not  {  A0450  A0592 gt  { %
(Engagements étudiants) }  {(Engagement étudiant) }ifelse  }  {  A0450  A0592 gt  {(Engagements étudiants \(suite\)) }  { %
(Engagement étudiant \(suite\)) }ifelse  }ifelse  A0077 10 add A0076 10 sub A0063 add 460 5 (V) 0 0 0.2 0 1 0 0 A0085  %
 /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0077 510.5 def  A0077 A0076 moveto  A0077 A0076 A0077 81.5 %
 add A0076 60 sub A0124  A0077 A0076 A0077 27.5 add A0076 60 sub A0124  /A0214 A0214 1 add def  A0451 A0214 A0076 60 sub %
 put  6 A0146  /A0077 A0077 10.5 add def  /A0076 A0076 60 sub def  /A0215 A0076 def  /A0076 A0076 10 add def  A0077 A0076 %
 moveto  /A0077 A0077 4.5 add def  A0077 A0076 moveto  90 rotate  (Trimestre) show  -90 rotate  /A0077 A0077 38 add def  %
 A0077 A0076 moveto  90 rotate  (Autre) show  -90 rotate  /A0077 A0077 9 add def  A0077 A0076 moveto  90 rotate   %
(établissement) show  -90 rotate  grestore  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 moveto  /A0076 %
 A0076 25 sub def  /A0077 A0077 3 add def  A0077 A0076 moveto  /A0076 A0076 32 sub def  A0077 A0076 moveto  10 A0146   %
(Domaine de l'engagement) show  10 A0148  /A0077 A0578 def  510.5 A0215 moveto  510.5 A0215 592 A0215 13 sub A0470 A0129  %
 /A0133 A0215 def  /A0076 A0215 10 sub def  A0077 A0076 moveto  /A0197 true def  }bind def  /A0243  {  /A0244 (PRINCIPALE) %
 def  /A0134 A0134 10 add def  A0316 1 ne  {/A0076 A0076 15 add def }  {/A0076 A0208 def }ifelse  /A0211 true def  480 %
 A0076 3 add moveto  /A0077 A0578 def  A0399 (NE PAS AFFICHER) eq not  {A0343 (SESSIONNEL) eq  {/A0076 A0076 20 sub def }  %
 {A0199 not  {/A0076 A0076 20 sub def }{/A0076 A0076 30 sub def }ifelse  }ifelse }  {/A0076 A0076 5 sub def }ifelse  A0077 %
 A0076 moveto  A0399 (NE PAS AFFICHER) eq not  {  /Times-Bold-French findfont 14 scalefont setfont  /A0245 A0076 def  A0399 %
 A0077 A0076 A0063 add 460 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0245 A0245 A0076 sub def  %
 /Times-Roman-French findfont 10 scalefont setfont }if  0 setgray  /A0077 A0578 def  /A0076 A0076 5 sub def  A0077 A0076 %
 moveto  /A0199 true def  /A0197 true def  }bind def  /A0246  {  /A0244 (SECONDAIRE) def  /A0076 A0076 11 add def  480 %
 A0076 moveto  480 A0076 592 A0076 30 sub A0470 A0129  /A0133 A0076 20 sub def  /A0076 A0076 20 sub def  A0077 A0076 %
 moveto  0 setgray  /Times-BoldItalic-French findfont 10 scalefont setfont  A0401  show  currentpoint  /A0247 exch def pop  %
 /Times-Roman-French findfont 10 scalefont setfont  0 setgray  /A0077 A0578 def  /A0076 A0076 15 sub def  A0077 A0076 %
 moveto  /A0230 true def  /A0197 true def  }bind def  /A0248  {gsave  translate  setgray  10 10 scale  87 99 false [87 0 0 %
 99 0 0]  {lys }imagemask  grestore  }bind def  /A0249  {gsave  10 A0148  1 setgray  400 A0076 .5 sub moveto  400 0 %
 rlineto  0 -1000 rlineto  -400 0 rlineto  closepath  fill  0 setgray  /A0250 A0578 def  /A0251 A0076 12 sub def  /A0252 %
 A0250 def  /A0253 A0251 def  1 1 12  {pop  0 A0250 A0251 A0248  /A0250 A0250 20.83 add def  }for  A0250 1.5 sub A0251 %
 moveto  /A0254 A0250 1.5 sub def  /A0255 A0251 def  (FIN DU RELEVÉ) show  currentpoint  pop  /A0250 exch 10.33 add def  %
 A0250 A0251 moveto  /A0256 A0250 def  /A0257 A0251 def  1 1 12  {pop  0 A0250 A0251 A0248  /A0250 A0250 20.83 add def  %
 }for  grestore  }bind def  /A0258  {gsave  10 A0148  1 setgray  400 A0076 .5 sub moveto  400 0 rlineto  0 -1000 rlineto  %
 -400 0 rlineto  closepath  fill  0 setgray  /A0250 A0578 def  /A0251 A0076 12 sub def  1 1 10  {pop  0 A0250 A0251 A0248  %
 /A0250 A0250 21.4 add def  }for  A0250 1.5 sub A0251 moveto  /A0254 A0250 1.5 sub def  /A0255 A0251 def  A0254 A0255 %
 moveto  ( SUITE À LA PAGE SUIVANTE ) show  currentpoint  pop  /A0250 exch 10.33 add def  A0250 A0251 moveto  1 1 10  {pop  %
 0 A0250 A0251 A0248  /A0250 A0250 21.4 add def  }for  grestore  }bind def  /A0259  {  /A0073 exch def  gsave  %
 currentpoint  /A0074 exch def  /A0075 exch def  /A0074 A0074 2 sub def  A0073 show  currentpoint  /A0076 exch def  /A0077 %
 exch def  /A0076 A0076 2 sub def  /A0077 A0077 2 sub def  /A0077 A0077 2 add def  A0075 A0074 moveto  A0077 A0076 lineto  %
 stroke  grestore  currentpoint  /A0076 exch def  /A0077 exch def  A0077 A0076 moveto  }bind def  /A0260  {  9 A0148  %
 /A0261  (Date de délivrance : )  A0506 A0150 def  A0261 320 26 270 0 (V) 0 0 0.2 1 1 0 0 A0085  10 A0148  }bind def  %
 /A0262  {  /A0263 exch def  /A0077 A0578 def  /A0076 A0263 def  A0077 A0076 moveto  A0077 A0076 A0077 572 add A0076 90 sub %
 A0124  A0077 A0076 A0077 296 add A0076 90 sub A0124  /A0212 true def  A0077 A0076 A0077 50 add A0076 17 sub A0471 A0129  %
 /A0212 false def  /A0077 A0077 3 add def  /A0076 A0076 12 sub def  A0077 A0076 moveto  1 setgray  (Légende) show  0 %
 setgray  9 A0148  /A0077 A0077 51 add def  /A0076 A0076 3 sub def  A0077 A0076 moveto  /A0264 A0077 def  %
 /Times-Bold-French findfont 9 scalefont setfont  (Unité : ) show  /Times-Roman-French findfont 9 scalefont setfont   %
(mesure équivalant à 45 heures d'activités d'apprentissage) show  currentpoint  /A0265 exch def  11 add  /A0266 exch def  %
 /A0076 A0076 12 sub def  A0077 A0076 moveto  /Times-Bold-French findfont 9 scalefont setfont  (Trimestre : ) show  %
 /Times-Roman-French findfont 9 scalefont setfont  (A = Automne H = Hiver E = Été) show  /A0076 A0076 12 sub def  /A0077 %
 A0077 50 sub def  A0077 A0076 2 add moveto  A0343 (SESSIONNEL) eq  {  /A0267 28 def  /A0268 43 def  /A0269 98.5 def  %
 /A0270 113.5 def  /A0271 209 def  /A0272 224 def  }  /A0267 28 def  /A0268 43 def  /A0269 101 def  /A0270 116 def  /A0271 %
 214 def  /A0272 229 def  {  }ifelse  gsave  /A0215 A0076 def  A0077 A0215 moveto  A0343 (SESSIONNEL) eq  {  000 -43 %
 rlineto  A0271 104.5 add A0215 43 sub lineto  000 47 rlineto  -244 000 rlineto  }  {  A0077 45 add A0215 4 add moveto  244 %
 000 rlineto  }ifelse  A0271 3 sub A0215 moveto  stroke  grestore  /Times-Bold-French findfont 9 scalefont setfont   %
(Remarques ) show  currentpoint  /A0273 exch def  pop  A0273 10 sub  /A0274 exch def  /A0275 A0274 10 sub def  /A0276 A0275 %
 10 sub def  /A0277 A0276 10 sub def  /A0278 A0277 10 sub def  /Times-Bold-French findfont 9 scalefont setfont  A0343  %
(SESSIONNEL) eq  {  A0267 A0274 moveto  (AB) show  A0267 A0275 moveto  (DI) show  A0267 A0276 moveto  (EA) show  A0269 %
 A0274 moveto  (EC) show  A0269 A0275 moveto  (EQ) show  A0269 A0276 moveto  (EX) show  A0269 A0277 moveto  (IN) show  %
 A0271 A0274 moveto  (IT) show  A0271 A0275 moveto  (RE) show  A0271 A0276 moveto  (SU) show  }  {  A0267 A0274 moveto  (AB) %
 show  A0267 A0275 moveto  (DI) show  A0267 A0276 moveto  (EA) show  A0267 A0278 moveto  (EC) show  A0269 A0274 moveto  (EQ) %
 show  A0269 A0275 moveto  (EX) show  A0269 A0276 moveto  (IN) show  A0269 A0277 moveto  (IT) show  A0269 A0278 moveto  (OA) %
 show  A0271 A0274 moveto  (OT) show  A0271 A0276 moveto  (RE) show  A0271 A0277 moveto  (SU) show  }ifelse  %
 /Times-Roman-French findfont 9 scalefont setfont  A0343 (SESSIONNEL) eq  {  A0268 A0274 moveto  (= Abandon) show  A0268 %
 A0275 moveto  (= Dispense) show  A0268 A0276 moveto  (= Échec par) show  A0268 7.7 add A0277 moveto  (abandon) show  A0270 %
 A0274 moveto  (= Échec) show  A0270 A0275 moveto  (= Équivalence) show  A0270 A0276 moveto  (= Exemption) show  A0270 %
 A0277 moveto  (= Incomplet) show  A0272 A0274 moveto  (= Incomplet temporaire) show  A0272 A0275 moveto   %
(= Réussite) show  A0272 A0276 moveto  (= Substitution) show  }  {  A0268 A0274 moveto  (= Abandon) show  A0268 A0275 %
 moveto  (= Dispense) show  A0268 A0276 moveto  (= Échec par) show  A0268 7.7 add A0277 moveto  (abandon) show  A0268 A0278 %
 moveto  (= Échec) show  A0270 A0274 moveto  (= Équivalence) show  A0270 A0275 moveto  (= Exemption) show  A0270 A0276 %
 moveto  (= Incomplet) show  A0270 A0277 moveto  (= Incomplet temporaire) show  A0270 A0278 moveto   %
(= Objectif atteint) show  A0272 A0274 moveto  (= Objectif technique-) show  A0272 7.7 add A0275 moveto  (ment atteint) %
 show  A0272 A0276 moveto  (= Réussite) show  A0272 A0277 moveto  (= Substitution) show  }ifelse  A0266 A0265 moveto  A0331 %
 0 gt  {  (Autres établissements que celui qui délivre le bulletin)  }  {   %
(Autre établissement que celui qui délivre le bulletin)  }ifelse show  /A0265 A0265 10 sub def  A0266 A0265 moveto  %
 /Times-Bold-French findfont 9 scalefont setfont  gsave  ( Code ) show  currentpoint  pop  5 add  /A0279 exch def  %
 grestore  ( Code ) A0259  A0279 A0265 moveto  (Nom de l'établissement ) A0259  A0263 105 eq  {  A0260  316 25 moveto  275 %
 0 rlineto  stroke  }if  /Times-Roman-French findfont 9 scalefont setfont  /A0265 A0265 10 sub def  8.5 A0148  A0331 -1 eq  %
 {/A0280 -1 def  A0266 117 add A0265 20 sub moveto  /Times-Roman-French findfont 11 scalefont setfont  (Aucun) show }  %
 /Times-Roman-French findfont 8.5 scalefont setfont  {/A0280 A0331 def }ifelse  0 1 A0280  {  A0266 A0265 moveto  /A0180 %
 exch def A0466 A0180 get  /A0281 exch def  A0570 A0281 known  {  A0281 A0573 cvs 1 6 getinterval show  A0279 A0265 moveto  %
 A0570 A0281 get dup 0 exch length 16 sub getinterval  /A0282 7 def  1000 A0265 A0063  add 5 add 237 5 (V) 0 0 0.2 0 1 0 0 %
 A0085  currentpoint exch pop  /A0283 exch def  /A0282 0 def  A0283 26 lt  {1 setgray  A0266 A0265 8 add moveto  30 0 %
 rlineto  0 -10 rlineto  -30 0 rlineto  closepath  fill  0 setgray  exit }  {/A0282 7 def  A0570 A0281 get dup 0 exch %
 length 16 sub getinterval  A0279 A0265 A0063  add 5 add 237 5 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop  /A0283 %
 exch def  /A0282 0 def  /A0265 A0283 8 sub def  A0265 26 lt  {exit }if  }ifelse  }if  }for  /Times-Roman-French findfont %
 10 scalefont setfont  }bind def  /A0284  {  /A0285 exch def  /A0286 () def  0 1 A0285 length 1 sub  {  /A0287 exch def  %
 A0285 A0287 1 getinterval ( ) ne  {  /A0286 A0286 A0285 A0287 1 getinterval  A0150 def  }if  }for  A0286  }bind def  %
 /A0288  {  210 145 230 A0469 20 Psigle  /A0076 A0577 def  /A0077 A0578 def  A0077 A0076 moveto  A0489 show ( ) show  %
 /A0289 () def  A0483 A0066 () ne A0289 () eq and  {/A0289 A0483 def }if  A0484 A0066 () ne A0289 () eq and  {/A0289 A0484 %
 def }if  A0485 A0066 () ne A0289 () eq and  {/A0289 A0485 def }if  A0486 A0066 () ne A0289 () eq and  {/A0289 A0486 def %
 }if  A0487 A0066 () ne A0289 () eq and  {/A0289 A0487 def }if  A0488 A0066 () ne A0289 () eq and  {/A0289 A0488 def }if  %
 A0289 show  /A0077 A0077 300 add def  A0077 A0076 moveto  /A0199 false def  (Code permanent : ) show  A0490 show  /A0077 %
 A0077 228 add def  A0077 A0076 moveto  A0149  /A0076 A0076 15 sub def  A0578 A0076 moveto  }bind def  /A0290  {  dup 3 -1 %
 roll exch get exch 1 add  }bind def  /A0291  {  /A0292 exch def  A0427  {  A0292  {  /A0293 A0542 def  A0316 1 eq  {  %
 /A0293 A0575 A0542 add def  }if  }  {  A0316 1 eq  {/A0293 A0583 def }  {/A0293 A0584 def }ifelse  }ifelse  }if  }bind %
 def  /A0294  {  A0428 cvs 5 (0) A0157 A0221 A0150  }bind def  /A0295  {  A0427  {  /A0296 A0296 1 add def  A0452 A0296 %
 A0298 put  }  {  /A0297 A0297 1 add def  /A0298 () def  A0296 A0297 ge  {  /A0298 A0452 A0297 get def  }if  }ifelse  }bind %
 def  /A0299  {  A0440 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 400 def  /A0304 592 def  /A0305 0 def  %
 A0427  {  A0343 (SESSIONNEL) eq  {  A0432 0 eq  A0434 0 eq and  A0438 0 eq and  A0446 0 eq and  A0448 0 eq and  A0450 0 eq %
 and  }  {  A0446 0 eq  A0448 0 eq and  A0450 0 eq and  }ifelse  dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  %
 /A0302 0 def  /A0309 A0458 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  /A0313 false def  }if  {  A0427 not  {  %
 A0298 A0305 A0294 eq  {  A0295  A0336  {A0422 }if  A0258  A0260  A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 %
 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  %
 A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  }if  }if  A0305 A0440 ge  {exit  }if  A0439 %
 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==COURS SESSIONNEL) eq  {  A0439 A0305 A0290  /A0305 exch def  %
 /A0319 exch def  A0439 A0305 A0290  /A0305 exch def  /A0320 exch def  A0439 A0305 A0290  /A0305 exch def  /A0321 exch def  %
 A0439 A0305 A0290  /A0305 exch def  /A0322 exch def  A0439 A0305 A0290  /A0305 exch def  /A0323 exch def  A0439 A0305 %
 A0290  /A0305 exch def  /A0324 exch def  /A0118 A0324 def  A0117  /A0324 A0118 def  A0439 A0305 A0290  /A0305 exch def  %
 /A0325 exch def  A0439 A0305 A0290  /A0305 exch def  /A0326 exch 6 (0) A0157 def  /A0077 A0578 def  A0077 A0076 moveto  %
 /A0133 A0076 10 add def  A0197 not  {  A0219  }if  /Courier-Bold findfont 10 scalefont setfont  A0319 show  %
 /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  0 1 A0320 length 1 sub  %
 {  /A0328 exch def  A0320 A0328 1 getinterval (|) ne  {/A0186  A0186 A0320 A0328 1 getinterval A0150 def  }  %
 {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add 300 0 (V) 0 0 0.2 0 1 0 0 %
 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub def }  {/A0076 %
 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  /A0327 A0327 1 add def  %
 A0186 A0077 73 add A0076 A0063 add 300 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0329 A0133 A0076 %
 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 A0470 A0129  %
 /A0077 A0578 def  /A0076 A0330 5.5 add def  A0321 400 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0322 425 A0076 %
 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0323 445 A0076 A0063 add 30 0 (V) 0 0 0.2 1 1 0 0 A0085  A0324 484 A0076 A0063 %
 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0325 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0326 544 A0076 A0063 add 36 %
 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0326 A0480 ne  A0326 A0325 A0161 %
 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0590 sub def  /A0333 A0309 %
 def  A0309 3 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add %
 def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  %
 A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 3 lt  A0302 2 lt and or  {  /A0298 A0311 dup  /A0334 exch def A0294 %
 def  /A0309 A0310 def  }  {  A0309 3 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 %
 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 %
 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 A0316 1 add def  0.3 %
 setlinewidth  A0288  A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 %
 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 %
 A0291 }ifelse  }if  }if  }if  /A0336 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  /A0197 false def  }if  }bind %
 def  /A0337  {  A0442 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 400 def  /A0304 592 def  /A0305 0 def  %
 A0427  {  A0343 (SESSIONNEL) eq  {  A0444 0 eq  A0432 0 eq and  A0434 0 eq and  A0438 0 eq and  A0446 0 eq and  A0448 0 eq %
 and  A0450 0 eq and  }  {  A0444 0 eq  A0446 0 eq and  A0448 0 eq and  A0450 0 eq and  }ifelse  dup  /A0306 exch def  %
 A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0459 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  %
 /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0338  {A0422 }if  A0258  A0260  A0316 1 eq  {105 %
 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  }if  %
 }if  A0305 A0442 ge  {exit  }if  A0441 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==COURS SESSIONNEL) eq  {  %
 A0441 A0305 A0290  /A0305 exch def  /A0319 exch def  A0441 A0305 A0290  /A0305 exch def  /A0320 exch def  A0441 A0305 %
 A0290  /A0305 exch def  /A0321 exch def  A0441 A0305 A0290  /A0305 exch def  /A0322 exch def  A0441 A0305 A0290  /A0305 %
 exch def  /A0323 exch def  A0441 A0305 A0290  /A0305 exch def  /A0324 exch def  /A0118 A0324 def  A0117  /A0324 A0118 def  %
 A0441 A0305 A0290  /A0305 exch def  /A0325 exch def  A0441 A0305 A0290  /A0305 exch def  /A0326 exch 6 (0) A0157 def  %
 /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 10 add def  A0197 not  {  A0219  }if  /Courier-Bold findfont 10 %
 scalefont setfont  A0319 show  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 %
 A0076 def  0 1 A0320 length 1 sub  {  /A0328 exch def  A0320 A0328 1 getinterval (|) ne  {/A0186  A0186 A0320 A0328 1 %
 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add %
 300 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 %
 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  %
 /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add 300 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def %
 pop  /A0329 A0133 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 %
 A0304 A0330 A0470 A0129  /A0077 A0578 def  /A0076 A0330 5.5 add def  A0321 400 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 %
 A0085  A0322 425 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0323 445 A0076 A0063 add 30 0 (V) 0 0 0.2 1 1 0 0 A0085  %
 A0324 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0325 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0326 %
 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0326 A0480 %
 ne  A0326 A0325 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0590 %
 sub def  /A0333 A0309 def  A0309 3 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub %
 def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 %
 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 3 lt  A0302 2 lt and or  {  /A0298 A0311 %
 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 3 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 %
 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  %
 erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  %
 /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false %
 def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  /A0338 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  %
 /A0197 false def  }if  }bind def  /A0339  {  A0444 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 400 def  %
 /A0304 592 def  /A0305 0 def  A0427  {  A0343 (SESSIONNEL) eq  {  A0432 0 eq  A0434 0 eq and  A0438 0 eq and  A0446 0 eq %
 and  A0448 0 eq and  A0450 0 eq and  }  {  A0446 0 eq  A0448 0 eq and  A0450 0 eq and  }ifelse  dup  /A0306 exch def  %
 A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0460 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  %
 /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0340  {A0422 }if  A0258  A0260  A0316 1 eq  {105 %
 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  }if  %
 }if  A0305 A0444 ge  {exit  }if  A0443 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==COURS SESSIONNEL) eq  {  %
 A0443 A0305 A0290  /A0305 exch def  /A0319 exch def  A0443 A0305 A0290  /A0305 exch def  /A0320 exch def  A0443 A0305 %
 A0290  /A0305 exch def  /A0321 exch def  A0443 A0305 A0290  /A0305 exch def  /A0322 exch def  A0443 A0305 A0290  /A0305 %
 exch def  /A0323 exch def  A0443 A0305 A0290  /A0305 exch def  /A0324 exch def  /A0118 A0324 def  A0117  /A0324 A0118 def  %
 A0443 A0305 A0290  /A0305 exch def  /A0325 exch def  A0443 A0305 A0290  /A0305 exch def  /A0326 exch 6 (0) A0157 def  %
 /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 10 add def  A0197 not  {  A0219  }if  /Courier-Bold findfont 10 %
 scalefont setfont  A0319 show  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 %
 A0076 def  0 1 A0320 length 1 sub  {  /A0328 exch def  A0320 A0328 1 getinterval (|) ne  {/A0186  A0186 A0320 A0328 1 %
 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add %
 300 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 %
 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  %
 /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add 300 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def %
 pop  /A0329 A0133 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 %
 A0304 A0330 A0470 A0129  /A0077 A0578 def  /A0076 A0330 5.5 add def  A0321 400 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 %
 A0085  A0322 425 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0323 445 A0076 A0063 add 30 0 (V) 0 0 0.2 1 1 0 0 A0085  %
 A0324 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0325 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0326 %
 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0326 A0480 %
 ne  A0326 A0325 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0590 %
 sub def  /A0333 A0309 def  A0309 3 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub %
 def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 %
 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 3 lt  A0302 2 lt and or  {  /A0298 A0311 %
 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 3 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 %
 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  %
 erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0317 true def  A0219  /A0317 false def  /A0133 A0076 9.5 add def  %
 /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false %
 def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  /A0340 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  %
 /A0197 false def  }if  }bind def  /A0341  {  A0432 0 gt  {  /A0342 A0343 def  /A0343 (OBJECTIF) def  /A0300 0 def  /A0301 %
 0 def  /A0302 0 def  /A0303 A0343 (SESSIONNEL) eq  {400 }{480 }ifelse def  /A0304 592 def  /A0344 false def  /A0211 false %
 def  /A0345 false def  /A0230 false def  /A0346 false def  /A0305 0 def  A0427  {  A0343 (SESSIONNEL) eq A0342 (SESSIONNEL) %
 eq or  {  A0434 0 eq  A0438 0 eq and  A0446 0 eq and  A0448 0 eq and  A0450 0 eq and  }  {  A0434 0 eq  A0436 0 eq and  %
 A0438 0 eq and  A0440 0 eq and  A0442 0 eq and  A0444 0 eq and  A0446 0 eq and  A0450 0 eq and  A0448 0 eq and  }ifelse  %
 dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0454 def  /A0310 A0309 def  /A0311 A0305 %
 def  /A0312 0 def  /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0344  {A0422 }if  A0258  %
 A0260  A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  %
 /A0211 false def  /A0315 -1 def  /A0230 false def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  A0343  %
(SESSIONNEL) eq  {A0219 }  {A0207 }ifelse  /A0076 A0076 9.5 add def  /A0077 A0578 def  A0077 A0076 moveto  /A0346 true def  %
 /A0133 A0076 9.5 add def  }if  }if  A0305 A0432 ge  {exit  }if  A0431 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318  %
(==TITRE EPREUVE) eq  {  /A0312 A0305 1 sub def  /A0307 A0307 1 add def  A0431 A0305 A0290  /A0305 exch def  /A0229 exch %
 def  /A0345 true def  }if  A0318 (==EPREUVE) eq  {  A0431 A0305 A0290  /A0305 exch def  /A0347 exch def  A0431 A0305 %
 A0290  /A0305 exch def  /A0348 exch def  A0431 A0305 A0290  /A0305 exch def  /A0349 exch def  /A0118 A0349 def  A0117  %
 /A0349 A0118 def  A0431 A0305 A0290  /A0305 exch def  /A0350 exch def  A0431 A0305 A0290  /A0305 exch def  /A0351 exch 6 (0) %
 A0157 def  /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 10 add def  A0211 not  A0425 (Epreuve) ne and  {A0222  }if  %
 A0345 A0346 or  {A0223  /A0300 A0305 A0586 sub def  /A0301 A0309 def  /A0302 A0308 def  /A0345 false def  /A0346 false def %
 }if  /Courier-Bold findfont 10 scalefont setfont  A0076 A0063 add 615 gt  {/A0076 615 def A0077 A0076 moveto }if  A0347 %
 show  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  0 1 A0348 length 1 %
 sub  {  /A0328 exch def  A0348 A0328 1 getinterval (|) ne  {/A0186  A0186 A0348 A0328 1 getinterval A0150 def  }  %
 {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add  A0343 (SESSIONNEL) eq  %
 {300 }{380 }ifelse  0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 %
 exch sub 13.5 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def %
 }ifelse  }for  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add  A0343 (SESSIONNEL) eq  {300 }{380 }ifelse  0 (V) %
 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0330 A0076 def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 5 %
 sub A0470 A0129  /A0077 A0578 def  /A0076 A0330 def  A0349 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0350 510 %
 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0351 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 %
 13.5 sub def  A0077 A0076 moveto  /A0344 true def  A0427  {  A0351 A0480 ne  A0351 A0350 A0161 not and  A0331 5 lt and  {  %
 /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0586 sub def  /A0333 A0309 def  A0309 2 eq  {  /A0300 %
 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  %
 A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le %
 or  {  A0309 2 add A0301 eq  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 dup  %
 /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 false %
 def  /A0314 false def  /A0218 false def  /A0211 false def  /A0315 -1 def  /A0230 false def  /A0335 A0316 def  /A0316 A0316 %
 1 add def  0.3 setlinewidth  A0288  A0195  A0343 (SESSIONNEL) eq  {A0219 }  {A0207 }ifelse  /A0076 A0076 9.5 add def  %
 /A0077 A0578 def  /A0346 true def  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  %
 /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  }if  %
 }loop  A0422  /A0343 A0342 def  /A0303 0 def  /A0304 0 def  /A0197 false def  }if  }bind def  /A0352  {  A0434 0 gt  {  %
 /A0342 A0343 def  /A0343 (OBJECTIF) def  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0305 0 def  /A0303 A0343 (SESSIONNEL) %
 eq  {400 }{480 }ifelse def  /A0304 592 def  /A0353 false def  /A0211 false def  A0427  {  A0343 (SESSIONNEL) eq A0342  %
(SESSIONNEL) eq or  {  A0438 0 eq  A0446 0 eq and  A0450 0 eq and  A0448 0 eq and  }  {  A0436 0 eq  A0438 0 eq and  A0440 %
 0 eq and  A0442 0 eq and  A0444 0 eq and  A0446 0 eq and  A0450 0 eq and  A0448 0 eq and  }ifelse  dup  /A0306 exch def  %
 A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0455 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  %
 /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0353  {A0422 }if  A0258  A0260  A0316 1 eq  {105 %
 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0211 false def  /A0218 false def  /A0315 %
 -1 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  A0343 (SESSIONNEL) eq  {A0219 }  {A0207 }ifelse  }if  }if  %
 A0305 A0434 ge  {exit  }if  A0433 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==AUTRE SANCTION) eq  {  A0433 %
 A0305 A0290  /A0305 exch def  /A0354 exch def  A0354 () ne  {  /A0354 A0354 ( -) A0150 def          }if  A0433 A0305 %
 A0290  /A0305 exch def  /A0355 exch def  A0433 A0305 A0290  /A0305 exch def  /A0356 exch def  A0433 A0305 A0290  /A0305 %
 exch def  /A0357 exch def  A0433 A0305 A0290  /A0305 exch def  /A0358 exch def  A0433 A0305 A0290  /A0305 exch def  /A0359 %
 exch 6 (0) A0157 def  /A0360 true def  /A0361 A0356 ( \() A0150 def  /A0361 A0361  A0355 A0150 def  /A0361 A0361 (\)) %
 A0150 def  A0357 () ne  {  /A0361  A0361 (|) A0150 def  /A0361  A0361 A0357 A0150 def  }if  gsave  1000 1000 moveto  A0354 %
 show  /A0362 currentpoint pop 1000 sub 3 add def  grestore  /A0133 A0076 10 add def  /A0077 A0578 def  A0077 A0076 moveto  %
 A0211 not  A0425 (Autre sanction) ne and  {A0231 }if  /A0327 0 def  /A0186 () def  /A0184 A0076 def  /A0363 false def  0 1 %
 A0361 length 1 sub  {  /A0328 exch def  A0361 A0328 1 getinterval (|) ne  {/A0186  A0186 A0361 A0328 1 getinterval A0150 %
 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0363 not  {A0578 A0076 moveto A0354 show  /A0363 true %
 def }if  A0186 A0578 A0362 add  A0076 A0063 add  A0343 (SESSIONNEL) eq  {375 A0362 sub }  {460 A0362 sub }ifelse  0 (V) 0 %
 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub def %
 }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def }ifelse  }for  /A0327 A0327 1 add %
 def  A0363 not  {A0578 A0076 moveto A0354 show  /A0363 true def }if  A0186 A0578 A0362 add  A0076 A0063 add  A0343  %
(SESSIONNEL) eq  {375 A0362 sub }  {460 A0362 sub }ifelse  0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  %
 /A0329 A0133 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 A0304 %
 A0330 A0470 A0129  /A0133 A0330 def  /A0077 A0578 def  /A0076 A0330 5.5 add def  A0358 510 A0076 A0063 add 25 0 (V) 0 0 %
 0.2 1 1 0 0 A0085  A0359 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 %
 moveto  /A0353 true def  A0427  {  A0359 A0480 ne  A0359 A0358 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  %
 A0466  A0331 A0164 put  }if  /A0332 A0305 A0587 sub def  /A0333 A0309 def  A0309 2 eq  {  /A0300 A0332 def  /A0301 A0309 %
 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  %
 A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 %
 2 lt  A0302 2 lt and or  {  /A0298 A0311 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 2 lt  {  /A0298 %
 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 %
 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0211 %
 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  %
 A0343 (SESSIONNEL) eq  {A0219 }  {A0207 }ifelse  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 def  /A0307 0 def  %
 /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 A0291 }ifelse  }if  %
 }if  }if  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  /A0343 A0342 def  /A0197 false def  }if  }bind def  /A0364  {  %
 A0438 0 gt  {  /A0342 A0343 def  /A0343 (OBJECTIF) def  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 A0343 (SESSIONNEL) %
 eq  {400 }{480 }ifelse def  /A0304 592 def  /A0230 false def  /A0346 false def  /A0305 0 def  /A0365 false def  /A0211 %
 false def  /A0366 false def  A0427  {  A0343 (SESSIONNEL) eq A0342 (SESSIONNEL) eq or  {  A0446 0 eq  A0450 0 eq and  %
 A0448 0 eq and  }  {  A0440 0 eq  A0442 0 eq and  A0444 0 eq and  A0446 0 eq and  A0450 0 eq and  A0448 0 eq and  }ifelse  %
 dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0457 def  /A0310 A0309 def  /A0311 A0305 %
 def  /A0312 0 def  /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0365  {A0422 }if  A0258  %
 A0260  A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  %
 /A0315 -1 def  /A0230 false def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  A0343 (SESSIONNEL) eq  {/A0367 %
 true def  A0219  A0232  /A0367 false def }  {A0207 }ifelse  /A0076 A0076 7 add def  /A0077 A0578 def  A0077 A0076 moveto  %
 /A0365 false def  /A0346 true def  /A0133 A0076 9.5 add def  }if  }if  A0305 A0438 ge  {exit  }if  A0437 A0305 A0290  %
 /A0305 exch def  /A0318 exch def  A0318 (==TITRE AUTRE EPREUVE) eq  {  /A0312 A0305 1 sub def  /A0307 0 def  A0437 A0305 %
 A0290  /A0305 exch def  /A0238 exch def  /A0366 true def  /A0230 false def  }if  A0318 (==AUTRE EPREUVE) eq  {  A0437 %
 A0305 A0290  /A0305 exch def  /A0368 exch def  A0437 A0305 A0290  /A0305 exch def  /A0369 exch def  A0437 A0305 A0290  %
 /A0305 exch def  /A0370 exch def  /A0118 A0370 def  A0117  /A0370 A0118 def  A0437 A0305 A0290  /A0305 exch def  /A0371 %
 exch def  A0437 A0305 A0290  /A0305 exch def  /A0372 exch 6 (0) A0157 def  /A0133 A0076 10 add def  /A0077 A0578 def  %
 A0077 A0076 moveto  A0211 not  A0425 (Autre epreuve) ne and  {A0232 }if  A0366 A0346 or  {A0233  /A0300 A0305 A0586 sub %
 def  /A0301 A0309 def  /A0302 A0308 def  /A0366 false def  /A0346 false def }if  /Courier-Bold findfont 10 scalefont %
 setfont  A0076 A0063 add 615 gt  {/A0076 615 def A0077 A0076 moveto }if  A0368 show  /Times-Roman-French findfont 10 %
 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  0 1 A0369 length 1 sub  {  /A0328 exch def  A0369 A0328 %
 1 getinterval (|) ne  {/A0186  A0186 A0369 A0328 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 %
 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add  A0343 (SESSIONNEL) eq  {300 }{380 }ifelse  0 (V) 0 0 0.2 0 1 0 0 %
 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub def }  {/A0076 %
 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def }ifelse  }for  /A0327 A0327 1 add def  A0186 %
 A0077 73 add A0076 A0063 add  A0343 (SESSIONNEL) eq  {300 }{380 }ifelse  0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 %
 exch def pop  /A0330 A0076 def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 5 sub A0470 A0129  /A0077 A0578 def  /A0076 %
 A0330 def  A0370 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0371 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 %
 A0085  A0372 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  /A0365 %
 true def  A0427  {  A0372 A0480 ne  A0372 A0371 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 %
 A0164 put  }if  /A0332 A0305 A0589 sub def  /A0333 A0309 def  A0309 3 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 %
 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 %
 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0309 2 add A0301 eq  {  %
 /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 %
 A0333 def  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false %
 def  /A0315 -1 def  /A0230 false def  /A0335 A0316 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  A0343  %
(SESSIONNEL) eq  {/A0367 true def  A0219  A0232  /A0367 false def }  {A0207 }ifelse  /A0076 A0076 7 add def  /A0365 false %
 def  /A0346 true def  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  %
 /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  }if  }loop  A0422  %
 /A0343 A0342 def  /A0303 0 def  /A0304 0 def  /A0197 false def  }if  }bind def  /A0373  {  A0448 0 gt  {  /A0300 0 def  %
 /A0301 0 def  /A0302 0 def  /A0303 400 def  /A0304 592 def  /A0305 0 def  A0427  {  A0446 0 eq  A0450 0 eq and  dup  %
 /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0462 def  /A0310 A0309 def  /A0311 A0305 def  %
 /A0312 0 def  /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0379 {A0422 }if  A0258  A0260  %
 A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 %
 -1 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0374 true def  A0239  /A0374 false def  /A0133 A0076 9.5 %
 add def  }if  }if  A0305 A0448 ge  {exit  }if  A0447 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==HABILETE) eq  %
 {  A0447 A0305 A0290  /A0305 exch def  /A0375 exch def  A0447 A0305 A0290  /A0305 exch def  /A0376 exch def  A0447 A0305 %
 A0290  /A0305 exch def  /A0377 exch def  A0447 A0305 A0290  /A0305 exch def  /A0378 exch 6 (0) A0157 def  /A0077 A0578 %
 def  A0077 A0076 moveto  /A0133 A0076 10 add def  A0197 not  {  A0239  }if  /Times-Roman-French findfont 10 scalefont %
 setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  /A0077 A0578 def  0 1 A0375 length 1 sub  {  /A0328 exch def  %
 A0375 A0328 1 getinterval (|) ne  {/A0186  A0186 A0375 A0328 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def %
 pop  /A0327 A0327 1 add def  A0186 A0077 A0076 A0063 add 360 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  %
 {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  %
 A0077 A0076 moveto  /A0186 () def  }ifelse  }for  /A0327 A0327 1 add def  A0186 A0077 A0076 A0063 add 360 0 (V) 0 0 0.2 0 %
 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0329 A0133 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 %
 add def  /A0077 A0578 def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 A0470 A0129  /A0076 A0330 5.5 add def  A0376 A0077 %
 380 add A0076 A0063 add 110 0 (V) 0 0 0.2 2 1 0 0 A0085  A0377 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0378 %
 550 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0378 A0480 %
 ne  A0378 A0377 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0593 %
 sub def  /A0333 A0309 def  A0309 2 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub %
 def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 %
 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 2 lt  A0302 2 lt and or  {  /A0298 A0311 %
 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 2 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 %
 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  %
 erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0374 true def  A0239  /A0374 false def  /A0133 A0076 9.5 add def  %
 /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false %
 def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  /A0379 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  %
 /A0197 false def  }if  }bind def  /A0380  {  A0446 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 482.5 def  %
 /A0304 592 def  /A0305 0 def  A0427  {  A0450 0 eq  dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  %
 /A0309 A0461 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  /A0313 false def  }if  {  A0427 not  {  A0298 A0305 %
 A0294 eq  {  A0295  A0386  {A0422 }if  A0258  A0260  A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 %
 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  %
 /A0374 true def  A0241  /A0374 false def  /A0133 A0076 9.5 add def  }if  }if  A0305 A0446 ge  {exit  }if  A0445 A0305 %
 A0290  /A0305 exch def  /A0318 exch def  A0318 (==STAGE) eq  {  A0445 A0305 A0290  /A0305 exch def  /A0381 exch def  A0445 %
 A0305 A0290  /A0305 exch def  /A0382 exch def  A0445 A0305 A0290  /A0305 exch def  /A0383 exch def  A0445 A0305 A0290  %
 /A0305 exch def  /A0384 exch def  A0445 A0305 A0290  /A0305 exch def  /A0385 exch 6 (0) A0157 def  /A0077 A0578 def  A0077 %
 A0076 moveto  /A0133 A0076 10 add def  A0197 not  {  A0241  }if  /Courier-Bold findfont 10 scalefont setfont  A0381 show  %
 /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  /A0077 A0578 def  0 1 %
 A0382 length 1 sub  {  /A0328 exch def  A0382 A0328 1 getinterval (|) ne  {/A0186  A0186 A0382 A0328 1 getinterval A0150 %
 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 73 add A0076 A0063 add 380 0 (V) 0 0 0.2 0 %
 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub def }  %
 {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  /A0327 A0327 1 add %
 def  A0186 A0077 73 add A0076 A0063 add 380 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0329 A0133 %
 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 A0470 %
 A0129  /A0077 A0578 def  /A0076 A0330 5.5 add def  A0383 480 A0076 A0063 add 20 0 (V) 0 0 0.2 1 1 0 0 A0085  A0384 510 %
 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0385 550 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 %
 13.5 sub def  A0077 A0076 moveto  A0427  {  A0385 A0480 ne  A0385 A0384 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 %
 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0591 sub def  /A0333 A0309 def  A0309 2 eq  {  /A0300 A0332 def  %
 /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 %
 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  %
 A0308 2 le  A0309 2 lt  A0302 2 lt and or  {  /A0298 A0311 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 2 %
 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  %
 /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 false def  /A0314 false %
 def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0374 %
 true def  A0241  /A0374 false def  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  %
 /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  %
 /A0386 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  /A0197 false def  }if  }bind def  /A0387  {  A0450 0 gt  %
 {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 510.5 def  /A0304 592 def  /A0305 0 def  A0427  {  true  dup  /A0306 %
 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0463 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 %
 def  /A0313 false def  }if  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0391 {A0422 }if  A0258  A0260  A0316 1 eq  %
 {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  %
 /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0374 true def  A0242  /A0374 false def  /A0133 A0076 9.5 add %
 def  }if  }if  A0305 A0450 ge  {exit  }if  A0449 A0305 A0290  /A0305 exch def  /A0318 exch def  A0318 (==ENGAGEMENT) eq  %
 {  A0449 A0305 A0290  /A0305 exch def  /A0388 exch def  A0449 A0305 A0290  /A0305 exch def  /A0389 exch def  A0449 A0305 %
 A0290  /A0305 exch def  /A0390 exch 6 (0) A0157 def  /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 10 add def  A0197 %
 not  {  A0242  }if  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  %
 /A0077 A0578 def  0 1 A0388 length 1 sub  {  /A0328 exch def  A0388 A0328 1 getinterval (|) ne  {/A0186  A0186 A0388 A0328 %
 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0077 A0076 A0063 add 460 0  %
(V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop A0191 exch sub 13.5 add sub %
 def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  /A0327 A0327 %
 1 add def  A0186 A0077 A0076 A0063 add 460 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  /A0076 exch def pop  /A0329 A0133 %
 A0076 sub def  /A0076 A0184 def  /A0330 A0076 A0329 sub 5.5 add def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 A0470 %
 A0129  /A0077 A0578 def  /A0076 A0330 5.5 add def  A0389 510 A0076 A0063 add 25 0 (V) 0 0 0.2 1 1 0 0 A0085  A0390 550 %
 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0390 A0480 ne  %
 A0390 A0389 A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0592 sub %
 def  /A0333 A0309 def  A0309 2 eq  {  /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  %
 /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 true %
 def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 le  A0309 2 lt  A0302 2 lt and or  {  /A0298 A0311 dup  %
 /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 2 lt  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 %
 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  %
 erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 %
 A0316 1 add def  0.3 setlinewidth  A0288  A0195  /A0374 true def  A0242  /A0374 false def  /A0133 A0076 9.5 add def  %
 /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false %
 def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  /A0391 true def  }if  }loop  A0422  /A0303 0 def  /A0304 0 def  %
 /A0197 false def  }if  }bind def  /A0392  {  A0430 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 0 def  /A0303 480 def  %
 /A0304 592 def  /A0305 0 def  /A0230 false def  /A0393 false def  /A0244 (RIEN) def  A0427  {  A0432 0 eq  A0434 0 eq and  %
 A0436 0 eq and  A0438 0 eq and  A0440 0 eq and  A0442 0 eq and  A0444 0 eq and  A0446 0 eq and  A0450 0 eq and  A0448 0 eq %
 and  dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  /A0309 A0453 def  /A0310 A0309 def  /A0311 %
 A0305 def  /A0312 0 def  /A0313 false def  }if  /A0076 450.7 def  A0077 A0076 moveto  /A0394 false def  /A0211 false def  %
 /A0395 false def  /A0396 false def  /A0397 false def  /A0398 false def  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  %
 A0394  {A0422 }if  A0258  A0260  A0316 1 eq  {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 %
 false def  /A0218 false def  /A0315 -1 def  /A0230 false def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  %
 A0207  /A0076 A0076 10 add def  /A0077 A0578 def  A0077 A0076 moveto  A0243  A0393  {A0246 }{/A0076 A0076 3 sub def %
 }ifelse  /A0133 A0076 9.5 add def  }if  }if  A0305 A0430 ge  {exit  }if  A0429 A0305 A0290  /A0305 exch def  /A0318 exch %
 def  A0318 (==TITRE COMPOSANTE PROGRAMME) eq  {  A0500 (AEC) eq  A0500 (Aec) eq or  A0500 (AEc) eq or  A0500 (aec) eq or  %
 A0500 (aEC) eq or  A0500 (aeC) eq or  A0500 (AeC) eq or  A0500 (aEc) eq or not  {  A0429 A0305 A0290  /A0305 exch def  %
 /A0395 false def  /A0399 exch def  /A0397 true def  /A0211 false def  /A0393 false def  }  {/A0399 (NE PAS AFFICHER) def  %
 }ifelse  }if  A0318 (==TITRE COMPOSANTE PROGRAMME FS) eq  {  A0500 (AEC) eq  A0500 (Aec) eq or  A0500 (AEc) eq or  A0500  %
(aec) eq or  A0500 (aEC) eq or  A0500 (aeC) eq or  A0500 (AeC) eq or  A0500 (aEc) eq or not  {  A0429 A0305 A0290  /A0305 %
 exch def  /A0395 false def  /A0399 exch def  /A0397 true def  /A0211 false def  /A0393 false def  A0429 A0305 A0290  %
 /A0305 exch def  /A0400 exch def  A0400 () ne  {/A0399 A0399 ( en ) A0150 def  /A0399 A0399 A0400 A0150 def }if  }  %
 {/A0399 (NE PAS AFFICHER) def  }ifelse  }if  A0318 (==TITRE DISCIPLINE FORMATION) eq  {  A0429 A0305 A0290  /A0305 exch %
 def  /A0396 false def  /A0401 exch def  /A0398 true def  /A0230 false def  /A0393 true def  }if  A0318 (==OBJECTIF) eq  {  %
 A0429 A0305 A0290  /A0305 exch def  /A0402 exch def  A0429 A0305 A0290  /A0305 exch def  /A0403 exch def  A0429 A0305 %
 A0290  /A0305 exch def  /A0404 exch def  A0429 A0305 A0290  /A0305 exch def  /A0405 exch def  /A0118 A0405 def  A0117  %
 /A0405 A0118 def  A0429 A0305 A0290  /A0305 exch def  /A0406 exch def  A0429 A0305 A0290  /A0305 exch def  /A0407 exch 6 (0) %
 A0157 def  /A0408 true def  /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 10.5 add def  A0211 not  {A0243  /A0300 %
 A0305 A0585 sub def  /A0301 A0309 def  /A0302 A0308 def  480 A0076 A0245 add 30 add 592 A0076 5 sub  A0470 A0129 }if  %
 A0398  A0230 not and  {A0246  /A0300 A0305 A0585 sub def  /A0301 A0309 def  /A0302 A0308 def  /A0397 false def  /A0398 %
 false def }if  /Courier-Bold findfont 10 scalefont setfont  A0393 A0399 (NE PAS AFFICHER) eq not and  {A0076 A0063 add 605 %
 gt  {/A0076 605 def A0077 A0076 moveto }if }  {A0076 A0063 add 635 gt  {/A0076 630 def A0077 A0076 moveto }if }ifelse  %
 A0244 (PRINCIPALE) eq  A0244 (RIEN) eq or  {A0500 (AEC) eq  A0500 (Aec) eq or  A0500 (AEc) eq or  A0500 (aec) eq or  A0500  %
(aEC) eq or  A0500 (aeC) eq or  A0500 (AeC) eq or  A0500 (aEc) eq or  A0316 1 ne and  {}  {/A0076 A0076 10 sub def }ifelse  %
 A0077 A0076 moveto  /A0244 (SECONDAIRE) def }if  currentpoint exch pop A0247 exch sub 10 lt  {/A0076 A0076 5 sub def A0077 %
 A0076 moveto }if  /A0247 1000 def  A0402 show  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () %
 def  /A0184 A0076 def  /A0409 A0403 A0404 A0150 def  0 1 A0409 length 1 sub  {  /A0328 exch def  A0409 A0328 1 getinterval  %
(|) ne  {/A0186  A0186 A0409 A0328 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  %
 A0186 A0077 70 add A0076 A0063 add 380 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 %
 currentpoint exch pop A0191 exch sub 13.5 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 %
 moveto  /A0186 () def }ifelse  }for  /A0327 A0327 1 add def  A0186 A0077 70 add A0076 A0063 add 380 0 (V) 0 0 0.2 0 1 0 0 %
 A0085  currentpoint  /A0076 exch def pop  /A0330 A0076 def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 5 sub A0470 A0129  %
 /A0077 A0578 def  /A0076 A0330 def  A0405 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0406 510 A0076 A0063 add 25 %
 0 (V) 0 0 0.2 1 1 0 0 A0085  A0407 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0208 currentpoint exch pop 3 add %
 def  /A0076 A0076 13.5 sub def  A0077 A0076 moveto  A0427  {  A0407 A0480 ne  A0407 A0406  A0161 not and  A0331 5 lt and  %
 {  /A0331  A0331 1 add def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0585 sub def  /A0333 A0309 def  A0309 2 eq  {  %
 /A0300 A0332 def  /A0301 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  %
 A0313 and  A0076 A0293 le or  {  A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 %
 A0293 le or  {  A0309 2 add A0301 eq  {  /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 %
 dup  /A0334 exch def A0294 def  /A0309 A0333 def  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 %
 false def  /A0314 false def  /A0218 false def  /A0315 -1 def  /A0230 false def  /A0335 A0316 def  /A0316 A0316 1 add def  %
 0.3 setlinewidth  A0288  A0195  A0207  /A0076 A0076 10 add def  /A0077 A0578 def  A0077 A0076 moveto  A0243  A0393  {A0246 %
 }{/A0076 A0076 3 sub def }ifelse  /A0133 A0076 9.5 add def  /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  %
 /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  %
 /A0394 true def  /A0395 true def  /A0396 true def  /A0398 false def  }if  /A0397 false def  }loop  A0422  /A0303 0 def  %
 /A0304 0 def  /A0245 0 def  /A0197 false def  }if  }bind def  /A0410  {  A0436 0 gt  {  /A0300 0 def  /A0301 0 def  /A0302 %
 0 def  /A0303 480 def  /A0304 592 def  /A0305 0 def  A0427  {  A0438 0 eq  A0440 0 eq and  A0442 0 eq and  A0444 0 eq and  %
 A0446 0 eq and  A0450 0 eq and  A0448 0 eq and  dup  /A0306 exch def  A0291  /A0307 0 def  /A0308 0 def  /A0302 0 def  %
 /A0309 A0456 def  /A0310 A0309 def  /A0311 A0305 def  /A0312 0 def  /A0313 false def  }if  A0077 A0076 moveto  /A0411 %
 false def  /A0211 false def  {  A0427 not  {  A0298 A0305 A0294 eq  {  A0295  A0411  {A0422 }if  A0258  A0260  A0316 1 eq  %
 {105 A0262 }if  A0419 showpage  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0211 false def  /A0218 false def  %
 /A0315 -1 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  A0195  A0207  /A0211 true def  /A0076 A0076 9.5 add def  %
 /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 9.5 add def  }if  }if  A0305 A0436 ge  {exit  }if  A0435 A0305 A0290  %
 /A0305 exch def  /A0318 exch def  A0318 (==AUTRE OBJECTIF) eq  {  A0435 A0305 A0290  /A0305 exch def  /A0412 exch def  %
 A0435 A0305 A0290  /A0305 exch def  /A0413 exch def  A0435 A0305 A0290  /A0305 exch def  /A0414 exch def  A0435 A0305 %
 A0290  /A0305 exch def  /A0415 exch def  /A0118 A0415 def  A0117  /A0415 A0118 def  A0435 A0305 A0290  /A0305 exch def  %
 /A0416 exch def  A0435 A0305 A0290  /A0305 exch def  /A0417 exch 6 (0) A0157 def  /A0133 A0076 10 add def  /A0077 A0578 %
 def  A0077 A0076 moveto  A0343 (OBJECTIF) eq  A0211 not and  A0425 (Autre objectif) ne and  {  A0207  /A0211 true def  %
 /A0076 A0076 15 sub def  }if  A0425 (Autre objectif) eq  {/A0076 A0076 6.5 sub def }if  /Courier-Bold findfont 10 %
 scalefont setfont  /A0077 A0578 def  A0077 A0076 moveto  A0076 A0063 add 642 gt  {/A0076 642 def A0077 A0076 moveto }if  %
 A0425 (Autre objectif) eq  A0411 not and  {/A0076 A0076 16 sub def A0077 A0076 moveto }if  A0425 (Autre objectif) eq  %
 {/A0076 A0076 6 add def A0077 A0076 moveto }if  currentpoint exch pop A0216 gt  {/A0076 A0216 def currentpoint pop A0076 %
 moveto }if  A0412 show  /Times-Roman-French findfont 10 scalefont setfont  /A0327 0 def  /A0186 () def  /A0184 A0076 def  %
 /A0418 A0413  A0414 A0150 def  0 1 A0418 length 1 sub  {  /A0328 exch def  A0418 A0328 1 getinterval (|) ne  {/A0186  %
 A0186 A0418 A0328 1 getinterval A0150 def  }  {currentpoint  /A0191 exch def pop  /A0327 A0327 1 add def  A0186 A0578 70 %
 add A0076 A0063 add 375 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint exch pop A0191 ne  {/A0076 A0076 currentpoint exch pop %
 A0191 exch sub 13.5 add sub def }  {/A0076 currentpoint 13.5 sub exch pop def }ifelse  A0077 A0076 moveto  /A0186 () def %
 }ifelse  }for  /A0327 A0327 1 add def  A0186 A0578 70 add A0076 A0063 add 375 0 (V) 0 0 0.2 0 1 0 0 A0085  currentpoint  %
 /A0076 exch def pop  /A0330 A0076 def  A0303 A0133 moveto  A0303 A0133 A0304 A0330 5 sub A0470 A0129  /A0133 A0330 def  %
 /A0077 A0578 def  /A0076 A0330 def  A0415 484 A0076 A0063 add 18 0 (V) 0 0 0.2 1 1 0 0 A0085  A0416 510 A0076 A0063 add 25 %
 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0411 true def  A0417 544 A0076 A0063 add 36 0 (V) 0 0 0.2 1 1 0 0 A0085  /A0076 A0076 13.5 %
 sub def  A0077 A0076 moveto  A0427  {  A0417 A0480 ne  A0417 A0416  A0161 not and  A0331 5 lt and  {  /A0331  A0331 1 add %
 def  A0466  A0331 A0164 put  }if  /A0332 A0305 A0588 sub def  /A0333 A0309 def  A0309 2 eq  {  /A0300 A0332 def  /A0301 %
 A0309 def  /A0302 A0308 def  }if  /A0309 A0309 1 sub def  /A0308 A0308 1 add def  A0309 0 eq  A0313 and  A0076 A0293 le %
 or  {  A0306  A0313 not and  {  false A0291  /A0313 true def  }if  A0309 0 eq  A0313 and  A0076 A0293 le or  {  A0308 2 %
 le  A0309 2 lt  A0302 2 lt and or  {  /A0298 A0311 dup  /A0334 exch def A0294 def  /A0309 A0310 def  }  {  A0309 2 lt  {  %
 /A0298 A0300 dup  /A0334 exch def A0294 def  /A0309 A0301 def  }  {  /A0298 A0332 dup  /A0334 exch def A0294 def  /A0309 %
 A0333 def  }ifelse  }ifelse  A0295  /A0305 A0334 def  erasepage  /A0134 2000 def  /A0220 false def  /A0314 false def  %
 /A0211 false def  /A0218 false def  /A0315 -1 def  /A0335 A0316 def  /A0316 A0316 1 add def  0.3 setlinewidth  A0288  %
 A0195  A0207  /A0211 true def  /A0076 A0076 9.5 add def  /A0077 A0578 def  A0077 A0076 moveto  /A0133 A0076 9.5 add def  %
 /A0311 A0305 def  /A0312 0 def  /A0307 0 def  /A0308 0 def  /A0300 0 def  /A0301 0 def  /A0302 0 def  A0313  {/A0313 false %
 def true A0291 } {A0306 A0291 }ifelse  }if  }if  }if  /A0411 true def  }if  }loop  A0422  /A0197 false def  }if  /A0303 0 %
 def  /A0304 0 def  }bind def  /A0419  {  0 1 A0214  {  /A0420 exch def  A0451 A0420 get  /A0421 exch def  A0578 A0421 %
 moveto  572 0 rlineto stroke  }for  /A0214 -1 def  }bind def  /A0422  {  A0209  A0303 0 ne and  {  A0303 A0135 A0304 A0135 %
 7 sub A0470 A0129  }if  /A0209 true def  /A0076 A0135 def  /A0314 true def  A0578 A0076 moveto  /A0214 A0214 1 add def  %
 A0451 A0214 A0076 put  }bind def  /A0423  {  /A0336 false def  /A0338 false def  /A0340 false def  /A0218 false def  %
 /A0365 false def  /A0411 false def  /A0353 false def  /A0344 false def  /A0394 false def  /A0386 false def  /A0391 false %
 def  /A0379 false def  /A0218 false def  A0219  A0560  {  A0119  }  {  /A0221 (Cours sessionnel) def  A0299  /A0221  %
(Cours suivi) def  A0337  /A0221 (Autre cours) def  A0339  /A0221 (Epreuve) def  A0341  /A0221 (Autre sanction) def  A0352  %
 /A0221 (Autre epreuve) def  A0364  /A0221 (Niveau LS) def  A0373  /A0221 (Stage ATE) def  A0380  /A0221 (Engagement) def  %
 A0387  /A0221 (Rien) def  }ifelse  }bind def  /A0424  {  /A0218 false def  /A0394 false def  /A0344 false def  /A0365 %
 false def  /A0411 false def  /A0353 false def  /A0336 false def  /A0338 false def  /A0340 false def  /A0386 false def  %
 /A0391 false def  /A0379 false def  A0221 (Cours sessionnel) ne  A0221 (Cours suivi) ne and  A0221 (Autre cours) ne and  %
 {  A0446 0 gt  {/A0221 (Stage ATE) def }if  A0450 0 gt  {/A0221 (Engagement) def }if  A0448 0 gt  {/A0221 (Niveau LS) def %
 }if  A0438 0 gt  {/A0221 (Autre epreuve) def }if  A0436 0 gt  {/A0221 (Autre objectif) def }if  A0434 0 gt  {/A0221  %
(Autre sanction) def }if  A0432 0 gt  {/A0221 (Epreuve) def }if  A0430 0 gt  {/A0221 (Objectif) def }if  /A0425 A0221 def  %
 A0207  }  {A0219 }ifelse  A0560  {  A0119  }  {  /A0199 false def  /A0221 (Objectif) def  A0392  /A0221 (Epreuve) def  %
 A0341  /A0221 (Autre sanction) def  A0352  /A0221 (Autre objectif) def  /A0216 2000 def  A0410  /A0221 (Autre epreuve) %
 def  A0364  /A0221 (Cours sessionnel) def  A0299  /A0221 (Cours suivi) def  A0337  /A0221 (Autre cours) def  A0339  /A0221  %
(Niveau LS) def  A0373  /A0221 (Stage ATE) def  A0380  /A0221 (Engagement) def  A0387  /A0221 (Rien) def  }ifelse  }bind %
 def  /A0426  {  /A0427 exch def  /A0228 0 def  /A0227 0 def  /A0225 -1 def  /A0224 -1 def  /A0221 (Rien) def  /A0316 1 %
 def  /A0428 20 string def  A0427  {  /A0429 250 dict def  /A0430 0 def  /A0431 250 dict def  /A0432 0 def  /A0433 250 dict %
 def  /A0434 0 def  /A0435 250 dict def  /A0436 0 def  /A0437 250 dict def  /A0438 0 def  /A0439 250 dict def  /A0440 0 %
 def  /A0441 250 dict def  /A0442 0 def  /A0443 250 dict def  /A0444 0 def  /A0445 250 dict def  /A0446 0 def  /A0447 250 %
 dict def  /A0448 0 def  /A0449 250 dict def  /A0450 0 def  /A0451 25 dict def  /A0214 -1 def  /A0452 25 dict def  /A0296 0 %
 def  /A0453 0 def  /A0454 0 def  /A0455 0 def  /A0456 0 def  /A0457 0 def  /A0458 0 def  /A0459 0 def  /A0460 0 def  %
 /A0461 0 def  /A0462 0 def  /A0463 0 def  /A0464 false def  /A0465 false def  /A0335 0 def  /A0466 25 dict def  /A0331 -1 %
 def  A0563 -1 0  {  /A0305 exch def  /A0467 exch def  A0564 A0305 A0467 put  }for  0 1 A0563  {  /A0468 exch def  A0564 %
 A0468 get  /A0318 exch def  A0318 (==SECTION PARAMETRES IMPRESSION) eq  {  A0564 A0468 1 add get  /A0469 exch cvr def  %
 A0564 A0468 2 add get  /A0470 exch cvr def  A0564 A0468 3 add get  /A0471 exch cvr def  A0564 A0468 4 add get  /A0472 exch %
 def  A0564 A0468 5 add get  /A0473 exch cvr def  A0473 0 ne  {A0473 1 ne  {A0473 2 ne  {/A0473 1 def }if }if }if  A0535  %
 }if  A0318 (==SECTION ENTETE COLLEGE) eq  {  A0564 A0468 1 add get  /A0474 exch def  A0564 A0468 2 add get  /A0475 exch %
 def  A0564 A0468 3 add get  /A0476 exch def  A0564 A0468 4 add get  /A0477 exch def  A0564 A0468 5 add get  /A0478 exch %
 def  A0564 A0468 6 add get  /A0479 exch def  A0564 A0468 7 add get  /A0480 exch 6 (0) A0157 def  A0564 A0468 8 add get  %
 /A0481 exch cvr def  A0564 A0468 9 add get  /A0482 exch cvr def  }if  A0318 (==SECTION ADRESSE ETUDIANT) eq  {  A0564 %
 A0468 1 add get  /A0483 exch def  A0564 A0468 2 add get  /A0484 exch def  A0564 A0468 3 add get  /A0485 exch def  A0564 %
 A0468 4 add get  /A0486 exch def  A0564 A0468 5 add get  /A0487 exch def  A0564 A0468 6 add get  /A0488 exch def  }if  %
 A0318 (==SECTION IDENTIFICATION ETUDIANT) eq  {  A0564 A0468 01 add get  /A0489 exch def  A0564 A0468 02 add get  /A0490 %
 exch def  A0564 A0468 03 add get  /A0491 exch def  A0564 A0468 04 add get  /A0492 exch def  A0564 A0468 05 add get  /A0493 %
 exch def  A0564 A0468 06 add get  /A0494 exch def  A0564 A0468 07 add get  /A0495 exch def  A0564 A0468 08 add get  /A0496 %
 exch def  A0564 A0468 09 add get  /A0497 exch def  A0497 () ne  {/A0498 true def }if  A0564 A0468 10 add get  /A0499 exch %
 def  A0564 A0468 11 add get  /A0500 exch def  A0564 A0468 12 add get  /A0501 exch def  A0564 A0468 13 add get  /A0502 exch %
 def  A0564 A0468 14 add get  /A0343 exch def  }if  A0318 (==SECTION INFORMATIONS COMPLEMENTAIRES) eq  {  A0564 A0468 1 add %
 get  /A0503 exch def  A0564 A0468 2 add get  /A0504 exch def  A0564 A0468 3 add get  /A0505 exch def  A0564 A0468 4 add %
 get  /A0506 exch def  A0564 A0468 5 add get  /A0507 exch def  A0564 A0468 6 add get  /A0508 exch def  A0564 A0468 7 add %
 get  /A0509 exch def  }if  A0318 (==SECTION EPREUVES) eq  {  /A0510 A0468 1 add def  A0510 1 A0563  {  /A0511 exch def  %
 A0564 A0511 get  /A0512 exch def  A0512 (==EPREUVE) eq  {  /A0454 A0454 1 add def  }if  A0512 length 9 ge  {  A0512 0 9 %
 getinterval (==SECTION) eq  {/A0432 A0432 1 sub def  exit }  {  A0431 A0432 A0512 put  /A0432 A0432 1 add def  }ifelse  }  %
 {A0431 A0432 A0512 put  /A0432 A0432 1 add def  }ifelse  }for  }if  A0318 (==SECTION OBJECTIFS) eq  {  /A0464 true def  %
 /A0513 A0468 1 add def  A0513 1 A0563  {  /A0511 exch def  A0564 A0511 get  /A0514 exch def  A0514 (==OBJECTIF) eq  {  %
 /A0453 A0453 1 add def  }if  A0514 length 9 ge  {  A0514 0 9 getinterval (==SECTION) eq  {/A0430 A0430 1 sub def  exit }  %
 {  A0429 A0430 A0514 put  /A0430 A0430 1 add def  }ifelse  }  {A0429 A0430 A0514 put  /A0430 A0430 1 add def  }ifelse  %
 }for  }if  A0318 (==SECTION AUTRES SANCTIONS) eq  {  /A0515 A0468 1 add def  A0515 1 A0563  {  /A0511 exch def  A0564 %
 A0511 get  /A0516 exch def  A0516 (==AUTRE SANCTION) eq  {  /A0455 A0455 1 add def  }if  A0516 length 9 ge  {  A0516 0 9 %
 getinterval (==SECTION) eq  {/A0434 A0434 1 sub def  exit }  {  A0433 A0434 A0516 put  /A0434 A0434 1 add def  }ifelse  }  %
 {A0433 A0434 A0516 put  /A0434 A0434 1 add def  }ifelse  }for  }if  A0318 (==SECTION AUTRES OBJECTIFS) eq  {  /A0465 true %
 def  /A0517 A0468 1 add def  A0517 1 A0563  {  /A0511 exch def  A0564 A0511 get  /A0518 exch def  A0518 (==AUTRE OBJECTIF) %
 eq  {  /A0456 A0456 1 add def  }if  A0518 length 9 ge  {  A0518 0 9 getinterval (==SECTION) eq  {/A0436 A0436 1 sub def  %
 exit }  {  A0435 A0436 A0518 put  /A0436 A0436 1 add def  }ifelse  }  {A0435 A0436 A0518 put  /A0436 A0436 1 add def  %
 }ifelse  }for  }if  A0318 (==SECTION AUTRES EPREUVES) eq  {  /A0519 A0468 1 add def  A0519 1 A0563  {  /A0511 exch def  %
 A0564 A0511 get  /A0520 exch def  A0520 (==AUTRE EPREUVE) eq  {  /A0457 A0457 1 add def  }if  A0520 length 9 ge  {  A0520 %
 0 9 getinterval (==SECTION) eq  {/A0438 A0438 1 sub def  exit }  {  A0437 A0438 A0520 put  /A0438 A0438 1 add def  %
 }ifelse  }  {A0437 A0438 A0520 put  /A0438 A0438 1 add def  }ifelse  }for  }if  A0318 (==SECTION COURS SESSIONNELS) eq  {  %
 /A0521 A0468 1 add def  A0521 1 A0563  {  /A0511 exch def  A0564 A0511 get  /A0522 exch def  A0522 (==COURS SESSIONNEL) %
 eq  {  /A0458 A0458 1 add def  }if  A0522 length 9 ge  {  A0522 0 9 getinterval (==SECTION) eq  {/A0440 A0440 1 sub def  %
 exit }  {  A0439 A0440 A0522 put  /A0440 A0440 1 add def  }ifelse  }  {A0439 A0440 A0522 put  /A0440 A0440 1 add def  %
 }ifelse  }for  }if  A0318 (==SECTION COURS PROGRAMME ETUDES) eq  {  /A0523 A0468 1 add def  A0523 1 A0563  {  /A0511 exch %
 def  A0564 A0511 get  /A0524 exch def  A0524 (==COURS SESSIONNEL) eq  {  /A0459 A0459 1 add def  }if  A0524 length 9 ge  %
 {  A0524 0 9 getinterval (==SECTION) eq  {/A0442 A0442 1 sub def  exit }  {  A0441 A0442 A0524 put  /A0442 A0442 1 add %
 def  }ifelse  }  {A0441 A0442 A0524 put  /A0442 A0442 1 add def  }ifelse  }for  }if  A0318 (==SECTION AUTRES COURS) eq  {  %
 /A0525 A0468 1 add def  A0525 1 A0563  {  /A0511 exch def  A0564 A0511 get  /A0526 exch def  A0526 (==COURS SESSIONNEL) %
 eq  {  /A0460 A0460 1 add def  }if  A0526 length 9 ge  {  A0526 0 9 getinterval (==SECTION) eq  {/A0444 A0444 1 sub def  %
 exit }  {  A0443 A0444 A0526 put  /A0444 A0444 1 add def  }ifelse  }  {A0443 A0444 A0526 put  /A0444 A0444 1 add def  %
 }ifelse  }for  }if  A0318 (==SECTION STAGES TRAVAIL ETUDES) eq  {  /A0527 A0468 1 add def  A0527 1 A0563  {  /A0511 exch %
 def  A0564 A0511 get  /A0528 exch def  A0528 (==STAGE) eq  {  /A0461 A0461 1 add def  }if  A0528 length 9 ge  {  A0528 0 9 %
 getinterval (==SECTION) eq  {/A0446 A0446 1 sub def  exit }  {  A0445 A0446 A0528 put  /A0446 A0446 1 add def  }ifelse  }  %
 {A0445 A0446 A0528 put  /A0446 A0446 1 add def  }ifelse  }for  }if  A0318 (==SECTION ENGAGEMENT ETUDIANT) eq  {  /A0529 %
 A0468 1 add def  A0529 1 A0563  {  /A0511 exch def  A0564 A0511 get  /A0530 exch def  A0530 (==ENGAGEMENT) eq  {  /A0463 %
 A0463 1 add def  }if  A0530 length 9 ge  {  A0530 0 9 getinterval (==SECTION) eq  {/A0450 A0450 1 sub def  exit }  {  %
 A0449 A0450 A0530 put  /A0450 A0450 1 add def  }ifelse  }  {A0449 A0450 A0530 put  /A0450 A0450 1 add def  }ifelse  }for  %
 }if  A0318 (==SECTION NIVEAUX MAITRISE LANGUE SEC) eq  {  /A0531 A0468 1 add def  A0531 1 A0563  {  /A0511 exch def  A0564 %
 A0511 get  /A0532 exch def  A0532 (==HABILETE) eq  {  /A0462 A0462 1 add def  }if  A0532 length 9 ge  {  A0532 0 9 %
 getinterval (==SECTION) eq  {/A0448 A0448 1 sub def  exit }  {  A0447 A0448 A0532 put  /A0448 A0448 1 add def  }ifelse  }  %
 {A0447 A0448 A0532 put  /A0448 A0448 1 add def  }ifelse  }for  }if  }for  gsave  1000 1000 translate  1 setgray  /A0212 %
 true def  A0536  /A0212 false def  0 setgray  grestore  }  {  /A0297 0 def  A0295  }ifelse  A0202  A0201  A0200  A0198  %
 A0195  /A0221 (Rien) def  A0436 0 gt  {/A0221 (Autre objectif) def }if  A0430 0 gt  {/A0221 (Objectif) def }if  A0343  %
(OBJECTIF) eq  {  A0464 not A0465 not and  {/A0343 (SESSIONNEL) def }if  }if  A0343 (SESSIONNEL) eq  {A0423 }  {A0424 %
 }ifelse  A0560 not  {A0249 }if  A0536  A0316 1 eq A0560 not and  {A0542 85 add A0262 }if  A0419 A0427  {erasepage %
 }{showpage }ifelse  /A0134 2000 def  /A0220 false def  /A0314 false def  /A0197 false def  /A0218 false def  /A0315 -1 %
 def  A0427  {/A0335 A0335 1 add def }if  A0427 not  {  A0472 (O) eq  {  A0335 2 mod 0 ne  {showpage }if  }if  restore  %
 A0533  save  }if  }bind def  /A0533  {  count  /A0534 exch def  A0534 -1 roll  dup  /A0469 exch def  A0534 1 roll  A0534 1 %
 sub -1 roll  dup  /A0470 exch def  A0534 1 sub 1 roll  A0534 2 sub -1 roll  dup  /A0471 exch def  A0534 2 sub 1 roll  %
 A0534 3 sub -1 roll  dup  1 eq  {(O) }{(N) }ifelse  /A0472 exch def  A0534 3 sub 1 roll  A0534 4 sub -1 roll  dup  /A0473 %
 exch def  A0534 5 sub 1 roll  }bind def  /A0535  {  count  /A0534 exch def  A0534 -1 roll  pop  A0469  A0534 1 roll  A0534 %
 1 sub -1 roll  pop  A0470 A0534 1 sub 1 roll  A0534 2 sub -1 roll  pop  A0471  A0534 2 sub 1 roll  A0534 3 sub -1 roll  %
 pop  A0472 (O) eq  {1 }{2 }ifelse  A0534 3 sub 1 roll  A0534 4 sub -1 roll  pop  A0473  A0534 4 sub 1 roll  }bind def  %
 /A0536  {  /A0077 A0578 def  Signature_dacs_existe  A0473 0 ne and  {30 23 1 1 A0473 2 eq  {0 15 translate }if %
 Signature_dacs A0473 2 eq  {0 -15 translate }if }  {A0578 10 add 23 moveto A0505 show }ifelse  A0473 2 ne  {(, ) show %
 A0504 show }  {A0578 10 add 23 moveto  A0505 show (, ) show A0504 show }ifelse  A0498 not  {341 87 579 39 A0470 A0129  346 %
 62 moveto }  {331 87 579 39 A0470 A0129  336 62 moveto }ifelse  A0500 (aec) eq  A0500 (aeC) eq or  A0500 (aEc) eq or  %
 A0500 (aEC) eq or  A0500 (Aec) eq or  A0500 (AeC) eq or  A0500 (AEc) eq or  A0500 (AEC) eq or  A0508 (Sans verdict) eq %
 and  {  /A0537 true def  }  {  /A0537 false def  }ifelse  A0508 0 3 getinterval (AEC) eq  A0508 0 3 getinterval (Aec) eq %
 or  A0508 0 3 getinterval (AEc) eq or  A0508 0 3 getinterval (aec) eq or  A0508 0 3 getinterval (aEC) eq or  A0508 0 3 %
 getinterval (aeC) eq or  A0508 0 3 getinterval (AeC) eq or  A0508 0 3 getinterval (aEc) eq or  A0537 or  { %
(Sanction obtenue : )  show  10 A0146  A0508 A0072  346 47 moveto  10 A0148  (Trimestre de l'obtention : ) show  10 A0146  %
 A0507 A0259  10 A0148  }  {  A0498 not  {(Sanction recommandée : ) }  {(Sanctions recommandées : ) }ifelse  show  10 %
 A0146  A0508 A0072  A0498 not  {346 47 moveto }{336 47 moveto }ifelse  10 A0148  A0498 not  { %
(Trimestre de la recommandation : ) }  {(Trimestre des recommandations : ) }ifelse  show  10 A0146  A0507 A0259  10 A0148  %
 }ifelse  10 A0148  A0498 not  {346 77 moveto }{336 77 moveto }ifelse  A0498 not  {(Programme terminé : ) }  { %
(Programmes terminés : ) }ifelse  show  10 A0146  A0503 A0072  10 A0148  280 23 moveto  /A0538 (Date de délivrance : ) %
 A0506 A0150 def  A0538 280 33 300 0 (V) 0 0 0.2 1 1 0 0 A0085  30 95 A0473 2 eq  {15 add }if moveto  A0498 not  { %
(Code de programme : ) }  {(Codes des programmes : ) }ifelse  show  10 A0146  A0498 not  {A0493 A0259 }  {A0493 ( et ) %
 A0150 A0497 A0150 A0259 }ifelse  10 A0148  30 80 A0473 2 eq  {15 add }if moveto  (Régime d'études : )show  10 A0146  A0502 %
 A0259  10 A0148  30 65 A0473 2 eq  {15 add }if moveto  (Total des unités acquises au collégial : )show  10 A0146  A0501 %
 A0259  10 A0148  /A0539 0 def  A0509 (O) eq  {  /A0539 10 def  85 120 A0473 2 eq  {15 add }if moveto  /Souligne_pb500 (O) %
 def  10 A0146  (Programme complété en alternance travail-études) currentpoint 504 0 (V) 0 0 0.2 0 1 0 0 A0085  10 A0148  %
 /Souligne_pb500 (N) def  }if  /A0185 () def  /A0186 () def  /A0187 () def  /A0187 A0494 def  A0498  {  /A0187 A0187 ( et ) %
 A0150 def  /A0187 A0187 A0499 A0150 def  }if  A0495 () ne  {/A0187 A0187 (|) A0150 def  /A0187 A0187 A0495 A0150 def }if  %
 A0496 () ne  {/A0187 A0187 (|) A0150 def  /A0187 A0187 A0496 A0150 def }if  /A0077 1000 def  /A0076 1000 def  A0077 A0076 %
 moveto  0 1 A0187 length 1 sub  {  /A0305 exch def  A0187 A0305 1 getinterval (|) ne  {/A0186  A0186 A0187 A0305 1 %
 getinterval A0150 def  }  {A0186 A0077 A0076 A0063 add 490 0 (V) 0 0 0.2 0 1 0 0 A0085  /A0076 currentpoint exch pop def  %
 /A0076 A0076 10 sub def  A0077 A0076 moveto  /A0186 () def  }ifelse  }for  A0186 A0077 A0076 A0063 add 490 0 (V) 0 0 0.2 0 %
 1 0 0 A0085  /A0076 currentpoint exch pop def  /A0541 1000 A0076 sub 10 add def  /A0077 30 def  /A0076 100 A0539 add A0541 %
 add def  A0473 2 eq  {/A0076 A0076 15 add def }if  /A0542 A0076 def  A0077 A0076 moveto  A0498 not  {(Programme : ) }  { %
(Programmes : ) }ifelse  show  currentpoint pop  /A0077 exch def  10 A0146  /A0186 () def  0 1 A0187 length 1 sub  {  %
 /A0305 exch def  A0187 A0305 1 getinterval (|) ne  {/A0186  A0186 A0187 A0305 1 getinterval A0150 def  }  {A0186 A0077 %
 A0076 A0063 add 490 0 (V) 0 0 0.2 0 1 0 0 A0085  /A0076 currentpoint exch pop def  /A0076 A0076 10 sub def  A0077 A0076 %
 moveto  /A0186 () def  }ifelse  }for  A0186 A0077 A0076 A0063 add 490 0 (V) 0 0 0.2 0 1 0 0 A0085  20 20 moveto  572 0 %
 rlineto  0 A0542 rlineto  -572 0 rlineto  closepath  stroke  /A0542 A0542 37 add def  10 A0148  }bind def  %
 /Signature_dacs  { /A0544 exch def  /A0545 exch def  /A0546 exch def  /A0547 exch def  }bind def  /Signature_dacs_existe %
 false def  /Psigle  { /sigle_existe false def  /A0551 exch def  /A0552 exch def  /A0553 exch def  /A0554 exch def  /A0555 %
 exch def  }bind def  /A0556  {  /A0557 50 string def  /A0558 false def  currentsystemparams  {  exch A0557 cvs dup  %
(PrinterName) eq  {pop (LaserJet 5) eq  {/A0558 true def }  {/A0558 false def }ifelse }  {pop pop }ifelse  }forall  }bind %
 def  /TRAITER_ETUDIANT  {  /A0247 1000 def  A0574 not  {/A0560 false def  A0562 }  {clear }ifelse  }bind def  %
 /TRAITER_ETUDIANT_RETENTION  {  A0574 not  {/A0560 true def  A0562 }  {clear }ifelse  }bind def  /A0562  {  /A0245 0 def  %
 /A0498 false def  /A0220 false def  /A0425 (Rien) def  /A0134 2000 def  /Times-Roman-French findfont 10 scalefont setfont  %
 /A0563 -1 def  /A0558 false def  A0556  count A0621 1 add sub  /A0563 exch def  /A0564 5000 dict def  /A0565 -1 def  %
 /A0566 100 dict def  true A0426  A0556  A0558 not  {  A0472 (O) eq  {<< /Duplex true >> setpagedevice }  {<< /Duplex false %
 >> setpagedevice }ifelse  }if  false A0426  }bind def  clear  /A0317 false def  /A0568 false def  /A0209 false def  /A0303 %
 0 def  /A0569 0 def  /A0570 1000 dict def  /A0571 (Vide) def  /A0572 false def  /A0573 7 string def  /A0574 false def  %
 /A0217 0 def  /A0077 0 def  /A0076 0 def  /A0575 103 def  /A0314 false def  /A0576 () def  /A0577 750 def  /A0578 20 def  %
 /A0579 658 def  /A0580 65 def  /A0581 400 def  /A0582 675 def  /A0583 121.9 def  /A0584 47 def  /Souligne_pb500 (N) def  %
 /A0585 7 def  /A0586 6 def  /A0587 7 def  /A0588 7 def  /A0589 6 def  /A0590 9 def  /A0591 6 def  /A0592 4 def  /A0593 5 %
 def  /A0282 0 def  /A0212 false def  /A0367 false def  /A0374 false def  /A0199 false def
 /lys <  ffffffffff8fffffffffff
 ffffffffff07ffffffffff  fffffffffe03ffffffffff  fffffffffe03ffffffffff  fffffffffc01ffffffffff  fffffffffc01ffffffffff
 fffffffffc01ffffffffff  fffffffff800ffffffffff  fffffffff800ffffffffff  fffffffff800ffffffffff  fffffffe000001ffffffff
 fffffffc000000ffffffff  fffffff80000007fffffff  fffffff00000003fffffff  ffffffff800007ffffffff  ffffffffc0000fffffffff
 ffffffffe0001fffffffff  fffffffff0003fffffffff  fffffffff8007fffffffff  fffffffff8007fffffffff  fffffffffc00ffffffffff
 fffffffffc00ffffffffff  fffff000000000007fffff  fffff000000000007fffff  fffff000000000007fffff  fffff000000000007fffff
 fffff000000000007ffffe  fffff000000000007ffffe  fffff000000000007ffffe  fffff000000000007ffffe  fffffffe0f03c1fffffffe
 fffffffe0f03c1fffffffe  fffffffe0f03c1ffffffff  ff8ffffe0f03c1ffffe3ff  ff0ffffe0f03c1ffffe1ff  fe0ffffe0f03c1ffffe0ff
 fc0ffffc0f03c0ffffe07f  f807fffc1f03e0ffffc03e  f007fff81f03e07fffc03e  f003fff81f03e07fff801f  e003fff01f03e03fff801e
 e000ffe01f03e01ffe001f  e0007fc03f03f00ffc000f  c0001e003e01f001e0000f  c00000003e01f00000000f  c00000007e01f00000000f
 c00000007e01f00000000f  c00000007e01f80000000f  c00000007c00f80000000f  c0000000fc00f80000000f  c0000000fc00fc0000001f
 e0000001fc00fc0000001f  e0000001f8007e0000003f  e0000003f8007f0000003f  f0000007f8007f0000007f  f0000007f0003f8000007f
 f800000ff0003fc00000ff  fc00001fe0003fe00001ff  fe00003fe0001ff00007ff  ff8000ffc0001ffc000fff  ffe001ffc0000fff007fff
 fffc07ffc0000fffffffff  ffffffff800007ffffffff  ffffffff800007fffffffe  ffffffff000003fffffffe  ffffffff000003ffffffff
 ffffffff000003ffffffff  fffffffe000001ffffffff  fffffffe000001ffffffff  fffffffe000001ffffffff  fffffffe000001ffffffff
 fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff
 fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff  fffffffc000000ffffffff
 fffffffe000001ffffffff  fffffffe000001ffffffff  fffffffe000001ffffffff  ffffffff000003ffffffff  ffffffff000003ffffffff
 ffffffff800007ffffffff  ffffffffc0000fffffffff  ffffffffc0000fffffffff  ffffffffe0001fffffffff  fffffffff0003fffffffff
 fffffffff0003fffffffff  fffffffff8007fffffffff  fffffffffc00ffffffffff  fffffffffe01ffffffffff  fffffffffe01ffffffffff
 ffffffffff03fffffffffe  ffffffffff87fffffffffe  ffffffffffcfffffffffff> def
 /A0595  {  /A0596 exch def  /A0597 exch def  %
 .85 setgray  10 782 moveto  602 782 lineto  602 10 lineto  10 10 lineto  closepath  fill  0 setgray  602 782 moveto  599 %
 782 lineto  599 10 lineto  602 10 lineto  closepath  fill  10 782 moveto  602 782 lineto  602 779 lineto  10 779 lineto  %
 closepath  fill  10 10 moveto  602 10 lineto  602 13 lineto  10 13 lineto  closepath  fill  10 10 moveto  10 782 lineto  %
 13 782 lineto  13 10 lineto  closepath  fill  .50 setgray  17 741 moveto  594 741 lineto  594 735 lineto  17 735 lineto  %
 closepath  fill  0 setgray  /Times-Bold-French findfont 18 scalefont setfont   %
(LISTE DES MESSAGES D'ERREURS - IMPRESSION BULLETIN)  20 770 570 5 (V) 0 0 0.5 2 1 0 0 A0085  /Times-Roman-French findfont %
 15 scalefont setfont  A0596 20 700 570 15 (V) 0 0 0.5 2 0.80 5 .50 A0085  showpage  A0597  {/A0574 true def }if  }bind %
 def  /CHARGER_COLLEGES  {/A0571 (CHARGER) def A0610 }bind def  /INITIALISER_PILE  {/A0571 (PILE) def A0610 }bind def  %
 /A0600  {  /A0601 2 string def  /A0177 7 string def  /A0602 1 def  {  /A0603 A0602 A0177 cvs A0619 A0150 def  A0570 A0603 %
 known  {  /A0602 A0602 1 add def  }  {  exit  }ifelse  }loop  A0602 A0601 cvs  }bind def  /A0604  {  /A0605 exch def  %
 /A0606 exch def  /A0607 true def  A0605 () ne  A0605 (0000-00-00) ne and  {  A0605 length 10 eq  {  (12) A0605 0 1 %
 getinterval search  {pop pop pop true }{pop false }ifelse  (09) A0605 1 1 getinterval search  {pop pop pop true }{pop %
 false }ifelse  and  (0123456789) A0605 2 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  (0123456789) %
 A0605 3 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  (-) A0605 4 1 getinterval search  {pop pop pop %
 true }{pop false }ifelse  and  (01) A0605 5 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  (0123456789) %
 A0605 6 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  (-) A0605 7 1 getinterval search  {pop pop pop %
 true }{pop false }ifelse  and  (0123) A0605 8 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  (0123456789) %
 A0605 9 1 getinterval search  {pop pop pop true }{pop false }ifelse  and  {false }{true }ifelse  }  {true  }ifelse  A0605 %
 length 10 ne or  {  /A0576  A0576 ( La Date ) A0150  A0606 A0150  ( \() A0150  A0606 (d'ouverture) eq  {A0608 A0150 }  %
 {A0609 A0150 }ifelse  (\)) A0150  ( pour le collège ) A0150  A0619 A0150  ( \() A0150  A0620 A0150  (\)) A0150   %
( ne correspond pas au format \(AAAA-MM-JJ\) ou est hors limite.) A0150  ( Par conséquent la date ) A0150  A0606 A0150   %
( a été assignée à ) A0150  A0606 (d'ouverture) eq  {(1967-01-01. )  /A0608 () def  }  {(2066-12-31. )  /A0609 () def  %
 }ifelse  A0150  def  /A0607 false def  }if  }if  A0607  }bind def  /A0610  {  /A0576 () def  /A0611 0 def  /A0612 false %
 def  /A0613 (==SECTION TABLE COLLEGE) def  A0571 (CHARGER) eq  {/A0570 1000 dict def }if  A0571 (PILE) eq A0572 not and  %
 {/A0570 1000 dict def }if  /A0614 false def  /A0615 count 1 sub def  1 1 A0615 1 sub  {/A0616 exch def  /A0616 A0615 A0616 %
 sub 1 add def  A0616 1 roll }for  /A0615 count 1 sub def  /A0617 0 def  /A0618 () def  1 1 A0615  {/A0616 exch def  /A0318 %
 exch def  A0318 (==COLLEGE) eq  {  /A0619 exch 6 (0) A0157 def  /A0620 exch def  /A0608 exch def  /A0608 A0608 A0284 def   %
(d'ouverture) A0608 A0604  A0608 () ne and  {/A0608  A0608 0 4 getinterval  A0608 5 2 getinterval A0150  A0608 8 2 %
 getinterval A0150  def  }if  /A0609 exch def  /A0609 A0609 A0284 def  (de fermeture) A0609 A0604  A0609 () ne and  %
 {/A0609  A0609 0 4 getinterval  A0609 5 2 getinterval A0150  A0609 8 2 getinterval A0150  def  }if  /A0617 A0617 4 add %
 def  A0608 () eq  A0608 (00000000) eq or  {/A0608 (19670101) def }if  A0609 () eq  A0609 (00000000) eq or  {/A0609  %
(20661231) def }if  /A0618 A0619 def  /A0618 A0600 A0618 A0150 def  A0570 A0618 A0620 A0608 A0150  A0609 A0150 put  }if  %
 A0616 A0617 add A0615 ge  {exit }if  }for  A0576 () ne  {false A0576 A0595 }if  /A0621 6 def  clear  save  0  0  0  0  0  %
 A0621 -1 roll  A0614  {true (LE CODE DE COLLÈGE ") A0619 A0150  (" N'EST PAS UN CODE DE COLLÈGE VALIDE DANS SOBEC.) A0150   %
( VEUILLEZ CORRIGER VOS DONNÉES S'IL-VOUS-PLAÎT.) A0150  A0595 }if  /A0572 true def  }bind def %



/Psigle{ gsave 
        /sigle_existe true def 
  /uuu exch def 
   /www exch def 
   /xxx exch def 
        /zzz exch def 
        /yyy exch def 
        zzz 600 gt { Psigle_1 } 
                   { Psigle_2 }ifelse 
        grestore 
       }bind def 
%---------------------------------------------------------- 
% Ici on insère entre les accolades le sigle qui sera 
% imprimé en haut à gauche de la première page du bulletin. 
% 
/Psigle_1 { 

% Mettre ici le code postscript du sigle imprimé en haut à gauche. 


%%BoundingBox: 9 717 62 756 
%%LanguageLevel: 2
%%Creator: CorelDRAW
%%Title: gESJ.eps
%%CreationDate: Wed Aug 29 10:45:21 2012
%%DocumentProcessColors: Cyan Magenta Yellow Black 
%%DocumentSuppliedResources: (atend)
%%EndComments
%%BeginProlog
/AutoFlatness false def
/AutoSteps 0 def
/CMYKMarks true def
/UseLevel 2 def
%Build: CorelDRAW Version 14.0.0.567
%Color profile:  Generic offset separations profile
/CorelIsEPS true def
%%BeginResource: procset wCorel14Dict 14.0 0
/wCorel14Dict 300 dict def wCorel14Dict begin
% Copyright (c)1992-2007 Corel Corporation
% All rights reserved.     v14 r0.0
/bd{bind def}bind def/ld{load def}bd/xd{exch def}bd/_ null def/rp{{pop}repeat}
bd/@cp/closepath ld/@gs/gsave ld/@gr/grestore ld/@np/newpath ld/Tl/translate ld
/$sv 0 def/@sv{/$sv save def}bd/@rs{$sv restore}bd/spg/showpage ld/showpage{}
bd currentscreen/@dsp xd/$dsp/@dsp def/$dsa xd/$dsf xd/$sdf false def/$SDF
false def/$Scra 0 def/SetScr/setscreen ld/@ss{2 index 0 eq{$dsf 3 1 roll 4 -1
roll pop}if exch $Scra add exch load SetScr}bd/SepMode_5 where{pop}{/SepMode_5
0 def}ifelse/CorelIsSeps where{pop}{/CorelIsSeps false def}ifelse
/CorelIsInRIPSeps where{pop}{/CorelIsInRIPSeps false def}ifelse/CorelIsEPS
where{pop}{/CorelIsEPS false def}ifelse/CurrentInkName_5 where{pop}
{/CurrentInkName_5(Composite)def}ifelse/$ink_5 where{pop}{/$ink_5 -1 def}
ifelse/fill_color 6 array def/num_fill_inks 1 def/$o 0 def/$fil 0 def
/outl_color 6 array def/num_outl_inks 1 def/$O 0 def/$PF false def/$bkg false
def/$op false def matrix currentmatrix/$ctm xd/$ptm matrix def/$ttm matrix def
/$stm matrix def/$ffpnt true def/CorelDrawReencodeVect[16#0/grave 16#5/breve
16#6/dotaccent 16#8/ring 16#A/hungarumlaut 16#B/ogonek 16#C/caron 16#D/dotlessi
16#27/quotesingle 16#60/grave 16#7C/bar 16#80/Euro
16#82/quotesinglbase/florin/quotedblbase/ellipsis/dagger/daggerdbl
16#88/circumflex/perthousand/Scaron/guilsinglleft/OE
16#91/quoteleft/quoteright/quotedblleft/quotedblright/bullet/endash/emdash
16#98/tilde/trademark/scaron/guilsinglright/oe 16#9F/Ydieresis
16#A1/exclamdown/cent/sterling/currency/yen/brokenbar/section
16#a8/dieresis/copyright/ordfeminine/guillemotleft/logicalnot/minus/registered/macron
16#b0/degree/plusminus/twosuperior/threesuperior/acute/mu/paragraph/periodcentered
16#b8/cedilla/onesuperior/ordmasculine/guillemotright/onequarter/onehalf/threequarters/questiondown
16#c0/Agrave/Aacute/Acircumflex/Atilde/Adieresis/Aring/AE/Ccedilla
16#c8/Egrave/Eacute/Ecircumflex/Edieresis/Igrave/Iacute/Icircumflex/Idieresis
16#d0/Eth/Ntilde/Ograve/Oacute/Ocircumflex/Otilde/Odieresis/multiply
16#d8/Oslash/Ugrave/Uacute/Ucircumflex/Udieresis/Yacute/Thorn/germandbls
16#e0/agrave/aacute/acircumflex/atilde/adieresis/aring/ae/ccedilla
16#e8/egrave/eacute/ecircumflex/edieresis/igrave/iacute/icircumflex/idieresis
16#f0/eth/ntilde/ograve/oacute/ocircumflex/otilde/odieresis/divide
16#f8/oslash/ugrave/uacute/ucircumflex/udieresis/yacute/thorn/ydieresis]def
/get_ps_level/languagelevel where{pop systemdict/languagelevel get exec}{1
}ifelse def/level2 get_ps_level 2 ge def/level3 get_ps_level 3 ge def
/is_distilling{/product where{pop systemdict/setdistillerparams known product
(Adobe PostScript Parser)ne and}{false}ifelse}bd/is_rip_separation{
is_distilling{false}{level2{currentpagedevice/Separations 2 copy known{get}{
pop pop false}ifelse}{false}ifelse}ifelse}bd/is_current_sep_color{
is_separation{gsave false setoverprint 1 1 1 1 5 -1 roll findcmykcustomcolor 1
setcustomcolor currentgray 0 eq grestore}{pop false}ifelse}bd
/get_sep_color_index{dup length 1 sub 0 1 3 -1 roll{dup 3 -1 roll dup 3 -1 roll
get is_current_sep_color{exit}{exch pop}ifelse}for pop -1}bd/is_separation{
/LumSepsDict where{pop false}{/AldusSepsDict where{pop false}{
is_rip_separation{true}{1 0 0 0 gsave setcmykcolor currentcmykcolor grestore
add add add 0 ne 0 1 0 0 gsave setcmykcolor currentcmykcolor grestore add add
add 0 ne 0 0 1 0 gsave setcmykcolor currentcmykcolor grestore add add add 0 ne
0 0 0 1 gsave setcmykcolor currentcmykcolor grestore add add add 0 ne and and
and not}ifelse}ifelse}ifelse}bind def/is_composite{is_separation not
is_distilling or}bd/is_sim_devicen{level2 level3 not and{is_distilling
is_rip_separation or}{false}ifelse}bd/@PL{/LV where{pop LV 2 ge level2 not and
{@np/Courier findfont 12 scalefont setfont 72 144 m
(The PostScript level set in the Corel application is higher than)show 72 132 m
(the PostScript level of this device. Change the PS Level in the Corel)show 72
120 m(application to Level 1 by selecting the PostScript tab in the print)show
72 108 m(dialog, and selecting Level 1 from the Compatibility drop down list.)
show flush spg quit}if}if}bd/@BeginSysCorelDict{systemdict/Corel30Dict known
{systemdict/Corel30Dict get exec}if systemdict/CorelLexDict known{1 systemdict
/CorelLexDict get exec}if}bd/@EndSysCorelDict{systemdict/Corel30Dict known
{end}if/EndCorelLexDict where{pop EndCorelLexDict}if}bd AutoFlatness{/@ifl{dup
currentflat exch sub 10 gt{
([Error: PathTooComplex; OffendingCommand: AnyPaintingOperator]\n)print flush
@np exit}{currentflat 2 add setflat}ifelse}bd/@fill/fill ld/fill{currentflat{
{@fill}stopped{@ifl}{exit}ifelse}bind loop setflat}bd/@eofill/eofill ld/eofill
{currentflat{{@eofill}stopped{@ifl}{exit}ifelse}bind loop setflat}bd/@clip
/clip ld/clip{currentflat{{@clip}stopped{@ifl}{exit}ifelse}bind loop setflat}
bd/@eoclip/eoclip ld/eoclip{currentflat{{@eoclip}stopped{@ifl}{exit}ifelse}
bind loop setflat}bd/@stroke/stroke ld/stroke{currentflat{{@stroke}stopped
{@ifl}{exit}ifelse}bind loop setflat}bd}if level2{/@ssa{true setstrokeadjust}
bd}{/@ssa{}bd}ifelse/d/setdash ld/j/setlinejoin ld/J/setlinecap ld/M
/setmiterlimit ld/w/setlinewidth ld/O{/$o xd}bd/R{/$O xd}bd/W/eoclip ld/c
/curveto ld/C/c ld/l/lineto ld/L/l ld/rl/rlineto ld/m/moveto ld/n/newpath ld/N
/newpath ld/P{11 rp}bd/u{}bd/U{}bd/A{pop}bd/q/@gs ld/Q/@gr ld/&{}bd/@j{@sv @np}
bd/@J{@rs}bd/g{1 exch sub 0 0 0 1 null 1 set_fill_color/$fil 0 def}bd/G{1 sub
neg 0 0 0 1 null 1 set_outline_color}bd/set_fill_color{/fill_color exch def
/num_fill_inks fill_color length 6 idiv def/bFillDeviceN num_fill_inks 1 gt def
/$fil 0 def}bd/set_outline_color{/outl_color exch def/num_outl_inks outl_color
length 6 idiv def/bOutlDeviceN num_outl_inks 1 gt def}bd
/get_devicen_color_names{dup length 6 idiv dup 5 mul exch getinterval}bd
/create_colorarray_from_devicen_params{/ink_names_temp exch def
/tint_params_temp exch def/ink_values_temp exch def[ink_values_temp aload pop
tint_params_temp aload pop ink_names_temp aload pop]}bd
/get_devicen_color_specs{dup length 6 idiv dup 4 mul getinterval}bd
/get_devicen_color{dup length 6 idiv 0 exch getinterval}bd/mult_devicen_color{
/colorarray exch def/mult_vals exch def 0 1 mult_vals length 1 sub{colorarray
exch dup mult_vals exch get exch dup colorarray exch get 3 -1 roll mul put}for
colorarray}bd/combine_devicen_colors{/colorarray2 exch def/colorarray1 exch def
/num_inks1 colorarray1 length 6 idiv def/num_inks2 colorarray2 length 6 idiv
def/num3 0 def/colorarray3[num_inks1 num_inks2 add 6 mul{0}repeat]def 0 1
num_inks1 1 sub{colorarray1 exch get colorarray3 num3 3 -1 roll put/num3 num3 1
add def}for 0 1 num_inks2 1 sub{colorarray2 exch get colorarray3 num3 3 -1 roll
put/num3 num3 1 add def}for colorarray1 num_inks1 dup 4 mul getinterval
colorarray3 num3 3 -1 roll putinterval/num3 num3 num_inks1 4 mul add def
colorarray2 num_inks2 dup 4 mul getinterval colorarray3 num3 3 -1 roll
putinterval/num3 num3 num_inks2 4 mul add def colorarray1 num_inks1 dup 5 mul
exch getinterval colorarray3 num3 3 -1 roll putinterval/num3 num3 num_inks1 add
def colorarray2 num_inks2 dup 5 mul exch getinterval colorarray3 num3 3 -1 roll
putinterval/num3 num3 num_inks2 add def colorarray3}bd/get_devicen_color_spec{
/colorant_index exch def/colorarray exch def/ncolorants colorarray length 6
idiv def[colorarray colorant_index get colorarray ncolorants colorant_index 4
mul add 4 getinterval aload pop colorarray ncolorants 5 mul colorant_index add
get]}bd/set_devicen_color{level3{/colorarray exch def/numcolorants colorarray
length 6 idiv def colorarray get_devicen_color_specs/tint_params exch def[
/DeviceN colorarray get_devicen_color_names/DeviceCMYK{tint_params
CorelTintTransformFunction}]setcolorspace colorarray get_devicen_color aload
pop setcolor}{/DeviceCMYK setcolorspace devicen_to_cmyk aload pop pop @tc_5
setprocesscolor_5}ifelse}bd/sf{/bmp_fill_fg_color xd}bd/i{dup 0 ne{setflat}
{pop}ifelse}bd/v{4 -2 roll 2 copy 6 -2 roll c}bd/V/v ld/y{2 copy c}bd/Y/y ld
/@w{matrix rotate/$ptm xd matrix scale $ptm dup concatmatrix/$ptm xd 1 eq{$ptm
exch dup concatmatrix/$ptm xd}if 1 w}bd/@g{1 eq dup/$sdf xd{/$scp xd/$sca xd
/$scf xd}if}bd/@G{1 eq dup/$SDF xd{/$SCP xd/$SCA xd/$SCF xd}if}bd/@D{2 index 0
eq{$dsf 3 1 roll 4 -1 roll pop}if 3 copy exch $Scra add exch load SetScr/$dsp
xd/$dsa xd/$dsf xd}bd/$ngx{$SDF{$SCF SepMode_5 0 eq{$SCA}{$dsa}ifelse $SCP @ss
}if}bd/@MN{2 copy le{pop}{exch pop}ifelse}bd/@MX{2 copy ge{pop}{exch pop}
ifelse}bd/InRange{3 -1 roll @MN @MX}bd/@sqr{dup 0 rl dup 0 exch rl neg 0 rl @cp
}bd/currentscale{1 0 dtransform matrix defaultmatrix idtransform dup mul exch
dup mul add sqrt 0 1 dtransform matrix defaultmatrix idtransform dup mul exch
dup mul add sqrt}bd/@unscale{}bd/wDstChck{2 1 roll dup 3 -1 roll eq{1 add}if}
bd/@dot{dup mul exch dup mul add 1 exch sub}bd/@lin{exch pop abs 1 exch sub}bd
/cmyk2rgb{3{dup 5 -1 roll add 1 exch sub dup 0 lt{pop 0}if exch}repeat pop}bd
/rgb2cmyk{3{1 exch sub 3 1 roll}repeat 3 copy @MN @MN 3{dup 5 -1 roll sub neg
exch}repeat}bd/rgb2g{2 index .299 mul 2 index .587 mul add 1 index .114 mul add
4 1 roll pop pop pop}bd/devicen_to_cmyk{/convertcolor exch def convertcolor
get_devicen_color aload pop convertcolor get_devicen_color_specs
CorelTintTransformFunction}bd/WaldoColor_5 where{pop}{/SetRgb/setrgbcolor ld
/GetRgb/currentrgbcolor ld/SetGry/setgray ld/GetGry/currentgray ld/SetRgb2
systemdict/setrgbcolor get def/GetRgb2 systemdict/currentrgbcolor get def
/SetHsb systemdict/sethsbcolor get def/GetHsb systemdict/currenthsbcolor get
def/rgb2hsb{SetRgb2 GetHsb}bd/hsb2rgb{3 -1 roll dup floor sub 3 1 roll SetHsb
GetRgb2}bd/setcmykcolor where{pop/LumSepsDict where{pop/SetCmyk_5{LumSepsDict
/setcmykcolor get exec}def}{/AldusSepsDict where{pop/SetCmyk_5{AldusSepsDict
/setcmykcolor get exec}def}{/SetCmyk_5/setcmykcolor ld}ifelse}ifelse}{
/SetCmyk_5{cmyk2rgb SetRgb}bd}ifelse/currentcmykcolor where{pop/GetCmyk
/currentcmykcolor ld}{/GetCmyk{GetRgb rgb2cmyk}bd}ifelse/setoverprint where
{pop}{/setoverprint{/$op xd}bd}ifelse/currentoverprint where{pop}{
/currentoverprint{$op}bd}ifelse/@tc_5{5 -1 roll dup 1 ge{pop}{4{dup 6 -1 roll
mul exch}repeat pop}ifelse}bd/@trp{exch pop 5 1 roll @tc_5}bd
/setprocesscolor_5{SepMode_5 0 eq{SetCmyk_5}{SepsColor not{4 1 roll pop pop pop
1 exch sub SetGry}{SetCmyk_5}ifelse}ifelse}bd/findcmykcustomcolor where{pop}{
/findcmykcustomcolor{5 array astore}bd}ifelse/Corelsetcustomcolor_exists false
def/setcustomcolor where{pop/Corelsetcustomcolor_exists true def}if CorelIsSeps
true eq CorelIsInRIPSeps false eq and{/Corelsetcustomcolor_exists false def}if
Corelsetcustomcolor_exists false eq{/setcustomcolor{exch aload pop SepMode_5 0
eq{pop @tc_5 setprocesscolor_5}{CurrentInkName_5 eq{4 index}{0}ifelse 6 1 roll
5 rp 1 sub neg SetGry}ifelse}bd}if/@scc_5{dup type/booleantype eq{dup
currentoverprint ne{setoverprint}{pop}ifelse}{1 eq setoverprint}ifelse dup _ eq
{pop setprocesscolor_5 pop}{dup(CorelRegistrationColor)eq{5 rp 1 exch sub
setregcolor}{findcmykcustomcolor exch setcustomcolor}ifelse}ifelse SepMode_5 0
eq{true}{GetGry 1 eq currentoverprint and not}ifelse}bd/colorimage where{pop
/ColorImage{colorimage}def}{/ColorImage{/ncolors xd/$multi xd $multi true eq{
ncolors 3 eq{/daqB xd/daqG xd/daqR xd pop pop exch pop abs{daqR pop daqG pop
daqB pop}repeat}{/daqK xd/daqY xd/daqM xd/daqC xd pop pop exch pop abs{daqC pop
daqM pop daqY pop daqK pop}repeat}ifelse}{/dataaq xd{dataaq ncolors dup 3 eq{
/$dat xd 0 1 $dat length 3 div 1 sub{dup 3 mul $dat 1 index get 255 div $dat 2
index 1 add get 255 div $dat 3 index 2 add get 255 div rgb2g 255 mul cvi exch
pop $dat 3 1 roll put}for $dat 0 $dat length 3 idiv getinterval pop}{4 eq{
/$dat xd 0 1 $dat length 4 div 1 sub{dup 4 mul $dat 1 index get 255 div $dat 2
index 1 add get 255 div $dat 3 index 2 add get 255 div $dat 4 index 3 add get
255 div cmyk2rgb rgb2g 255 mul cvi exch pop $dat 3 1 roll put}for $dat 0 $dat
length ncolors idiv getinterval}if}ifelse}image}ifelse}bd}ifelse/setcmykcolor{
1 5 1 roll null 6 array astore currentoverprint set_current_color/$ffpnt xd}bd
/currentcmykcolor{GetCmyk}bd/setrgbcolor{rgb2cmyk setcmykcolor}bd
/currentrgbcolor{currentcmykcolor cmyk2rgb}bd/sethsbcolor{hsb2rgb setrgbcolor}
bd/currenthsbcolor{currentrgbcolor rgb2hsb}bd/setgray{dup dup setrgbcolor}bd
/currentgray{currentrgbcolor rgb2g}bd/InsideDCS false def/IMAGE/image ld/image
{InsideDCS{IMAGE}{/EPSDict where{pop SepMode_5 0 eq{IMAGE}{dup type/dicttype eq
{dup/ImageType get 1 ne{IMAGE}{dup dup/BitsPerComponent get 8 eq exch
/BitsPerComponent get 1 eq or currentcolorspace 0 get/DeviceGray eq and{
CurrentInkName_5(Black)eq{IMAGE}{dup/DataSource get/TCC xd/Height get abs{TCC
pop}repeat}ifelse}{IMAGE}ifelse}ifelse}{2 index 1 ne{CurrentInkName_5(Black)eq
{IMAGE}{/TCC xd pop pop exch pop abs{TCC pop}repeat}ifelse}{IMAGE}ifelse}
ifelse}ifelse}{IMAGE}ifelse}ifelse}bd}ifelse/WaldoColor_5 true def
/WaldoColor_13 where{pop}{/separate_color{SepMode_5 0 ne{[exch/colorarray_sep
exch def/ink_num -1 def colorarray_sep length 6 idiv 1 gt{colorarray_sep
get_devicen_color_names dup length 1 sub 0 1 3 -1 roll{exch dup 3 -1 roll dup 3
1 roll get CurrentInkName_5 eq{/ink_num exch def}{pop}ifelse}for pop ink_num -1
ne{colorarray_sep ink_num get_devicen_color_spec aload pop pop SepsColor not{
pop pop pop pop 1 0 0 0 5 -1 roll}if null}{0 0 0 0 0 null}ifelse}{
colorarray_sep 5 get $ink_5 4 eq{CurrentInkName_5 eq{colorarray_sep aload pop
pop SepsColor not{pop pop pop pop 0 0 0 1}if null}{0 0 0 0 0 null}ifelse}{
colorarray_sep 0 get colorarray_sep $ink_5 1 add get 3 -1 roll null eq{0 0 0 4
-1 roll SepsColor{4 $ink_5 1 add roll}if null}{pop pop 0 0 0 0 0 null}ifelse
}ifelse}ifelse]}if}bd/separate_cmyk_color{$ink_5 -1 ne{[exch aload pop 3 $ink5
sub index/colorarray_sep exch def/ink_num -1 def colorarray_sep
get_devicen_color_names dup length 1 sub 0 1 3 -1 roll{exch dup 3 -1 roll dup 3
1 roll get CurrentInkName_5 eq{/ink_num exch def}{pop}ifelse}for pop ink_num -1
ne{[colorarray_sep ink_num get_devicen_color_spec aload pop]}{[0 0 0 0 0 null]
}ifelse}if}bd/set_current_color{dup type/booleantype eq{dup currentoverprint ne
{setoverprint}{pop}ifelse}{1 eq setoverprint}ifelse/cur_color exch def
/nNumColors cur_color length 6 idiv def nNumColors 1 eq{cur_color 5 get
(CorelRegistrationColor)eq{cur_color aload pop 5 rp 1 exch sub setregcolor}{
SepMode_5 0 eq{cur_color aload pop dup null eq{pop @tc_5 setprocesscolor_5}{
findcmykcustomcolor exch setcustomcolor}ifelse}{cur_color separate_color aload
pop pop @tc_5 setprocesscolor_5}ifelse}ifelse}{SepMode_5 0 eq{is_distilling
is_rip_separation or{cur_color set_devicen_color}{cur_color devicen_to_cmyk
setprocesscolor_5}ifelse}{cur_color separate_color aload pop pop @tc_5
setprocesscolor_5}ifelse}ifelse SepMode_5 0 eq{true}{GetGry 1 eq
currentoverprint and not}ifelse}bd}ifelse/WaldoColor_13 true def/$fm 0 def
/wfill{1 $fm eq{fill}{eofill}ifelse}bd/@Pf{@sv SepMode_5 0 eq $Psc 0 ne or
$ink_5 3 eq or{0 J 0 j[]0 d fill_color $o set_current_color pop $ctm setmatrix
72 1000 div dup matrix scale dup concat dup Bburx exch Bbury exch itransform
ceiling cvi/Bbury xd ceiling cvi/Bburx xd Bbllx exch Bblly exch itransform
floor cvi/Bblly xd floor cvi/Bbllx xd $Prm aload pop $Psn load exec}{1 SetGry
wfill}ifelse @rs @np}bd/F{matrix currentmatrix $sdf{$scf $sca $scp @ss}if $fil
1 eq{CorelPtrnDoFill}{$fil 2 eq{@ff}{$fil 3 eq{@Pf}{level3{fill_color $o
set_current_color{wfill}{@np}ifelse}{/overprint_flag $o def is_distilling
is_rip_separation or{0 1 num_fill_inks 1 sub{dup 0 gt{/overprint_flag true def
}if fill_color exch get_devicen_color_spec overprint_flag set_current_color{
@gs wfill @gr}{@np exit}ifelse}for}{fill_color overprint_flag set_current_color
{@gs wfill @gr}{@np}ifelse}ifelse}ifelse}ifelse}ifelse}ifelse $sdf{$dsf $dsa
$dsp @ss}if setmatrix}bd/f{@cp F}bd/S{matrix currentmatrix $ctm setmatrix $SDF
{$SCF $SCA $SCP @ss}if level3{outl_color $O set_current_color{matrix
currentmatrix $ptm concat stroke setmatrix}{@np}ifelse}{/overprint_flag $O def
is_distilling is_rip_separation or{0 1 num_outl_inks 1 sub{dup 0 gt{
/overprint_flag true def}if outl_color exch get_devicen_color_spec
overprint_flag set_current_color{matrix currentmatrix $ptm concat @gs stroke
@gr setmatrix}{@np exit}ifelse}for}{outl_color overprint_flag set_current_color
{matrix currentmatrix $ptm concat @gs stroke @gr setmatrix}{@np}ifelse}ifelse
}ifelse $SDF{$dsf $dsa $dsp @ss}if setmatrix}bd/s{@cp S}bd/B{@gs F @gr S}bd/b{
@cp B}bd/_E{5 array astore exch cvlit xd}bd/@cc{currentfile $dat readhexstring
pop}bd/@sm{/$ctm $ctm currentmatrix def}bd/@E{/Bbury xd/Bburx xd/Bblly xd
/Bbllx xd}bd/@c{@cp}bd/@P{/$fil 3 def/$Psn xd/$Psc xd array astore/$Prm xd}bd
/tcc{@cc}def/@B{@gs S @gr F}bd/@b{@cp @B}bd/@sep{CurrentInkName_5(Composite)eq
{/$ink_5 -1 def}{CurrentInkName_5(Cyan)eq{/$ink_5 0 def}{CurrentInkName_5
(Magenta)eq{/$ink_5 1 def}{CurrentInkName_5(Yellow)eq{/$ink_5 2 def}{
CurrentInkName_5(Black)eq{/$ink_5 3 def}{/$ink_5 4 def}ifelse}ifelse}ifelse}
ifelse}ifelse}bd/@whi{@gs -72000 dup m -72000 72000 l 72000 dup l 72000 -72000
l @cp 1 SetGry fill @gr}bd/@neg{[{1 exch sub}/exec cvx currenttransfer/exec
cvx]cvx settransfer @whi}bd/deflevel 0 def/@sax{/deflevel deflevel 1 add def}
bd/@eax{/deflevel deflevel dup 0 gt{1 sub}if def deflevel 0 gt{/eax load}{eax}
ifelse}bd/eax{{exec}forall}bd/@rax{deflevel 0 eq{@rs @sv}if}bd systemdict
/pdfmark known not{/pdfmark/cleartomark ld}if/wclip{1 $fm eq{clip}{eoclip}
ifelse}bd level2{/setregcolor{/neg_flag exch def[/Separation/All/DeviceCMYK{
dup dup dup}]setcolorspace 1.0 neg_flag sub setcolor}bd}{/setregcolor{1 exch
sub dup dup dup setcmykcolor}bd}ifelse/CorelTintTransformFunction{
/colorantSpecArray exch def/nColorants colorantSpecArray length 4 idiv def
/inColor nColorants 1 add 1 roll nColorants array astore def/outColor 4 array
def 0 1 3{/nOutInk exch def 1 0 1 nColorants 1 sub{dup inColor exch get exch 4
mul nOutInk add colorantSpecArray exch get mul 1 exch sub mul}for 1 exch sub
outColor nOutInk 3 -1 roll put}for outColor aload pop}bind def
% Copyright (c)1992-2007 Corel Corporation
% All rights reserved.     v14 r0.0
/@ii{concat 3 index 3 index m 3 index 1 index l 2 copy l 1 index 3 index l 3
index 3 index l clip pop pop pop pop}bd/@i{@sm @gs @ii 6 index 1 ne{/$frg true
def pop pop}{1 eq{bmp_fill_fg_color $O set_current_color/$frg xd}{/$frg false
def}ifelse 1 eq{@gs $ctm setmatrix F @gr}if}ifelse @np/$ury xd/$urx xd/$lly xd
/$llx xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul 8 div ceiling cvi string
def $bkg $frg or{$SDF{$SCF $SCA $SCP @ss}if $llx $lly Tl $urx $llx sub $ury
$lly sub scale $bkg{fill_color set_current_color pop}if $wid $hei abs $bts 1 eq
{$bkg}{$bts}ifelse[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse]/tcc load $bts
1 eq{imagemask}{image}ifelse $SDF{$dsf $dsa $dsp @ss}if}{$hei abs{tcc pop}
repeat}ifelse @gr $ctm setmatrix}bd/@I{@sm @gs @ii @np/$ury xd/$urx xd/$lly xd
/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd $ngx $llx $lly Tl $urx $llx sub $ury
$lly sub scale $wid $hei abs $bts[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse
]/$dat $wid $bts mul $ncl mul 8 div ceiling cvi string def $msimage false eq
$ncl 1 eq or{/@cc load false $ncl ColorImage}{$wid $bts mul 8 div ceiling cvi
$ncl 3 eq{dup dup/$dat1 exch string def/$dat2 exch string def/$dat3 exch string
def/@cc1 load/@cc2 load/@cc3 load}{dup dup dup/$dat1 exch string def/$dat2 exch
string def/$dat3 exch string def/$dat4 exch string def/@cc1 load/@cc2 load
/@cc3 load/@cc4 load}ifelse true $ncl ColorImage}ifelse $SDF{$dsf $dsa $dsp
@ss}if @gr $ctm setmatrix}bd/@cc1{currentfile $dat1 readhexstring pop}bd/@cc2{
currentfile $dat2 readhexstring pop}bd/@cc3{currentfile $dat3 readhexstring pop
}bd/@cc4{currentfile $dat4 readhexstring pop}bd/$msimage false def/COMP 0 def
/MaskedImage false def/bImgDeviceN false def/nNumInksDeviceN 0 def
/sNamesDeviceN[]def/tint_params[]def level2{/@I_2{@sm @gs @ii @np/$ury xd/$urx
xd/$lly xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul $ncl mul
8 div ceiling cvi string def $ngx $ncl 1 eq{/DeviceGray}{$ncl 3 eq{/DeviceRGB}
{/DeviceCMYK}ifelse}ifelse setcolorspace $llx $lly Tl $urx $llx sub $ury $lly
sub scale 8 dict begin/ImageType 1 def/Width $wid def/Height $hei abs def
/BitsPerComponent $bts def/Decode $ncl 1 eq{[0 1]}{$ncl 3 eq{[0 1 0 1 0 1]}{[0
1 0 1 0 1 0 1]}ifelse}ifelse def/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt
{$hei}{0}ifelse]def/DataSource currentfile/ASCII85Decode filter COMP 1 eq
{/DCTDecode filter}{COMP 2 eq{/RunLengthDecode filter}{COMP 3 eq{/LZWDecode
filter}if}ifelse}ifelse def currentdict end image $SDF{$dsf $dsa $dsp @ss}if
@gr $ctm setmatrix}bd}{/@I_2{}bd}ifelse level2{/@I_2D{@sm @gs @ii @np/$ury xd
/$urx xd/$lly xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd $ngx/scanline $wid
$bts mul $ncl mul 8 div ceiling cvi string def/readscanline{currentfile
scanline readhexstring pop}bind def level3{[/DeviceN sNamesDeviceN/DeviceCMYK{
tint_params CorelTintTransformFunction}]setcolorspace $llx $lly Tl $urx $llx
sub $ury $lly sub scale 8 dict begin/ImageType 1 def/Width $wid def/Height $hei
abs def/BitsPerComponent $bts def/Decode[nNumInksDeviceN{0 1}repeat]def
/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse]def/DataSource{
readscanline}def currentdict end image}{/scanline_height $lly $ury sub 1 sub
$hei div def/plate_scanline $wid string def/cmyk_scanline $wid 4 mul string def
is_distilling is_rip_separation or{/bSimDeviceN true def}{/bSimDeviceN false
def}ifelse/scanline_img_dict 8 dict begin/ImageType 1 def/Width $wid def
/Height 1 def/BitsPerComponent $bts def/Decode bSimDeviceN{[0 1]}{[0 1 0 1 0 1
0 1]}ifelse def/ImageMatrix[$wid 0 0 1 neg 0 1]def/DataSource bSimDeviceN{
plate_scanline}{cmyk_scanline}ifelse def currentdict end def 0 1 $hei 1 sub{
@gs/nScanIndex exch def readscanline pop/$t_lly $ury $lly scanline_height
nScanIndex mul sub sub ceiling cvi def/$t_ury $t_lly scanline_height sub
ceiling cvi def bSimDeviceN{0 1 $ncl 1 sub{@gs/nInkIndex exch def 0 1
plate_scanline length 1 sub{dup $ncl mul nInkIndex add scanline exch get
plate_scanline 3 1 roll put}for[0 1 $ncl 1 sub{nInkIndex eq{1.0}{0.0}ifelse
}for]/sepTintTransformParams exch def[/Separation sNamesDeviceN nInkIndex get
/DeviceCMYK{sepTintTransformParams aload pop tint_params
CorelTintTransformFunction @tc_5}]setcolorspace $llx $t_lly Tl $urx $llx sub
$t_ury $t_lly sub scale nInkIndex 0 eq currentoverprint not and{false
setoverprint}{true setoverprint}ifelse scanline_img_dict image @gr}for}{0 1
$wid 1 sub{dup $ncl mul scanline exch $ncl getinterval 0 1 $ncl 1 sub{2 copy
get 255 div 3 1 roll pop}for pop tint_params CorelTintTransformFunction 5 -1
roll cmyk_scanline exch 0 1 3{3 1 roll 2 copy 5 -1 roll dup 8 exch sub index
255 mul cvi 3 1 roll exch 4 mul add exch put}for 6 rp}for/DeviceCMYK
setcolorspace $llx $t_lly Tl $urx $llx sub $t_ury $t_lly sub scale
scanline_img_dict image}ifelse @gr}for}ifelse $SDF{$dsf $dsa $dsp @ss}if @gr
$ctm setmatrix}bd}{/@I_2D{}bd}ifelse/@I_3{@sm @gs @ii @np/$ury xd/$urx xd/$lly
xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul $ncl mul 8 div
ceiling cvi string def $ngx bImgDeviceN{[/DeviceN sNamesDeviceN/DeviceCMYK{
tint_params CorelTintTransformFunction}]}{$ncl 1 eq{/DeviceGray}{$ncl 3 eq
{/DeviceRGB}{/DeviceCMYK}ifelse}ifelse}ifelse setcolorspace $llx $lly Tl $urx
$llx sub $ury $lly sub scale/ImageDataDict 8 dict def ImageDataDict begin
/ImageType 1 def/Width $wid def/Height $hei abs def/BitsPerComponent $bts def
/Decode[$ncl{0 1}repeat]def/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}
ifelse]def/DataSource currentfile/ASCII85Decode filter COMP 1 eq{/DCTDecode
filter}{COMP 2 eq{/RunLengthDecode filter}{COMP 3 eq{/LZWDecode filter}if}
ifelse}ifelse def end/MaskedImageDict 7 dict def MaskedImageDict begin
/ImageType 3 def/InterleaveType 3 def/MaskDict ImageMaskDict def/DataDict
ImageDataDict def end MaskedImageDict image $SDF{$dsf $dsa $dsp @ss}if @gr $ctm
setmatrix}bd/@SetMask{/$mbts xd/$mhei xd/$mwid xd/ImageMaskDict 8 dict def
ImageMaskDict begin/ImageType 1 def/Width $mwid def/Height $mhei abs def
/BitsPerComponent $mbts def/DataSource maskstream def/ImageMatrix[$mwid 0 0
$mhei neg 0 $mhei 0 gt{$mhei}{0}ifelse]def/Decode[1 0]def end}bd/@daq{dup type
/arraytype eq{{}forall}if}bd/@BMP{/@cc xd UseLevel 3 eq MaskedImage true eq and
{7 -2 roll pop pop @I_3}{12 index 1 gt UseLevel 2 eq UseLevel 3 eq or and{7 -2
roll pop pop bImgDeviceN{@I_2D}{@I_2}ifelse}{11 index 1 eq{12 -1 roll pop @i}{
7 -2 roll pop pop @I}ifelse}ifelse}ifelse}bd/disable_raster_output{/@BMP load
/old_raster_func exch bind def/@BMP{8 rp/$ury xd/$urx xd/$lly xd/$llx xd/$ncl
xd/$bts xd/$hei xd/$wid xd/scanline $wid $bts mul $ncl mul 8 div ceiling cvi
string def 0 1 $hei 1 sub{currentfile scanline readhexstring pop pop pop}for
}def}bd/enable_raster_output{/old_raster_func where{pop/old_raster_func load
/@BMP exch bd}if}bd
end
%%EndResource
%%EndProlog
%%BeginSetup
wCorel14Dict begin
@BeginSysCorelDict
@ssa
1.00 setflat
/$fst 128 def
%%EndSetup

%%Page: 1 1
%%ViewingOrientation: 0 1 1 0
%LogicalPage: 1
%%BeginPageSetup
@sv
@sm
@sv
%%EndPageSetup
@rax %Note: Object
31.45011 733.78006 39.54813 742.69446 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.76 0.64 0.64 0.30 null ] set_fill_color
32.33395 735.89981 m
32.33395 736.87635 32.62876 737.17115 33.60586 737.17115 C
34.58239 737.17115 34.87720 736.87635 34.87720 735.89981 C
34.87720 734.92328 34.58239 734.62819 33.60586 734.62819 C
32.62876 734.62819 32.33395 734.92328 32.33395 735.89981 C
@c
34.02907 739.29005 m
33.08513 739.54261 32.75773 739.38926 32.75773 740.56195 C
32.75773 740.98602 L
32.75773 741.67909 33.01115 742.25735 33.60586 742.25735 C
34.19915 742.25735 34.45313 741.67909 34.45313 740.98602 C
34.45313 740.56195 L
34.45313 739.74359 34.31991 739.80737 34.02907 739.29005 C
@c
34.02907 739.29005 m
34.87720 739.29005 L
35.40274 741.81260 L
36.99609 741.83329 L
36.99609 738.86627 L
36.99609 737.91609 36.66047 737.93622 36.14854 737.17115 C
38.69150 737.17115 L
38.17899 737.93622 37.84337 737.91609 37.84337 738.86627 C
37.84337 740.56195 L
37.84337 741.37975 37.97745 741.31625 38.26743 741.83329 C
39.54813 741.43276 L
39.53934 742.68085 L
37.82466 742.33162 L
37.18035 742.75880 38.70680 742.68085 36.99609 742.68085 C
35.72447 742.68085 L
34.18583 742.68085 35.31203 742.77780 34.87720 742.25735 C
33.75978 742.81096 35.22586 742.68085 33.60586 742.68085 C
32.33395 742.68085 L
31.93313 741.40044 L
31.90989 740.56195 L
31.90989 740.13789 L
31.90989 739.31953 32.04312 739.38331 32.33395 738.86627 C
31.83194 738.20268 31.90989 739.72913 31.90989 738.01871 C
31.90989 737.17115 L
31.45011 736.34570 L
31.48611 735.47575 L
31.48611 734.62819 L
32.02157 734.34472 32.88756 733.78006 33.60586 733.78006 C
34.21191 733.78006 35.72447 734.79855 35.72447 735.89981 C
35.72447 736.32302 L
35.72447 737.27376 35.38913 737.25392 34.87720 738.01871 C
34.02907 738.01871 L
32.75773 738.01871 L
32.75773 738.86627 L
34.02907 739.29005 L
@c
F

@rax %Note: Object
49.63238 737.17115 54.79739 745.64759 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.72 0.60 0.60 0.18 null ] set_fill_color
49.71118 745.64759 m
50.26479 744.53046 50.13496 745.99682 50.13496 744.37625 C
50.13496 739.29005 L
50.13496 738.44277 L
49.63238 737.20120 L
51.83008 737.17115 L
51.27647 738.28800 51.40630 736.82249 51.40630 738.44277 C
51.40630 741.83329 L
53.10198 741.83329 L
53.10198 738.44277 L
53.10198 737.62441 52.96876 737.68791 52.67792 737.17115 C
54.79739 737.17115 L
54.39628 738.45128 L
54.37332 739.29005 L
54.37332 740.98602 L
54.37332 741.97757 53.67005 742.68085 52.67792 742.68085 C
51.78189 742.68085 52.11921 742.52891 50.98280 742.25735 C
50.98280 745.64759 L
49.71118 745.64759 L
@c
F

@rax %Note: Object
51.40630 718.09824 61.58721 724.03200 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.69 0.58 0.58 0.13 null ] set_fill_color
58.18819 721.48904 m
58.18819 720.64148 L
56.91628 720.64148 L
57.58469 721.60299 56.99650 721.13669 58.18819 721.48904 C
@c
51.40630 722.76038 m
51.83008 722.33717 L
52.48120 723.27345 51.89981 722.86384 53.10198 723.18444 C
53.10198 719.79392 L
53.10198 718.94608 L
53.52605 718.52230 L
53.94926 718.94608 L
53.42854 719.38091 53.52605 718.25528 53.52605 719.79392 C
53.52605 720.21742 L
53.52605 720.91134 53.77946 721.48904 54.37332 721.48904 C
54.75033 721.48904 55.22088 721.01849 55.22088 720.64148 C
55.22088 719.49685 55.01849 719.47276 54.79739 718.52230 C
56.01798 719.43137 L
56.91628 718.94608 L
56.91628 720.21742 L
59.03546 720.21742 L
59.28690 719.14054 59.38980 718.09824 60.73087 718.09824 C
61.48545 718.09824 61.42620 718.73433 61.57843 719.37014 C
59.90769 718.85339 L
59.88331 720.21742 L
59.88331 721.03578 60.01654 720.97200 60.30709 721.48904 C
61.58721 721.08850 L
60.79351 723.01068 60.22431 721.49613 58.61197 721.06526 C
58.61197 721.91310 L
56.91628 721.91310 L
56.41370 720.67181 L
55.13046 721.82183 L
53.94926 721.91310 L
53.94926 724.03200 L
51.83008 724.03200 L
51.40630 722.76038 L
@c
F

@rax %Note: Object
41.23474 725.72740 45.89660 731.31506 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
43.77770 730.81361 m
43.58693 729.47849 L
43.35364 730.38954 L
41.73704 730.35950 L
41.23474 729.11820 L
41.23474 728.27065 L
41.25770 727.43187 L
41.65824 726.15146 L
43.35364 726.15146 L
44.62526 725.72740 L
44.91553 726.24444 45.04932 726.18066 45.04932 726.99931 C
45.04932 729.54227 L
45.04932 731.16227 45.17915 729.69647 44.62526 730.81361 C
45.89660 730.81361 L
45.13918 731.71956 44.54731 731.19515 43.77770 730.81361 C
@c
F

@rax %Note: Object
47.16850 725.64576 53.52605 731.23739 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.66 0.66 0.38 null ] set_fill_color
49.28712 726.15146 m
48.65159 726.30397 48.01578 726.24444 48.01578 726.99931 C
48.01578 728.28057 48.51468 728.17115 49.80643 728.25222 C
49.28712 726.15146 L
@c
49.28712 726.15146 m
50.40482 725.59757 48.93846 725.72740 50.55874 725.72740 C
53.52605 725.72740 L
53.30409 726.67814 53.10198 726.70167 53.10198 727.84658 C
53.10198 730.81361 L
51.83008 730.81361 L
52.38454 729.69647 52.25414 731.16227 52.25414 729.54227 C
52.25414 726.15146 L
51.05792 726.25068 50.55874 726.14154 50.55874 727.42252 C
50.55874 729.96548 L
50.55874 730.94230 50.26422 731.23739 49.28712 731.23739 C
48.86391 731.23739 L
47.58208 731.23739 47.69150 730.73877 47.59200 729.54227 C
48.07928 730.36857 L
49.71118 730.38954 L
49.71118 729.11820 L
47.59569 728.67883 L
47.37061 727.74397 47.16850 727.71987 47.16850 726.57524 C
47.16850 725.67241 49.28712 725.23814 49.28712 726.15146 C
@c
F

@rax %Note: Object
42.50636 717.25096 50.13496 723.60850 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.71 0.60 0.60 0.16 null ] set_fill_color
45.39345 718.97641 m
44.11474 718.97641 43.35364 718.80831 43.35364 720.21742 C
43.35364 721.48904 L
43.35364 722.30797 44.10907 723.18444 44.62526 723.18444 C
45.14088 723.18444 45.89660 722.30797 45.89660 721.48904 C
45.89660 721.06526 L
45.87364 720.22649 L
45.39345 718.97641 L
@c
50.13496 718.94608 m
49.44841 720.02778 49.71118 720.22649 49.71118 721.91310 C
48.86391 721.91310 L
48.86391 718.94608 L
47.59200 718.94608 L
47.59200 721.91310 L
45.54028 722.46076 46.17524 723.60850 44.62526 723.60850 C
43.63710 723.60850 42.50636 722.47691 42.50636 721.48904 C
42.50636 720.21742 L
42.50636 719.19893 43.19235 718.97159 43.77770 718.09824 C
44.62526 718.09824 L
45.04932 718.09824 L
46.42696 718.09824 45.36907 717.73115 47.16850 717.25096 C
45.98731 718.61329 L
46.45191 719.57140 46.74444 719.82737 46.74444 721.48904 C
47.16850 721.48904 L
47.16850 719.37014 L
47.16850 718.55206 47.30117 718.61584 47.59200 718.09824 C
50.13496 718.94608 L
@c
F

@rax %Note: Object
32.33395 725.64094 37.39805 734.20413 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.77 0.65 0.65 0.34 null ] set_fill_color
35.30069 726.15146 m
34.10447 726.25068 33.60586 726.14154 33.60586 727.42252 C
33.63562 730.31046 L
34.81342 730.62283 L
35.72447 730.38954 L
35.72447 727.42252 L
35.72447 725.80195 35.85487 727.26831 35.30069 726.15146 C
@c
35.30069 726.15146 m
37.39805 725.64094 L
36.90737 726.49247 36.57203 726.47263 36.57203 727.42252 C
36.57203 734.20413 L
35.30069 734.20413 L
35.85487 733.08671 35.72447 734.55307 35.72447 732.93279 C
35.72447 730.81361 L
34.05345 731.32951 L
32.65058 730.31386 33.08542 730.53836 32.33395 729.11820 C
32.33395 728.27065 L
32.33395 727.42252 L
32.83654 726.18180 L
33.28611 726.02816 35.30069 725.15820 35.30069 726.15146 C
@c
F

@rax %Note: Object
44.20148 734.20413 49.28712 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.67 0.67 0.44 null ] set_fill_color
45.89660 740.56195 m
45.89660 741.38003 46.65203 742.25735 47.16850 742.25735 C
47.82104 742.25735 48.43984 740.83380 48.43984 740.13789 C
48.43984 739.57833 47.79836 738.02494 47.59200 737.59493 C
46.74444 737.59493 L
46.15058 737.59493 45.89660 738.17291 45.89660 738.86627 C
45.89660 740.56195 L
@c
49.28712 740.56195 m
49.28712 741.75874 48.31483 742.19669 47.59200 742.68085 C
44.62526 742.25735 L
45.17915 741.13994 45.04932 742.60602 45.04932 740.98602 C
45.04932 735.89981 L
45.04932 734.94907 44.71342 734.96891 44.20148 734.20413 C
46.74444 734.20413 L
46.23222 734.96891 45.89660 734.94907 45.89660 735.89981 C
45.89660 737.17115 L
47.16850 737.17115 L
48.01578 737.17115 L
48.58044 738.01389 48.78709 738.34526 49.28712 739.29005 C
49.28712 740.13789 L
49.28712 740.56195 L
@c
F

@rax %Note: Object
21.31455 737.17115 26.39991 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.67 0.67 0.44 null ] set_fill_color
21.33241 742.16183 m
21.60482 741.74031 21.73805 741.80381 21.73805 740.98602 C
21.73805 739.29005 L
21.71509 738.45128 L
21.31455 737.17115 L
23.43345 737.17115 L
22.92151 737.93622 22.58589 737.91609 22.58589 738.86627 C
22.58589 739.71411 L
22.60885 740.55260 L
23.00939 741.83329 L
24.70479 741.83329 L
24.70479 738.44277 L
24.70479 736.82249 24.83518 738.28800 24.28072 737.17115 C
26.39991 737.17115 L
25.88769 737.93622 25.55263 737.91609 25.55263 738.86627 C
25.55263 741.40923 L
25.55263 742.10315 25.29865 742.68085 24.70479 742.68085 C
23.45528 742.56775 L
21.33241 742.16183 L
@c
F

@rax %Note: Object
16.65184 737.17115 20.89049 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.63 0.63 0.25 null ] set_fill_color
19.20387 742.23383 m
19.71128 740.58576 L
17.49997 740.56195 L
17.95380 741.75392 L
19.20387 742.23383 L
@c
17.07591 741.83329 m
16.65184 740.13789 L
16.65184 739.29005 L
16.65184 738.57260 17.21650 737.70633 17.49997 737.17115 C
18.34724 737.17115 L
19.19509 737.17115 L
20.38819 737.17115 19.98000 737.35427 20.46643 738.01871 C
19.33002 737.74658 19.66734 737.59493 18.77131 737.59493 C
17.79449 737.59493 17.94416 738.77953 17.92346 739.71411 C
19.61915 739.71411 L
21.23943 739.71411 19.77307 739.58428 20.89049 740.13789 C
20.60929 741.34573 20.23512 742.68085 18.77131 742.68085 C
18.08419 742.68085 17.42287 742.17288 17.07591 741.83329 C
@c
F

@rax %Note: Object
38.26743 746.91950 42.08230 753.70054 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.76 0.64 0.64 0.31 null ] set_fill_color
38.69150 752.42891 m
38.69150 748.19083 L
38.69150 746.57027 38.82189 748.03663 38.26743 746.91950 C
42.08230 746.91950 L
41.89153 748.25433 L
41.65824 747.34271 L
39.53934 747.34271 L
39.55748 750.40526 L
41.65824 749.88567 L
41.68035 751.04419 L
39.53934 750.73380 L
39.53934 752.85298 L
40.81068 752.85298 L
42.43096 752.85298 40.96460 752.98309 42.08230 752.42891 C
42.08230 753.70054 L
38.26743 753.70054 L
38.55798 753.18378 38.69150 753.24728 38.69150 752.42891 C
@c
F

@rax %Note: Object
39.96312 737.07761 43.85622 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.77 0.65 0.65 0.35 null ] set_fill_color
42.08230 737.59493 m
41.44620 737.74687 40.81068 737.68791 40.81068 738.44277 C
40.81068 739.72375 41.30929 739.61490 42.60104 739.69569 C
42.08230 737.59493 L
@c
42.08230 737.59493 m
43.85622 737.20120 L
43.35364 738.44277 L
43.35364 739.29005 L
43.35364 741.40923 L
43.35364 742.38576 43.05883 742.68085 42.08230 742.68085 C
41.65824 742.68085 L
40.48554 742.68085 40.63918 742.35373 40.39087 741.39420 C
42.50636 741.83329 L
42.50636 740.56195 L
41.23474 740.56195 L
40.64939 739.68860 39.96312 739.46126 39.96312 738.44277 C
39.96312 737.02176 41.30135 736.66006 42.08230 737.59493 C
@c
F

@rax %Note: Object
27.24803 725.63471 31.88580 730.81361 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.80 0.68 0.68 0.55 null ] set_fill_color
27.24803 730.81361 m
27.80164 729.69647 27.67153 731.16227 27.67153 729.54227 C
27.67153 726.99931 L
27.67153 726.02220 27.96718 725.72740 28.94287 725.72740 C
29.36693 725.72740 L
30.90586 725.72740 29.77965 725.63046 30.21477 726.15146 C
31.88580 725.63471 L
31.68879 726.67814 31.48611 726.70167 31.48611 727.84658 C
31.48611 730.81361 L
30.21477 730.81361 L
30.76866 729.69647 30.63855 731.16227 30.63855 729.54227 C
30.63855 727.84658 L
30.63855 727.02794 29.88340 726.15146 29.36693 726.15146 C
28.77307 726.15146 28.51965 726.72945 28.51965 727.42252 C
28.51965 730.81361 L
27.24803 730.81361 L
@c
F

@rax %Note: Object
26.80129 737.17115 31.06261 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.66 0.66 0.41 null ] set_fill_color
28.94287 737.59493 m
27.96718 737.59493 27.67153 737.88945 27.67153 738.86627 C
27.67153 740.56195 L
27.67153 741.38003 28.42724 742.25735 28.94287 742.25735 C
29.45934 742.25735 30.21477 741.38003 30.21477 740.56195 C
30.21477 739.29005 L
30.21477 738.47169 29.45934 737.59493 28.94287 737.59493 C
@c
26.80129 740.99764 m
26.82397 740.13789 L
26.82397 738.86627 L
26.82397 737.87386 27.52753 737.17115 28.51965 737.17115 C
30.21477 737.17115 L
30.69524 738.97030 31.06261 737.91269 31.06261 739.29005 C
31.06261 740.56195 L
31.06261 741.54983 29.93159 742.68085 28.94287 742.68085 C
28.51965 742.68085 L
27.69506 742.66809 L
26.80129 740.99764 L
@c
F

@rax %Note: Object
27.67153 737.59493 30.21477 742.25735 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.04 0.03 0.03 0.00 null ] set_fill_color
28.94287 737.59493 m
29.45934 737.59493 30.21477 738.47169 30.21477 739.29005 C
30.21477 740.56195 L
30.21477 741.38003 29.45934 742.25735 28.94287 742.25735 C
28.42724 742.25735 27.67153 741.38003 27.67153 740.56195 C
27.67153 738.86627 L
27.67153 737.88945 27.96718 737.59493 28.94287 737.59493 C
@c
F

@rax %Note: Object
45.89660 737.59493 48.43984 742.25735 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.04 0.03 0.03 0.00 null ] set_fill_color
45.89660 740.56195 m
45.89660 738.86627 L
45.89660 738.17291 46.15058 737.59493 46.74444 737.59493 C
47.59200 737.59493 L
47.79836 738.02494 48.43984 739.57833 48.43984 740.13789 C
48.43984 740.83380 47.82104 742.25735 47.16850 742.25735 C
46.65203 742.25735 45.89660 741.38003 45.89660 740.56195 C
@c
F

@rax %Note: Object
57.74088 737.17115 61.57843 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.79 0.67 0.67 0.45 null ] set_fill_color
59.88331 742.25735 m
60.75099 742.25735 60.66227 741.38372 60.73087 740.56195 C
58.61197 740.56195 L
58.87559 741.09430 59.20980 742.25735 59.88331 742.25735 C
@c
57.76413 740.56195 m
57.76413 739.71411 L
57.74088 738.85408 L
58.61197 737.17115 L
59.45953 737.17115 L
60.30709 737.17115 L
61.47978 737.17115 61.32671 737.49827 61.57843 738.44277 C
61.23742 738.20523 60.53216 737.59493 60.30709 737.59493 C
58.79792 737.59493 58.64570 738.59981 58.61197 740.13789 C
61.57843 740.13789 L
61.54441 741.67597 61.39276 742.68085 59.88331 742.68085 C
58.89487 742.68085 57.76413 741.54983 57.76413 740.56195 C
@c
F

@rax %Note: Object
57.76413 725.72740 61.57843 731.23739 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.67 0.67 0.44 null ] set_fill_color
59.88331 730.81361 m
60.75099 730.81361 60.66227 729.94082 60.73087 729.11820 C
58.61197 729.11820 L
58.78658 729.84728 59.12192 730.81361 59.88331 730.81361 C
@c
59.88331 726.15146 m
58.83364 726.15146 58.63833 727.50699 58.61197 728.69414 C
61.57843 728.69414 L
61.54441 730.23222 61.39276 731.23739 59.88331 731.23739 C
58.89487 731.23739 57.76413 730.10636 57.76413 729.11820 C
57.76413 727.42252 L
57.76413 726.43096 58.46712 725.72740 59.45953 725.72740 C
60.30709 725.72740 L
61.47978 725.72740 61.32671 726.05452 61.57843 726.99931 C
60.81364 726.48709 60.83348 726.15146 59.88331 726.15146 C
@c
F

@rax %Note: Object
43.77770 747.34271 46.74444 751.58164 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
45.47282 747.34271 m
46.74444 747.76677 L
46.45389 748.28381 46.32066 748.22031 46.32066 749.03839 C
46.32066 749.88567 L
46.32066 751.50680 46.19083 750.04072 46.74444 751.15757 C
45.89660 751.58164 L
45.89660 750.30973 L
45.55559 750.54699 44.85005 751.15757 44.62526 751.15757 C
44.03083 751.15757 43.77770 750.57959 43.77770 749.88567 C
43.77770 748.61433 L
43.77770 747.33335 44.27631 747.44249 45.47282 747.34271 C
@c
F

@rax %Note: Object
43.35364 718.97046 45.89660 723.18444 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.03 0.02 0.02 0.00 null ] set_fill_color
45.87364 720.22649 m
45.89660 721.06526 L
45.89660 721.48904 L
45.89660 722.30797 45.14088 723.18444 44.62526 723.18444 C
44.10907 723.18444 43.35364 722.30797 43.35364 721.48904 C
43.35364 720.21742 L
43.35364 718.80831 44.11474 718.97641 45.39345 718.97641 C
45.87364 720.22649 L
@c
F

@rax %Note: Object
13.64854 737.17115 16.22835 743.95219 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.64 0.64 0.26 null ] set_fill_color
16.22835 741.83329 m
15.40205 742.32085 L
15.38022 743.95219 L
13.61027 743.47965 14.48192 743.76255 13.64854 742.23496 C
14.14545 741.43191 L
14.10888 740.56195 L
14.10888 739.29005 L
14.10888 738.44277 L
14.61203 737.20120 L
16.22835 737.17115 L
15.40205 737.65843 L
15.38022 741.83329 L
16.22835 741.83329 L
@c
F

@rax %Note: Object
33.60586 726.15146 35.73836 730.62283 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.03 0.02 0.02 0.00 null ] set_fill_color
35.30069 726.15146 m
35.85487 727.26831 35.72447 725.80195 35.72447 727.42252 C
35.72447 730.38954 L
34.81342 730.62283 L
33.63562 730.31046 L
33.60586 727.42252 L
33.60586 726.14154 34.10447 726.25068 35.30069 726.15146 C
@c
F

@rax %Note: Object
46.30734 746.91950 50.13496 751.59496 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.79 0.67 0.67 0.45 null ] set_fill_color
47.16850 748.61433 m
47.16850 749.88567 L
47.16850 750.57959 47.42192 751.15757 48.01578 751.15757 C
48.99231 751.15757 49.28712 750.86249 49.28712 749.88567 C
49.28712 748.61433 L
49.28712 747.92098 49.03370 747.34271 48.43984 747.34271 C
47.46331 747.34271 47.16850 747.63808 47.16850 748.61433 C
@c
46.74444 751.15757 m
46.19083 750.04072 46.32066 751.50680 46.32066 749.88567 C
46.32066 749.03839 L
46.32066 748.22031 46.45389 748.28381 46.74444 747.76677 C
47.16850 746.91950 L
48.01578 746.91950 L
48.43984 746.91950 L
49.43197 746.91950 50.13496 747.62249 50.13496 748.61433 C
50.13496 749.88567 L
50.13496 750.87808 49.43197 751.58164 48.43984 751.58164 C
48.01578 751.58164 L
46.39521 751.58164 47.86157 751.71146 46.74444 751.15757 C
@c
F

@rax %Note: Object
52.65468 746.91950 56.15490 751.58164 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.76 0.64 0.64 0.29 null ] set_fill_color
54.02835 751.12724 m
55.22627 750.81657 54.88016 751.16268 55.22088 749.88567 C
53.54901 749.87717 L
54.02835 751.12724 L
@c
52.67792 749.46246 m
52.65468 748.60243 L
53.52605 746.91950 L
54.37332 746.91950 L
54.79739 746.91950 L
55.99077 746.91950 55.58173 747.10261 56.06476 747.78208 C
53.96485 747.34696 L
53.52605 749.46246 L
56.15490 749.48372 L
55.64494 751.58164 L
54.37332 751.58164 L
53.52605 751.58164 L
53.24258 751.04646 52.67792 750.18019 52.67792 749.46246 C
@c
F

@rax %Note: Object
24.70479 722.76038 26.39991 731.23739 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.63 0.63 0.23 null ] set_fill_color
24.70479 731.23739 m
24.70479 730.38954 L
25.55263 730.38954 L
25.55263 724.88013 L
25.55263 723.50192 25.18498 724.55981 24.70479 722.76038 C
25.60309 723.08608 26.39991 723.73890 26.39991 724.88013 C
26.39991 729.96548 L
26.39991 731.24731 25.90129 731.13789 24.70479 731.23739 C
@c
F

@rax %Note: Object
47.16850 747.34271 49.28712 751.15757 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.04 0.03 0.03 0.00 null ] set_fill_color
49.28712 749.88567 m
49.28712 750.86249 48.99231 751.15757 48.01578 751.15757 C
47.42192 751.15757 47.16850 750.57959 47.16850 749.88567 C
47.16850 748.61433 L
47.16850 747.63808 47.46331 747.34271 48.43984 747.34271 C
49.03370 747.34271 49.28712 747.92098 49.28712 748.61433 C
49.28712 749.88567 L
@c
F

@rax %Note: Object
50.47965 746.91950 52.25414 754.54866 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.64 0.64 0.26 null ] set_fill_color
50.95956 753.26797 m
50.98280 752.42891 L
50.98280 748.19083 L
50.98280 746.57027 51.11291 748.03663 50.55874 746.91950 C
52.25414 746.91950 L
52.03276 747.86995 51.83008 747.89348 51.83008 749.03839 C
51.83008 754.54866 L
50.47965 754.51805 L
50.95956 753.26797 L
@c
F

@rax %Note: Object
38.26743 719.70123 41.65824 722.76038 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.33 0.27 0.27 0.00 null ] set_fill_color
41.63414 719.70123 m
41.65824 721.91310 L
39.96312 721.91310 L
39.96312 722.76038 L
39.11528 722.76038 L
39.11528 721.91310 L
38.26743 721.91310 L
38.31931 720.03685 38.36580 719.22586 39.96312 720.21742 C
41.63414 719.70123 L
@c
F

@rax %Note: Object
54.29452 725.72740 57.34913 731.23739 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.66 0.66 0.41 null ] set_fill_color
55.64494 729.11820 m
55.64494 729.93657 55.77846 729.87250 56.06901 730.38954 C
57.34913 729.98901 L
57.34035 731.23739 L
54.37332 730.81361 L
54.92750 729.69647 54.79739 731.16227 54.79739 729.54227 C
54.79739 727.84658 L
54.79739 726.99931 L
54.29452 725.75773 L
56.49222 725.72740 L
55.98028 726.49247 55.64494 726.47263 55.64494 727.42252 C
55.64494 729.11820 L
@c
F

@rax %Note: Object
40.38661 725.66220 43.77770 731.32951 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.66 0.66 0.40 null ] set_fill_color
43.35364 726.15146 m
41.65824 726.15146 L
41.25770 727.43187 L
41.23474 728.27065 L
41.23474 729.11820 L
41.73704 730.35950 L
43.35364 730.38954 L
43.58693 729.47849 L
43.77770 730.81361 L
42.10611 731.32951 L
41.35918 730.75351 40.38661 730.31499 40.38661 729.11820 C
40.38661 727.42252 L
40.38661 726.43096 41.09017 725.72740 42.08230 725.72740 C
43.00554 725.72740 43.35364 725.41559 43.35364 726.15146 C
@c
F

@rax %Note: Object
32.33395 734.62819 34.87720 737.17115 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
34.87720 735.89981 m
34.87720 736.87635 34.58239 737.17115 33.60586 737.17115 C
32.62876 737.17115 32.33395 736.87635 32.33395 735.89981 C
32.33395 734.92328 32.62876 734.62819 33.60586 734.62819 C
34.58239 734.62819 34.87720 734.92328 34.87720 735.89981 C
@c
F

@rax %Note: Object
50.98280 718.94608 53.10198 723.18444 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.08 0.06 0.06 0.00 null ] set_fill_color
51.40630 722.76038 m
50.98280 721.91310 L
52.54214 721.78356 52.54838 721.77676 52.67792 720.21742 C
50.98280 720.21742 L
50.98280 718.94608 L
52.67792 718.94608 L
53.10198 718.94608 L
53.10198 719.79392 L
53.10198 723.18444 L
51.89981 722.86384 52.48120 723.27345 51.83008 722.33717 C
51.40630 722.76038 L
@c
F

@rax %Note: Object
42.92957 746.85940 45.89660 751.58164 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.77 0.65 0.65 0.36 null ] set_fill_color
45.47282 747.34271 m
44.27631 747.44249 43.77770 747.33335 43.77770 748.61433 C
43.77770 749.88567 L
43.77770 750.57959 44.03083 751.15757 44.62526 751.15757 C
44.85005 751.15757 45.55559 750.54699 45.89660 750.30973 C
45.89660 751.58164 L
44.20148 751.58164 L
43.54157 751.13972 42.92957 751.01981 42.92957 749.88567 C
42.92957 748.61433 L
42.92957 747.32769 44.49713 746.17512 45.47282 747.34271 C
@c
F

@rax %Note: Object
50.13496 718.09824 52.67792 721.91310 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.70 0.58 0.58 0.13 null ] set_fill_color
50.98280 721.48904 m
51.83008 721.48904 L
51.83008 720.64148 L
50.98280 720.64148 L
50.98280 721.48904 L
@c
50.13496 718.94608 m
50.90003 718.43386 50.88019 718.09824 51.83008 718.09824 C
52.40183 718.09824 52.46617 718.56907 52.67792 718.94608 C
50.98280 718.94608 L
50.98280 720.21742 L
52.67792 720.21742 L
52.54838 721.77676 52.54214 721.78356 50.98280 721.91310 C
50.98280 721.48904 L
50.15707 721.02869 L
50.13496 718.94608 L
@c
F

@rax %Note: Object
55.22088 737.59493 56.91628 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.64 0.64 0.26 null ] set_fill_color
55.22088 741.83329 m
56.06901 741.83329 L
56.06901 737.59493 L
56.91628 737.59493 L
56.91628 742.68085 L
55.22088 742.68085 L
55.22088 741.83329 L
@c
F

@rax %Note: Object
44.62526 725.72740 46.74444 730.81361 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.80 0.68 0.68 0.55 null ] set_fill_color
44.62526 725.72740 m
46.74444 725.72740 L
45.83537 726.94800 L
45.89660 730.81361 L
44.62526 730.81361 L
45.17915 729.69647 45.04932 731.16227 45.04932 729.54227 C
45.04932 726.99931 L
45.04932 726.18066 44.91553 726.24444 44.62526 725.72740 C
@c
F

@rax %Note: Object
37.84337 725.72740 39.96312 730.81361 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.79 0.67 0.67 0.45 null ] set_fill_color
37.84337 730.81361 m
38.39783 729.69647 38.26743 731.16227 38.26743 729.54227 C
38.26743 726.99931 L
38.26743 726.18066 38.13449 726.24444 37.84337 725.72740 C
39.96312 725.72740 L
39.13654 726.21496 L
39.11528 730.81361 L
37.84337 730.81361 L
@c
F

@rax %Note: Object
53.51896 717.94885 55.22088 721.48904 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.12 0.09 0.09 0.00 null ] set_fill_color
53.52605 718.52230 m
53.54702 718.50643 54.79739 717.23962 54.79739 718.52230 C
55.01849 719.47276 55.22088 719.49685 55.22088 720.64148 C
55.22088 721.01849 54.75033 721.48904 54.37332 721.48904 C
53.77946 721.48904 53.52605 720.91134 53.52605 720.21742 C
53.52605 719.79392 L
53.52605 718.25528 53.42854 719.38091 53.94926 718.94608 C
53.52605 718.52230 L
@c
F

@rax %Note: Object
10.22995 737.59493 13.26132 741.83329 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.80 0.68 0.68 0.55 null ] set_fill_color
12.41376 737.59493 m
13.26132 738.01871 L
13.26132 738.86627 L
13.26132 739.71411 L
12.25417 740.24702 11.81622 740.69235 10.71808 740.98602 C
10.71808 741.83329 L
9.98731 741.83329 10.29458 740.98375 10.28778 740.12258 C
12.41376 739.29005 L
12.41376 737.59493 L
@c
F

@rax %Note: Object
32.75773 739.29005 34.45313 742.25735 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.07 0.05 0.05 0.00 null ] set_fill_color
34.02907 739.29005 m
34.31991 739.80737 34.45313 739.74359 34.45313 740.56195 C
34.45313 740.98602 L
34.45313 741.67909 34.19915 742.25735 33.60586 742.25735 C
33.01115 742.25735 32.75773 741.67909 32.75773 740.98602 C
32.75773 740.56195 L
32.75773 739.38926 33.08513 739.54261 34.02907 739.29005 C
@c
F

@rax %Note: Object
57.76413 746.91950 59.45953 750.73380 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.69 0.57 0.57 0.13 null ] set_fill_color
59.03546 749.03839 m
59.03546 747.34271 L
58.18819 747.34271 L
58.18819 749.03839 L
59.03546 749.03839 L
@c
59.03546 749.46246 m
57.76413 749.46246 L
57.76413 746.91950 L
59.45953 746.91950 L
59.45953 750.73380 L
59.03546 750.73380 L
59.03546 749.46246 L
@c
F

@rax %Note: Object
59.88331 746.91950 61.57843 749.46246 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.51 0.42 0.42 0.02 null ] set_fill_color
59.88331 748.19083 m
59.88331 746.90957 60.38192 747.01871 61.57843 746.91950 C
60.79861 749.27225 61.85934 746.04189 60.30709 748.19083 C
61.57843 748.19083 L
61.57843 749.46246 L
60.38192 749.36268 59.88331 749.47238 59.88331 748.19083 C
@c
F

@rax %Note: Object
58.61197 729.11820 60.73087 730.81361 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.07 0.05 0.05 0.00 null ] set_fill_color
58.61197 729.11820 m
60.73087 729.11820 L
60.66227 729.94082 60.75099 730.81361 59.88331 730.81361 C
59.12192 730.81361 58.78658 729.84728 58.61197 729.11820 C
@c
F

@rax %Note: Object
40.81068 737.59493 42.60104 739.69569 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
42.08230 737.59493 m
42.60104 739.69569 L
41.30929 739.61490 40.81068 739.72375 40.81068 738.44277 C
40.81068 737.68791 41.44620 737.74687 42.08230 737.59493 C
@c
F

@rax %Note: Object
48.01578 726.15146 49.80643 728.25222 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
49.28712 726.15146 m
49.80643 728.25222 L
48.51468 728.17115 48.01578 728.28057 48.01578 726.99931 C
48.01578 726.24444 48.65159 726.30397 49.28712 726.15146 C
@c
F

@rax %Note: Object
58.61197 740.56195 60.73087 742.25735 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.04 0.03 0.03 0.00 null ] set_fill_color
58.61197 740.56195 m
60.73087 740.56195 L
60.66227 741.38372 60.75099 742.25735 59.88331 742.25735 C
59.20980 742.25735 58.87559 741.09430 58.61197 740.56195 C
@c
F

@rax %Note: Object
17.49997 740.56195 19.71128 742.23383 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.05 0.04 0.04 0.00 null ] set_fill_color
17.95380 741.75392 m
17.49997 740.56195 L
19.71128 740.58576 L
19.20387 742.23383 L
17.95380 741.75392 L
@c
F

@rax %Note: Object
10.71808 741.40923 13.26132 742.68085 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.64 0.53 0.53 0.08 null ] set_fill_color
10.71808 741.83329 m
11.98091 741.81005 L
13.26132 741.40923 L
13.00904 742.35373 13.16211 742.68085 11.98998 742.68085 C
10.71808 742.68085 L
10.71808 741.83329 L
@c
F

@rax %Note: Object
9.87080 737.10567 12.41376 738.83622 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.64 0.64 0.26 null ] set_fill_color
12.41376 737.59493 m
11.14214 737.59493 L
10.63928 738.83622 L
10.39351 738.64035 9.87080 738.63865 9.87080 738.01871 C
9.87080 737.42513 10.44850 737.17115 11.14214 737.17115 C
12.06595 737.17115 12.41376 736.85934 12.41376 737.59493 C
@c
F

@rax %Note: Object
53.54901 749.87717 55.22088 751.12724 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.02 0.02 0.00 null ] set_fill_color
53.54901 749.87717 m
55.22088 749.88567 L
54.88016 751.16268 55.22627 750.81657 54.02835 751.12724 C
53.54901 749.87717 L
@c
F

@rax %Note: Object
58.18819 747.34271 59.03546 749.03839 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.06 0.04 0.04 0.00 null ] set_fill_color
58.18819 747.34271 m
59.03546 747.34271 L
59.03546 749.03839 L
58.18819 749.03839 L
58.18819 747.34271 L
@c
F

@rax %Note: Object
18.34724 743.10463 20.04321 745.64759 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.64 0.64 0.27 null ] set_fill_color
18.34724 743.10463 m
19.57635 743.92781 19.65458 743.98139 20.04321 745.64759 C
19.18800 745.02170 18.66416 744.29121 18.34724 743.10463 C
@c
F

@rax %Note: Object
56.91628 718.09058 58.61197 718.94608 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.54 0.44 0.44 0.03 null ] set_fill_color
56.91628 718.94608 m
56.91628 718.09824 L
58.88494 718.26208 57.65783 717.64413 58.61197 718.94608 C
56.91628 718.94608 L
@c
F

@rax %Note: Object
25.05005 732.50872 26.39991 733.78913 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.73 0.62 0.62 0.20 null ] set_fill_color
26.39991 732.50872 m
26.07931 733.71118 26.48891 733.12951 25.52939 733.78913 C
25.05005 732.53934 L
26.39991 732.50872 L
@c
F

@rax %Note: Object
55.64494 743.95219 56.91628 744.80031 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.75 0.63 0.63 0.25 null ] set_fill_color
55.64494 743.95219 m
56.91628 743.95219 L
56.91628 744.80031 L
55.64494 744.80031 L
55.64494 743.95219 L
@c
F

@rax %Note: Object
38.26743 732.50872 39.11528 733.78006 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.67 0.67 0.44 null ] set_fill_color
39.11528 733.78006 m
38.26743 733.78006 L
38.26743 732.50872 L
39.11528 732.50872 L
39.11528 733.78006 L
@c
F

@rax %Note: Object
52.25414 732.50872 53.10198 733.78006 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.78 0.66 0.66 0.39 null ] set_fill_color
53.10198 733.78006 m
52.25414 733.78006 L
52.25414 732.50872 L
53.10198 732.50872 L
53.10198 733.78006 L
@c
F

@rax %Note: Object
56.91628 720.64148 58.18819 721.48904 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.07 0.05 0.05 0.00 null ] set_fill_color
58.18819 720.64148 m
58.18819 721.48904 L
56.99650 721.13669 57.58469 721.60299 56.91628 720.64148 C
58.18819 720.64148 L
@c
F

@rax %Note: Object
45.04932 732.50872 45.89660 733.35685 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.84 0.72 0.72 0.88 null ] set_fill_color
45.04932 733.35685 m
45.04932 732.50872 L
45.89660 732.50872 L
45.89660 733.35685 L
45.04932 733.35685 L
@c
F

@rax %Note: Object
50.98280 720.64148 51.83008 721.48904 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.04 0.03 0.03 0.00 null ] set_fill_color
50.98280 721.48904 m
50.98280 720.64148 L
51.83008 720.64148 L
51.83008 721.48904 L
50.98280 721.48904 L
@c
F

@rax %Note: Object
39.96312 754.54866 41.23474 755.39594 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.80 0.68 0.68 0.53 null ] set_fill_color
39.96312 754.54866 m
41.20243 754.84488 40.57342 754.49395 41.23474 755.39594 C
40.49121 755.21849 40.09890 755.34293 39.96312 754.54866 C
@c
F

%%PageTrailer
@rs
@rs
%%Trailer
@EndSysCorelDict
end
%%DocumentSuppliedResources: procset wCorel14Dict 14.0 0
%%EOF



}bind def 
%---------------------------------------------------------- 
% Ici on insère entre les accolades le sigle qui sera 
% imprimé en filigrane au centre de chacune des pages 
% du bulletin. 
% 
/Psigle_2 { 
% Mettre ici le code postscript du sigle imprimé en filigrane au centre. 


%%BoundingBox: 100 189 369 391 
%%LanguageLevel: 2
%%Creator: CorelDRAW
%%Title: ESJ-BAC2.eps
%%CreationDate: Mon May 21 10:26:23 2012
%%DocumentProcessColors: Cyan Magenta Yellow 
%%DocumentSuppliedResources: (atend)
%%EndComments
%%BeginProlog
/AutoFlatness false def
/AutoSteps 0 def
/CMYKMarks true def
/UseLevel 2 def
%Build: CorelDRAW Version 14.0.0.567
%Color profile:  Generic offset separations profile
/CorelIsEPS true def
%%BeginResource: procset wCorel14Dict 14.0 0
/wCorel14Dict 300 dict def wCorel14Dict begin
% Copyright (c)1992-2007 Corel Corporation
% All rights reserved.     v14 r0.0
/bd{bind def}bind def/ld{load def}bd/xd{exch def}bd/_ null def/rp{{pop}repeat}
bd/@cp/closepath ld/@gs/gsave ld/@gr/grestore ld/@np/newpath ld/Tl/translate ld
/$sv 0 def/@sv{/$sv save def}bd/@rs{$sv restore}bd/spg/showpage ld/showpage{}
bd currentscreen/@dsp xd/$dsp/@dsp def/$dsa xd/$dsf xd/$sdf false def/$SDF
false def/$Scra 0 def/SetScr/setscreen ld/@ss{2 index 0 eq{$dsf 3 1 roll 4 -1
roll pop}if exch $Scra add exch load SetScr}bd/SepMode_5 where{pop}{/SepMode_5
0 def}ifelse/CorelIsSeps where{pop}{/CorelIsSeps false def}ifelse
/CorelIsInRIPSeps where{pop}{/CorelIsInRIPSeps false def}ifelse/CorelIsEPS
where{pop}{/CorelIsEPS false def}ifelse/CurrentInkName_5 where{pop}
{/CurrentInkName_5(Composite)def}ifelse/$ink_5 where{pop}{/$ink_5 -1 def}
ifelse/fill_color 6 array def/num_fill_inks 1 def/$o 0 def/$fil 0 def
/outl_color 6 array def/num_outl_inks 1 def/$O 0 def/$PF false def/$bkg false
def/$op false def matrix currentmatrix/$ctm xd/$ptm matrix def/$ttm matrix def
/$stm matrix def/$ffpnt true def/CorelDrawReencodeVect[16#0/grave 16#5/breve
16#6/dotaccent 16#8/ring 16#A/hungarumlaut 16#B/ogonek 16#C/caron 16#D/dotlessi
16#27/quotesingle 16#60/grave 16#7C/bar 16#80/Euro
16#82/quotesinglbase/florin/quotedblbase/ellipsis/dagger/daggerdbl
16#88/circumflex/perthousand/Scaron/guilsinglleft/OE
16#91/quoteleft/quoteright/quotedblleft/quotedblright/bullet/endash/emdash
16#98/tilde/trademark/scaron/guilsinglright/oe 16#9F/Ydieresis
16#A1/exclamdown/cent/sterling/currency/yen/brokenbar/section
16#a8/dieresis/copyright/ordfeminine/guillemotleft/logicalnot/minus/registered/macron
16#b0/degree/plusminus/twosuperior/threesuperior/acute/mu/paragraph/periodcentered
16#b8/cedilla/onesuperior/ordmasculine/guillemotright/onequarter/onehalf/threequarters/questiondown
16#c0/Agrave/Aacute/Acircumflex/Atilde/Adieresis/Aring/AE/Ccedilla
16#c8/Egrave/Eacute/Ecircumflex/Edieresis/Igrave/Iacute/Icircumflex/Idieresis
16#d0/Eth/Ntilde/Ograve/Oacute/Ocircumflex/Otilde/Odieresis/multiply
16#d8/Oslash/Ugrave/Uacute/Ucircumflex/Udieresis/Yacute/Thorn/germandbls
16#e0/agrave/aacute/acircumflex/atilde/adieresis/aring/ae/ccedilla
16#e8/egrave/eacute/ecircumflex/edieresis/igrave/iacute/icircumflex/idieresis
16#f0/eth/ntilde/ograve/oacute/ocircumflex/otilde/odieresis/divide
16#f8/oslash/ugrave/uacute/ucircumflex/udieresis/yacute/thorn/ydieresis]def
/get_ps_level/languagelevel where{pop systemdict/languagelevel get exec}{1
}ifelse def/level2 get_ps_level 2 ge def/level3 get_ps_level 3 ge def
/is_distilling{/product where{pop systemdict/setdistillerparams known product
(Adobe PostScript Parser)ne and}{false}ifelse}bd/is_rip_separation{
is_distilling{false}{level2{currentpagedevice/Separations 2 copy known{get}{
pop pop false}ifelse}{false}ifelse}ifelse}bd/is_current_sep_color{
is_separation{gsave false setoverprint 1 1 1 1 5 -1 roll findcmykcustomcolor 1
setcustomcolor currentgray 0 eq grestore}{pop false}ifelse}bd
/get_sep_color_index{dup length 1 sub 0 1 3 -1 roll{dup 3 -1 roll dup 3 -1 roll
get is_current_sep_color{exit}{exch pop}ifelse}for pop -1}bd/is_separation{
/LumSepsDict where{pop false}{/AldusSepsDict where{pop false}{
is_rip_separation{true}{1 0 0 0 gsave setcmykcolor currentcmykcolor grestore
add add add 0 ne 0 1 0 0 gsave setcmykcolor currentcmykcolor grestore add add
add 0 ne 0 0 1 0 gsave setcmykcolor currentcmykcolor grestore add add add 0 ne
0 0 0 1 gsave setcmykcolor currentcmykcolor grestore add add add 0 ne and and
and not}ifelse}ifelse}ifelse}bind def/is_composite{is_separation not
is_distilling or}bd/is_sim_devicen{level2 level3 not and{is_distilling
is_rip_separation or}{false}ifelse}bd/@PL{/LV where{pop LV 2 ge level2 not and
{@np/Courier findfont 12 scalefont setfont 72 144 m
(The PostScript level set in the Corel application is higher than)show 72 132 m
(the PostScript level of this device. Change the PS Level in the Corel)show 72
120 m(application to Level 1 by selecting the PostScript tab in the print)show
72 108 m(dialog, and selecting Level 1 from the Compatibility drop down list.)
show flush spg quit}if}if}bd/@BeginSysCorelDict{systemdict/Corel30Dict known
{systemdict/Corel30Dict get exec}if systemdict/CorelLexDict known{1 systemdict
/CorelLexDict get exec}if}bd/@EndSysCorelDict{systemdict/Corel30Dict known
{end}if/EndCorelLexDict where{pop EndCorelLexDict}if}bd AutoFlatness{/@ifl{dup
currentflat exch sub 10 gt{
([Error: PathTooComplex; OffendingCommand: AnyPaintingOperator]\n)print flush
@np exit}{currentflat 2 add setflat}ifelse}bd/@fill/fill ld/fill{currentflat{
{@fill}stopped{@ifl}{exit}ifelse}bind loop setflat}bd/@eofill/eofill ld/eofill
{currentflat{{@eofill}stopped{@ifl}{exit}ifelse}bind loop setflat}bd/@clip
/clip ld/clip{currentflat{{@clip}stopped{@ifl}{exit}ifelse}bind loop setflat}
bd/@eoclip/eoclip ld/eoclip{currentflat{{@eoclip}stopped{@ifl}{exit}ifelse}
bind loop setflat}bd/@stroke/stroke ld/stroke{currentflat{{@stroke}stopped
{@ifl}{exit}ifelse}bind loop setflat}bd}if level2{/@ssa{true setstrokeadjust}
bd}{/@ssa{}bd}ifelse/d/setdash ld/j/setlinejoin ld/J/setlinecap ld/M
/setmiterlimit ld/w/setlinewidth ld/O{/$o xd}bd/R{/$O xd}bd/W/eoclip ld/c
/curveto ld/C/c ld/l/lineto ld/L/l ld/rl/rlineto ld/m/moveto ld/n/newpath ld/N
/newpath ld/P{11 rp}bd/u{}bd/U{}bd/A{pop}bd/q/@gs ld/Q/@gr ld/&{}bd/@j{@sv @np}
bd/@J{@rs}bd/g{1 exch sub 0 0 0 1 null 1 set_fill_color/$fil 0 def}bd/G{1 sub
neg 0 0 0 1 null 1 set_outline_color}bd/set_fill_color{/fill_color exch def
/num_fill_inks fill_color length 6 idiv def/bFillDeviceN num_fill_inks 1 gt def
/$fil 0 def}bd/set_outline_color{/outl_color exch def/num_outl_inks outl_color
length 6 idiv def/bOutlDeviceN num_outl_inks 1 gt def}bd
/get_devicen_color_names{dup length 6 idiv dup 5 mul exch getinterval}bd
/create_colorarray_from_devicen_params{/ink_names_temp exch def
/tint_params_temp exch def/ink_values_temp exch def[ink_values_temp aload pop
tint_params_temp aload pop ink_names_temp aload pop]}bd
/get_devicen_color_specs{dup length 6 idiv dup 4 mul getinterval}bd
/get_devicen_color{dup length 6 idiv 0 exch getinterval}bd/mult_devicen_color{
/colorarray exch def/mult_vals exch def 0 1 mult_vals length 1 sub{colorarray
exch dup mult_vals exch get exch dup colorarray exch get 3 -1 roll mul put}for
colorarray}bd/combine_devicen_colors{/colorarray2 exch def/colorarray1 exch def
/num_inks1 colorarray1 length 6 idiv def/num_inks2 colorarray2 length 6 idiv
def/num3 0 def/colorarray3[num_inks1 num_inks2 add 6 mul{0}repeat]def 0 1
num_inks1 1 sub{colorarray1 exch get colorarray3 num3 3 -1 roll put/num3 num3 1
add def}for 0 1 num_inks2 1 sub{colorarray2 exch get colorarray3 num3 3 -1 roll
put/num3 num3 1 add def}for colorarray1 num_inks1 dup 4 mul getinterval
colorarray3 num3 3 -1 roll putinterval/num3 num3 num_inks1 4 mul add def
colorarray2 num_inks2 dup 4 mul getinterval colorarray3 num3 3 -1 roll
putinterval/num3 num3 num_inks2 4 mul add def colorarray1 num_inks1 dup 5 mul
exch getinterval colorarray3 num3 3 -1 roll putinterval/num3 num3 num_inks1 add
def colorarray2 num_inks2 dup 5 mul exch getinterval colorarray3 num3 3 -1 roll
putinterval/num3 num3 num_inks2 add def colorarray3}bd/get_devicen_color_spec{
/colorant_index exch def/colorarray exch def/ncolorants colorarray length 6
idiv def[colorarray colorant_index get colorarray ncolorants colorant_index 4
mul add 4 getinterval aload pop colorarray ncolorants 5 mul colorant_index add
get]}bd/set_devicen_color{level3{/colorarray exch def/numcolorants colorarray
length 6 idiv def colorarray get_devicen_color_specs/tint_params exch def[
/DeviceN colorarray get_devicen_color_names/DeviceCMYK{tint_params
CorelTintTransformFunction}]setcolorspace colorarray get_devicen_color aload
pop setcolor}{/DeviceCMYK setcolorspace devicen_to_cmyk aload pop pop @tc_5
setprocesscolor_5}ifelse}bd/sf{/bmp_fill_fg_color xd}bd/i{dup 0 ne{setflat}
{pop}ifelse}bd/v{4 -2 roll 2 copy 6 -2 roll c}bd/V/v ld/y{2 copy c}bd/Y/y ld
/@w{matrix rotate/$ptm xd matrix scale $ptm dup concatmatrix/$ptm xd 1 eq{$ptm
exch dup concatmatrix/$ptm xd}if 1 w}bd/@g{1 eq dup/$sdf xd{/$scp xd/$sca xd
/$scf xd}if}bd/@G{1 eq dup/$SDF xd{/$SCP xd/$SCA xd/$SCF xd}if}bd/@D{2 index 0
eq{$dsf 3 1 roll 4 -1 roll pop}if 3 copy exch $Scra add exch load SetScr/$dsp
xd/$dsa xd/$dsf xd}bd/$ngx{$SDF{$SCF SepMode_5 0 eq{$SCA}{$dsa}ifelse $SCP @ss
}if}bd/@MN{2 copy le{pop}{exch pop}ifelse}bd/@MX{2 copy ge{pop}{exch pop}
ifelse}bd/InRange{3 -1 roll @MN @MX}bd/@sqr{dup 0 rl dup 0 exch rl neg 0 rl @cp
}bd/currentscale{1 0 dtransform matrix defaultmatrix idtransform dup mul exch
dup mul add sqrt 0 1 dtransform matrix defaultmatrix idtransform dup mul exch
dup mul add sqrt}bd/@unscale{}bd/wDstChck{2 1 roll dup 3 -1 roll eq{1 add}if}
bd/@dot{dup mul exch dup mul add 1 exch sub}bd/@lin{exch pop abs 1 exch sub}bd
/cmyk2rgb{3{dup 5 -1 roll add 1 exch sub dup 0 lt{pop 0}if exch}repeat pop}bd
/rgb2cmyk{3{1 exch sub 3 1 roll}repeat 3 copy @MN @MN 3{dup 5 -1 roll sub neg
exch}repeat}bd/rgb2g{2 index .299 mul 2 index .587 mul add 1 index .114 mul add
4 1 roll pop pop pop}bd/devicen_to_cmyk{/convertcolor exch def convertcolor
get_devicen_color aload pop convertcolor get_devicen_color_specs
CorelTintTransformFunction}bd/WaldoColor_5 where{pop}{/SetRgb/setrgbcolor ld
/GetRgb/currentrgbcolor ld/SetGry/setgray ld/GetGry/currentgray ld/SetRgb2
systemdict/setrgbcolor get def/GetRgb2 systemdict/currentrgbcolor get def
/SetHsb systemdict/sethsbcolor get def/GetHsb systemdict/currenthsbcolor get
def/rgb2hsb{SetRgb2 GetHsb}bd/hsb2rgb{3 -1 roll dup floor sub 3 1 roll SetHsb
GetRgb2}bd/setcmykcolor where{pop/LumSepsDict where{pop/SetCmyk_5{LumSepsDict
/setcmykcolor get exec}def}{/AldusSepsDict where{pop/SetCmyk_5{AldusSepsDict
/setcmykcolor get exec}def}{/SetCmyk_5/setcmykcolor ld}ifelse}ifelse}{
/SetCmyk_5{cmyk2rgb SetRgb}bd}ifelse/currentcmykcolor where{pop/GetCmyk
/currentcmykcolor ld}{/GetCmyk{GetRgb rgb2cmyk}bd}ifelse/setoverprint where
{pop}{/setoverprint{/$op xd}bd}ifelse/currentoverprint where{pop}{
/currentoverprint{$op}bd}ifelse/@tc_5{5 -1 roll dup 1 ge{pop}{4{dup 6 -1 roll
mul exch}repeat pop}ifelse}bd/@trp{exch pop 5 1 roll @tc_5}bd
/setprocesscolor_5{SepMode_5 0 eq{SetCmyk_5}{SepsColor not{4 1 roll pop pop pop
1 exch sub SetGry}{SetCmyk_5}ifelse}ifelse}bd/findcmykcustomcolor where{pop}{
/findcmykcustomcolor{5 array astore}bd}ifelse/Corelsetcustomcolor_exists false
def/setcustomcolor where{pop/Corelsetcustomcolor_exists true def}if CorelIsSeps
true eq CorelIsInRIPSeps false eq and{/Corelsetcustomcolor_exists false def}if
Corelsetcustomcolor_exists false eq{/setcustomcolor{exch aload pop SepMode_5 0
eq{pop @tc_5 setprocesscolor_5}{CurrentInkName_5 eq{4 index}{0}ifelse 6 1 roll
5 rp 1 sub neg SetGry}ifelse}bd}if/@scc_5{dup type/booleantype eq{dup
currentoverprint ne{setoverprint}{pop}ifelse}{1 eq setoverprint}ifelse dup _ eq
{pop setprocesscolor_5 pop}{dup(CorelRegistrationColor)eq{5 rp 1 exch sub
setregcolor}{findcmykcustomcolor exch setcustomcolor}ifelse}ifelse SepMode_5 0
eq{true}{GetGry 1 eq currentoverprint and not}ifelse}bd/colorimage where{pop
/ColorImage{colorimage}def}{/ColorImage{/ncolors xd/$multi xd $multi true eq{
ncolors 3 eq{/daqB xd/daqG xd/daqR xd pop pop exch pop abs{daqR pop daqG pop
daqB pop}repeat}{/daqK xd/daqY xd/daqM xd/daqC xd pop pop exch pop abs{daqC pop
daqM pop daqY pop daqK pop}repeat}ifelse}{/dataaq xd{dataaq ncolors dup 3 eq{
/$dat xd 0 1 $dat length 3 div 1 sub{dup 3 mul $dat 1 index get 255 div $dat 2
index 1 add get 255 div $dat 3 index 2 add get 255 div rgb2g 255 mul cvi exch
pop $dat 3 1 roll put}for $dat 0 $dat length 3 idiv getinterval pop}{4 eq{
/$dat xd 0 1 $dat length 4 div 1 sub{dup 4 mul $dat 1 index get 255 div $dat 2
index 1 add get 255 div $dat 3 index 2 add get 255 div $dat 4 index 3 add get
255 div cmyk2rgb rgb2g 255 mul cvi exch pop $dat 3 1 roll put}for $dat 0 $dat
length ncolors idiv getinterval}if}ifelse}image}ifelse}bd}ifelse/setcmykcolor{
1 5 1 roll null 6 array astore currentoverprint set_current_color/$ffpnt xd}bd
/currentcmykcolor{GetCmyk}bd/setrgbcolor{rgb2cmyk setcmykcolor}bd
/currentrgbcolor{currentcmykcolor cmyk2rgb}bd/sethsbcolor{hsb2rgb setrgbcolor}
bd/currenthsbcolor{currentrgbcolor rgb2hsb}bd/setgray{dup dup setrgbcolor}bd
/currentgray{currentrgbcolor rgb2g}bd/InsideDCS false def/IMAGE/image ld/image
{InsideDCS{IMAGE}{/EPSDict where{pop SepMode_5 0 eq{IMAGE}{dup type/dicttype eq
{dup/ImageType get 1 ne{IMAGE}{dup dup/BitsPerComponent get 8 eq exch
/BitsPerComponent get 1 eq or currentcolorspace 0 get/DeviceGray eq and{
CurrentInkName_5(Black)eq{IMAGE}{dup/DataSource get/TCC xd/Height get abs{TCC
pop}repeat}ifelse}{IMAGE}ifelse}ifelse}{2 index 1 ne{CurrentInkName_5(Black)eq
{IMAGE}{/TCC xd pop pop exch pop abs{TCC pop}repeat}ifelse}{IMAGE}ifelse}
ifelse}ifelse}{IMAGE}ifelse}ifelse}bd}ifelse/WaldoColor_5 true def
/WaldoColor_13 where{pop}{/separate_color{SepMode_5 0 ne{[exch/colorarray_sep
exch def/ink_num -1 def colorarray_sep length 6 idiv 1 gt{colorarray_sep
get_devicen_color_names dup length 1 sub 0 1 3 -1 roll{exch dup 3 -1 roll dup 3
1 roll get CurrentInkName_5 eq{/ink_num exch def}{pop}ifelse}for pop ink_num -1
ne{colorarray_sep ink_num get_devicen_color_spec aload pop pop SepsColor not{
pop pop pop pop 1 0 0 0 5 -1 roll}if null}{0 0 0 0 0 null}ifelse}{
colorarray_sep 5 get $ink_5 4 eq{CurrentInkName_5 eq{colorarray_sep aload pop
pop SepsColor not{pop pop pop pop 0 0 0 1}if null}{0 0 0 0 0 null}ifelse}{
colorarray_sep 0 get colorarray_sep $ink_5 1 add get 3 -1 roll null eq{0 0 0 4
-1 roll SepsColor{4 $ink_5 1 add roll}if null}{pop pop 0 0 0 0 0 null}ifelse
}ifelse}ifelse]}if}bd/separate_cmyk_color{$ink_5 -1 ne{[exch aload pop 3 $ink5
sub index/colorarray_sep exch def/ink_num -1 def colorarray_sep
get_devicen_color_names dup length 1 sub 0 1 3 -1 roll{exch dup 3 -1 roll dup 3
1 roll get CurrentInkName_5 eq{/ink_num exch def}{pop}ifelse}for pop ink_num -1
ne{[colorarray_sep ink_num get_devicen_color_spec aload pop]}{[0 0 0 0 0 null]
}ifelse}if}bd/set_current_color{dup type/booleantype eq{dup currentoverprint ne
{setoverprint}{pop}ifelse}{1 eq setoverprint}ifelse/cur_color exch def
/nNumColors cur_color length 6 idiv def nNumColors 1 eq{cur_color 5 get
(CorelRegistrationColor)eq{cur_color aload pop 5 rp 1 exch sub setregcolor}{
SepMode_5 0 eq{cur_color aload pop dup null eq{pop @tc_5 setprocesscolor_5}{
findcmykcustomcolor exch setcustomcolor}ifelse}{cur_color separate_color aload
pop pop @tc_5 setprocesscolor_5}ifelse}ifelse}{SepMode_5 0 eq{is_distilling
is_rip_separation or{cur_color set_devicen_color}{cur_color devicen_to_cmyk
setprocesscolor_5}ifelse}{cur_color separate_color aload pop pop @tc_5
setprocesscolor_5}ifelse}ifelse SepMode_5 0 eq{true}{GetGry 1 eq
currentoverprint and not}ifelse}bd}ifelse/WaldoColor_13 true def/$fm 0 def
/wfill{1 $fm eq{fill}{eofill}ifelse}bd/@Pf{@sv SepMode_5 0 eq $Psc 0 ne or
$ink_5 3 eq or{0 J 0 j[]0 d fill_color $o set_current_color pop $ctm setmatrix
72 1000 div dup matrix scale dup concat dup Bburx exch Bbury exch itransform
ceiling cvi/Bbury xd ceiling cvi/Bburx xd Bbllx exch Bblly exch itransform
floor cvi/Bblly xd floor cvi/Bbllx xd $Prm aload pop $Psn load exec}{1 SetGry
wfill}ifelse @rs @np}bd/F{matrix currentmatrix $sdf{$scf $sca $scp @ss}if $fil
1 eq{CorelPtrnDoFill}{$fil 2 eq{@ff}{$fil 3 eq{@Pf}{level3{fill_color $o
set_current_color{wfill}{@np}ifelse}{/overprint_flag $o def is_distilling
is_rip_separation or{0 1 num_fill_inks 1 sub{dup 0 gt{/overprint_flag true def
}if fill_color exch get_devicen_color_spec overprint_flag set_current_color{
@gs wfill @gr}{@np exit}ifelse}for}{fill_color overprint_flag set_current_color
{@gs wfill @gr}{@np}ifelse}ifelse}ifelse}ifelse}ifelse}ifelse $sdf{$dsf $dsa
$dsp @ss}if setmatrix}bd/f{@cp F}bd/S{matrix currentmatrix $ctm setmatrix $SDF
{$SCF $SCA $SCP @ss}if level3{outl_color $O set_current_color{matrix
currentmatrix $ptm concat stroke setmatrix}{@np}ifelse}{/overprint_flag $O def
is_distilling is_rip_separation or{0 1 num_outl_inks 1 sub{dup 0 gt{
/overprint_flag true def}if outl_color exch get_devicen_color_spec
overprint_flag set_current_color{matrix currentmatrix $ptm concat @gs stroke
@gr setmatrix}{@np exit}ifelse}for}{outl_color overprint_flag set_current_color
{matrix currentmatrix $ptm concat @gs stroke @gr setmatrix}{@np}ifelse}ifelse
}ifelse $SDF{$dsf $dsa $dsp @ss}if setmatrix}bd/s{@cp S}bd/B{@gs F @gr S}bd/b{
@cp B}bd/_E{5 array astore exch cvlit xd}bd/@cc{currentfile $dat readhexstring
pop}bd/@sm{/$ctm $ctm currentmatrix def}bd/@E{/Bbury xd/Bburx xd/Bblly xd
/Bbllx xd}bd/@c{@cp}bd/@P{/$fil 3 def/$Psn xd/$Psc xd array astore/$Prm xd}bd
/tcc{@cc}def/@B{@gs S @gr F}bd/@b{@cp @B}bd/@sep{CurrentInkName_5(Composite)eq
{/$ink_5 -1 def}{CurrentInkName_5(Cyan)eq{/$ink_5 0 def}{CurrentInkName_5
(Magenta)eq{/$ink_5 1 def}{CurrentInkName_5(Yellow)eq{/$ink_5 2 def}{
CurrentInkName_5(Black)eq{/$ink_5 3 def}{/$ink_5 4 def}ifelse}ifelse}ifelse}
ifelse}ifelse}bd/@whi{@gs -72000 dup m -72000 72000 l 72000 dup l 72000 -72000
l @cp 1 SetGry fill @gr}bd/@neg{[{1 exch sub}/exec cvx currenttransfer/exec
cvx]cvx settransfer @whi}bd/deflevel 0 def/@sax{/deflevel deflevel 1 add def}
bd/@eax{/deflevel deflevel dup 0 gt{1 sub}if def deflevel 0 gt{/eax load}{eax}
ifelse}bd/eax{{exec}forall}bd/@rax{deflevel 0 eq{@rs @sv}if}bd systemdict
/pdfmark known not{/pdfmark/cleartomark ld}if/wclip{1 $fm eq{clip}{eoclip}
ifelse}bd level2{/setregcolor{/neg_flag exch def[/Separation/All/DeviceCMYK{
dup dup dup}]setcolorspace 1.0 neg_flag sub setcolor}bd}{/setregcolor{1 exch
sub dup dup dup setcmykcolor}bd}ifelse/CorelTintTransformFunction{
/colorantSpecArray exch def/nColorants colorantSpecArray length 4 idiv def
/inColor nColorants 1 add 1 roll nColorants array astore def/outColor 4 array
def 0 1 3{/nOutInk exch def 1 0 1 nColorants 1 sub{dup inColor exch get exch 4
mul nOutInk add colorantSpecArray exch get mul 1 exch sub mul}for 1 exch sub
outColor nOutInk 3 -1 roll put}for outColor aload pop}bind def
% Copyright (c)1992-2007 Corel Corporation
% All rights reserved.     v14 r0.0
/@ii{concat 3 index 3 index m 3 index 1 index l 2 copy l 1 index 3 index l 3
index 3 index l clip pop pop pop pop}bd/@i{@sm @gs @ii 6 index 1 ne{/$frg true
def pop pop}{1 eq{bmp_fill_fg_color $O set_current_color/$frg xd}{/$frg false
def}ifelse 1 eq{@gs $ctm setmatrix F @gr}if}ifelse @np/$ury xd/$urx xd/$lly xd
/$llx xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul 8 div ceiling cvi string
def $bkg $frg or{$SDF{$SCF $SCA $SCP @ss}if $llx $lly Tl $urx $llx sub $ury
$lly sub scale $bkg{fill_color set_current_color pop}if $wid $hei abs $bts 1 eq
{$bkg}{$bts}ifelse[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse]/tcc load $bts
1 eq{imagemask}{image}ifelse $SDF{$dsf $dsa $dsp @ss}if}{$hei abs{tcc pop}
repeat}ifelse @gr $ctm setmatrix}bd/@I{@sm @gs @ii @np/$ury xd/$urx xd/$lly xd
/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd $ngx $llx $lly Tl $urx $llx sub $ury
$lly sub scale $wid $hei abs $bts[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse
]/$dat $wid $bts mul $ncl mul 8 div ceiling cvi string def $msimage false eq
$ncl 1 eq or{/@cc load false $ncl ColorImage}{$wid $bts mul 8 div ceiling cvi
$ncl 3 eq{dup dup/$dat1 exch string def/$dat2 exch string def/$dat3 exch string
def/@cc1 load/@cc2 load/@cc3 load}{dup dup dup/$dat1 exch string def/$dat2 exch
string def/$dat3 exch string def/$dat4 exch string def/@cc1 load/@cc2 load
/@cc3 load/@cc4 load}ifelse true $ncl ColorImage}ifelse $SDF{$dsf $dsa $dsp
@ss}if @gr $ctm setmatrix}bd/@cc1{currentfile $dat1 readhexstring pop}bd/@cc2{
currentfile $dat2 readhexstring pop}bd/@cc3{currentfile $dat3 readhexstring pop
}bd/@cc4{currentfile $dat4 readhexstring pop}bd/$msimage false def/COMP 0 def
/MaskedImage false def/bImgDeviceN false def/nNumInksDeviceN 0 def
/sNamesDeviceN[]def/tint_params[]def level2{/@I_2{@sm @gs @ii @np/$ury xd/$urx
xd/$lly xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul $ncl mul
8 div ceiling cvi string def $ngx $ncl 1 eq{/DeviceGray}{$ncl 3 eq{/DeviceRGB}
{/DeviceCMYK}ifelse}ifelse setcolorspace $llx $lly Tl $urx $llx sub $ury $lly
sub scale 8 dict begin/ImageType 1 def/Width $wid def/Height $hei abs def
/BitsPerComponent $bts def/Decode $ncl 1 eq{[0 1]}{$ncl 3 eq{[0 1 0 1 0 1]}{[0
1 0 1 0 1 0 1]}ifelse}ifelse def/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt
{$hei}{0}ifelse]def/DataSource currentfile/ASCII85Decode filter COMP 1 eq
{/DCTDecode filter}{COMP 2 eq{/RunLengthDecode filter}{COMP 3 eq{/LZWDecode
filter}if}ifelse}ifelse def currentdict end image $SDF{$dsf $dsa $dsp @ss}if
@gr $ctm setmatrix}bd}{/@I_2{}bd}ifelse level2{/@I_2D{@sm @gs @ii @np/$ury xd
/$urx xd/$lly xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd $ngx/scanline $wid
$bts mul $ncl mul 8 div ceiling cvi string def/readscanline{currentfile
scanline readhexstring pop}bind def level3{[/DeviceN sNamesDeviceN/DeviceCMYK{
tint_params CorelTintTransformFunction}]setcolorspace $llx $lly Tl $urx $llx
sub $ury $lly sub scale 8 dict begin/ImageType 1 def/Width $wid def/Height $hei
abs def/BitsPerComponent $bts def/Decode[nNumInksDeviceN{0 1}repeat]def
/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}ifelse]def/DataSource{
readscanline}def currentdict end image}{/scanline_height $lly $ury sub 1 sub
$hei div def/plate_scanline $wid string def/cmyk_scanline $wid 4 mul string def
is_distilling is_rip_separation or{/bSimDeviceN true def}{/bSimDeviceN false
def}ifelse/scanline_img_dict 8 dict begin/ImageType 1 def/Width $wid def
/Height 1 def/BitsPerComponent $bts def/Decode bSimDeviceN{[0 1]}{[0 1 0 1 0 1
0 1]}ifelse def/ImageMatrix[$wid 0 0 1 neg 0 1]def/DataSource bSimDeviceN{
plate_scanline}{cmyk_scanline}ifelse def currentdict end def 0 1 $hei 1 sub{
@gs/nScanIndex exch def readscanline pop/$t_lly $ury $lly scanline_height
nScanIndex mul sub sub ceiling cvi def/$t_ury $t_lly scanline_height sub
ceiling cvi def bSimDeviceN{0 1 $ncl 1 sub{@gs/nInkIndex exch def 0 1
plate_scanline length 1 sub{dup $ncl mul nInkIndex add scanline exch get
plate_scanline 3 1 roll put}for[0 1 $ncl 1 sub{nInkIndex eq{1.0}{0.0}ifelse
}for]/sepTintTransformParams exch def[/Separation sNamesDeviceN nInkIndex get
/DeviceCMYK{sepTintTransformParams aload pop tint_params
CorelTintTransformFunction @tc_5}]setcolorspace $llx $t_lly Tl $urx $llx sub
$t_ury $t_lly sub scale nInkIndex 0 eq currentoverprint not and{false
setoverprint}{true setoverprint}ifelse scanline_img_dict image @gr}for}{0 1
$wid 1 sub{dup $ncl mul scanline exch $ncl getinterval 0 1 $ncl 1 sub{2 copy
get 255 div 3 1 roll pop}for pop tint_params CorelTintTransformFunction 5 -1
roll cmyk_scanline exch 0 1 3{3 1 roll 2 copy 5 -1 roll dup 8 exch sub index
255 mul cvi 3 1 roll exch 4 mul add exch put}for 6 rp}for/DeviceCMYK
setcolorspace $llx $t_lly Tl $urx $llx sub $t_ury $t_lly sub scale
scanline_img_dict image}ifelse @gr}for}ifelse $SDF{$dsf $dsa $dsp @ss}if @gr
$ctm setmatrix}bd}{/@I_2D{}bd}ifelse/@I_3{@sm @gs @ii @np/$ury xd/$urx xd/$lly
xd/$llx xd/$ncl xd/$bts xd/$hei xd/$wid xd/$dat $wid $bts mul $ncl mul 8 div
ceiling cvi string def $ngx bImgDeviceN{[/DeviceN sNamesDeviceN/DeviceCMYK{
tint_params CorelTintTransformFunction}]}{$ncl 1 eq{/DeviceGray}{$ncl 3 eq
{/DeviceRGB}{/DeviceCMYK}ifelse}ifelse}ifelse setcolorspace $llx $lly Tl $urx
$llx sub $ury $lly sub scale/ImageDataDict 8 dict def ImageDataDict begin
/ImageType 1 def/Width $wid def/Height $hei abs def/BitsPerComponent $bts def
/Decode[$ncl{0 1}repeat]def/ImageMatrix[$wid 0 0 $hei neg 0 $hei 0 gt{$hei}{0}
ifelse]def/DataSource currentfile/ASCII85Decode filter COMP 1 eq{/DCTDecode
filter}{COMP 2 eq{/RunLengthDecode filter}{COMP 3 eq{/LZWDecode filter}if}
ifelse}ifelse def end/MaskedImageDict 7 dict def MaskedImageDict begin
/ImageType 3 def/InterleaveType 3 def/MaskDict ImageMaskDict def/DataDict
ImageDataDict def end MaskedImageDict image $SDF{$dsf $dsa $dsp @ss}if @gr $ctm
setmatrix}bd/@SetMask{/$mbts xd/$mhei xd/$mwid xd/ImageMaskDict 8 dict def
ImageMaskDict begin/ImageType 1 def/Width $mwid def/Height $mhei abs def
/BitsPerComponent $mbts def/DataSource maskstream def/ImageMatrix[$mwid 0 0
$mhei neg 0 $mhei 0 gt{$mhei}{0}ifelse]def/Decode[1 0]def end}bd/@daq{dup type
/arraytype eq{{}forall}if}bd/@BMP{/@cc xd UseLevel 3 eq MaskedImage true eq and
{7 -2 roll pop pop @I_3}{12 index 1 gt UseLevel 2 eq UseLevel 3 eq or and{7 -2
roll pop pop bImgDeviceN{@I_2D}{@I_2}ifelse}{11 index 1 eq{12 -1 roll pop @i}{
7 -2 roll pop pop @I}ifelse}ifelse}ifelse}bd/disable_raster_output{/@BMP load
/old_raster_func exch bind def/@BMP{8 rp/$ury xd/$urx xd/$lly xd/$llx xd/$ncl
xd/$bts xd/$hei xd/$wid xd/scanline $wid $bts mul $ncl mul 8 div ceiling cvi
string def 0 1 $hei 1 sub{currentfile scanline readhexstring pop pop pop}for
}def}bd/enable_raster_output{/old_raster_func where{pop/old_raster_func load
/@BMP exch bd}if}bd
end
%%EndResource
%%EndProlog
%%BeginSetup
wCorel14Dict begin
@BeginSysCorelDict
@ssa
1.00 setflat
/$fst 128 def
%%EndSetup

%%Page: 1 1
%%ViewingOrientation: 0 1 1 0
%LogicalPage: 1
%%BeginPageSetup
@sv
@sm
@sv
%%EndPageSetup
@rax %Note: Object
216.76819 234.13946 243.06180 279.31833 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
228.57477 236.35332 m
227.83691 236.35332 L
222.30170 236.35332 221.19562 243.55843 221.19562 248.89748 C
221.19562 253.65685 223.88712 260.70435 228.57477 260.70435 C
236.83890 260.70435 235.62510 236.35332 228.57477 236.35332 C
@c
230.80195 278.30948 m
234.47792 276.20022 L
234.09893 259.64334 L
232.26435 262.17950 L
223.35080 262.17950 216.76819 261.78746 216.76819 250.37263 C
216.76819 245.94548 L
216.76819 241.93531 218.15235 241.97528 218.24476 237.82876 C
221.54230 236.94831 220.43310 234.13946 227.09962 234.13946 C
229.31348 234.13946 L
231.19115 234.13946 232.71506 236.64784 234.47792 237.82876 C
234.47792 234.87676 L
242.59550 234.87676 L
243.06180 235.47912 L
238.90564 237.82876 L
238.88438 279.31833 L
230.80195 278.30948 L
@c
F

@rax %Note: Object
306.05556 294.64724 333.32003 339.08939 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
306.06831 338.07912 m
306.05556 335.96986 L
308.41994 335.91770 309.74485 336.21052 309.74485 333.75600 C
309.74485 302.76482 L
309.74485 299.23257 309.52913 297.15024 306.05556 296.86110 C
306.05556 294.64724 L
309.00472 294.67247 L
317.12400 295.38539 L
317.09537 296.77124 L
314.17200 297.59924 L
314.17200 314.57083 L
314.17200 316.07773 316.56302 319.73669 318.59972 319.73669 C
321.55172 319.73669 L
324.44504 319.73669 325.24072 316.08624 325.24072 313.09512 C
325.15625 297.74013 L
321.55172 295.38539 L
327.10734 295.38539 332.57480 293.92894 333.32003 296.71143 C
329.66844 297.59924 L
329.66844 317.52283 L
329.66844 319.30838 326.28841 322.68784 324.50258 322.68784 C
321.55172 322.68784 L
316.23222 322.68784 317.09537 320.79458 314.17200 319.73669 C
314.15131 339.08939 L
306.06831 338.07912 L
@c
F

@rax %Note: Object
156.99827 294.64724 185.38724 322.68784 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
165.85342 319.73669 m
165.09090 322.13650 L
157.73556 321.21184 L
157.73556 318.99827 L
159.81959 318.82479 160.68756 319.01584 160.68756 316.78469 C
160.68756 299.07496 L
160.68756 296.62016 159.36293 296.91411 156.99827 296.86110 C
156.99827 294.64724 L
168.80428 294.64724 L
168.76715 296.71143 L
165.11528 297.59924 L
165.11528 308.66797 L
165.11528 313.89987 166.51389 319.73669 171.75628 319.73669 C
172.49443 319.73669 L
174.89310 319.73669 173.05172 319.09663 175.98246 318.24028 C
176.92214 308.66797 L
177.28101 305.15839 176.18400 301.41893 175.87871 297.31408 C
173.23200 294.64724 L
185.38724 295.18413 L
181.34929 297.59924 L
181.34929 306.68769 183.80381 322.68784 174.70828 322.68784 C
171.75628 322.68784 L
168.40346 322.68784 167.90740 321.11178 165.85342 319.73669 C
@c
F

@rax %Note: Object
245.08035 344.82472 267.68409 379.72403 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.12 0.12 0.00 null ] set_fill_color
249.97436 379.72403 m
245.54665 379.50718 L
245.54665 378.03061 L
247.91102 377.97846 249.23650 378.27128 249.23650 375.81704 C
248.81499 348.32069 L
245.08035 345.42709 L
245.54665 344.82472 L
249.97209 344.86044 L
260.30523 345.56287 L
262.51909 345.56287 L
267.68211 345.56287 267.48425 344.69575 267.68409 353.67959 C
265.48753 353.67732 L
264.73294 347.77672 L
253.66422 347.77672 L
253.66422 362.53446 L
262.51909 362.53446 L
262.51909 359.58359 L
264.73294 359.58359 L
264.20060 368.04529 L
262.51909 364.74831 L
253.66422 364.74831 L
253.66422 377.29332 L
263.62261 377.10340 L
266.20838 372.86617 L
266.20838 379.50718 L
260.30523 379.72403 L
249.97436 379.72403 L
@c
F

@rax %Note: Object
187.99087 234.13946 215.68649 262.17950 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
187.99087 259.96564 m
191.67987 259.22750 L
191.67987 239.30391 L
191.67987 235.60980 196.62917 234.13946 200.53474 234.13946 C
202.96828 234.13946 205.13282 235.70759 205.69975 237.82876 C
207.17603 237.82876 L
207.34923 235.74557 207.15846 234.87676 209.38961 234.87676 C
211.60346 234.87676 L
213.59650 234.87676 213.63732 235.22967 215.29276 235.61490 C
215.68649 236.42617 L
211.60346 237.82876 L
211.60346 262.17950 L
205.69975 262.17950 L
203.65852 262.17950 203.92526 261.61058 203.52444 260.11672 C
207.17603 259.22750 L
207.17603 243.73162 L
207.17603 240.02220 203.50658 236.35332 199.79688 236.35332 C
191.50129 236.35332 200.20791 262.17950 193.89373 262.17950 C
190.20416 262.17950 L
188.45943 262.17950 188.03764 261.67068 187.99087 259.96564 C
@c
F

@rax %Note: Object
277.27710 293.90995 304.07811 322.59288 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
288.34583 297.59924 m
288.01899 298.27984 286.13197 302.33707 286.13197 302.76482 C
286.13197 310.88183 L
286.13197 314.31798 288.37276 319.73669 291.29698 319.73669 C
296.46227 319.73669 L
297.13776 316.83600 299.41398 313.34797 299.41398 310.14312 C
299.41398 305.25931 297.65367 296.12381 293.51027 296.12381 C
289.19339 296.16038 L
288.34583 297.59924 L
@c
281.70425 298.33739 m
286.13197 299.07496 L
286.13197 297.59924 L
288.34583 297.59924 L
287.60740 296.12381 L
288.70214 294.62995 289.30195 293.90995 292.03483 293.90995 C
293.51027 293.90995 L
299.40917 293.90995 304.74992 301.39455 304.00894 308.68894 C
303.10356 316.78469 L
298.09219 318.80750 298.60271 327.34942 286.13197 318.99827 C
286.12318 322.02255 L
277.27710 321.21184 L
277.32132 319.86454 L
281.73317 318.26013 L
281.70425 298.33739 L
@c
F

@rax %Note: Object
190.94173 295.07329 204.96217 320.47398 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
201.27288 296.12381 m
202.14964 299.40661 204.96217 301.85518 204.96217 307.92983 C
204.96217 313.09030 202.80614 320.47398 198.32088 320.47398 C
192.99600 320.47398 190.94173 313.63228 190.94173 308.66797 C
190.94173 307.92983 L
191.78447 299.82614 L
197.32139 295.07329 L
201.27288 296.12381 L
@c
F

@rax %Note: Object
272.11124 197.98129 286.13197 221.59531 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
272.11124 207.57487 m
272.11124 202.66809 274.57172 197.98129 280.22825 197.98129 C
284.67553 197.98129 286.13197 203.28661 286.13197 207.57487 C
286.13197 211.26387 L
286.13197 219.92513 283.94957 219.10054 278.75254 221.59531 C
274.73216 218.90211 272.11124 217.91906 272.11124 210.52658 C
272.11124 207.57487 L
@c
F

@rax %Note: Object
292.77298 234.13946 314.91043 262.91792 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
297.93798 245.94548 m
300.91663 247.02435 299.43609 248.89748 302.36513 248.89748 C
306.79285 248.89748 L
306.79285 244.46976 L
306.79285 241.29553 305.93282 240.47036 305.31713 237.82876 C
300.16375 237.02598 L
297.99099 237.96652 L
297.69931 242.98498 L
297.93798 245.94548 L
@c
295.72413 254.80035 m
300.21959 256.00139 296.62894 259.96564 300.88998 259.96564 C
302.36513 259.96564 L
304.35846 259.96564 304.40041 259.61357 306.05556 259.22750 C
306.44079 257.57348 306.79285 257.53181 306.79285 255.53849 C
306.79285 251.11077 L
302.36513 251.11077 L
298.70589 251.11077 292.77298 246.10564 292.77298 242.99433 C
292.77298 238.32085 295.34683 234.13946 300.15184 234.13946 C
302.82208 234.13946 304.57984 235.05392 305.31713 237.09061 C
306.15109 237.42454 L
307.37254 234.37106 L
310.99805 235.11912 313.99795 233.67487 314.91043 237.09061 C
311.16728 238.45266 L
311.22000 258.49049 L
309.64706 260.83984 307.74813 262.91792 303.84170 262.91792 C
297.06208 262.91792 297.18425 260.01213 294.24869 259.22750 C
295.72413 254.80035 L
@c
F

@rax %Note: Object
255.87808 293.70926 277.27710 321.94998 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
260.30523 303.50211 m
259.57672 307.81276 269.16038 310.86595 269.16038 306.45411 C
269.16038 302.76482 L
269.16038 300.06737 267.12340 296.86110 264.73294 296.86110 C
262.73962 296.86110 262.69795 297.21317 261.04252 297.59924 C
260.30523 303.50211 L
@c
256.61537 318.26013 m
259.43726 314.65984 L
262.51909 319.73669 L
264.73294 319.73669 L
266.72513 319.73669 266.76680 319.38378 268.42224 318.99827 C
268.80746 317.34312 269.16038 317.30230 269.16038 315.30898 C
269.16038 310.88183 L
266.94652 310.88183 L
261.94479 310.88183 255.87808 307.78923 255.87808 302.76482 C
255.87808 301.28825 L
255.87808 296.57282 257.94085 293.90995 262.51909 293.90995 C
263.99452 293.90995 L
265.54961 293.90995 268.27739 296.66920 269.16038 297.59924 C
269.18391 293.70926 L
277.27710 294.64724 L
277.23855 296.71143 L
273.58696 297.59924 L
273.82649 310.89033 L
273.58696 317.52283 L
272.10898 319.73131 271.44737 321.94998 267.68409 321.94998 C
263.99452 321.94998 L
261.11169 321.94998 258.55115 319.55698 256.61537 318.26013 C
@c
F

@rax %Note: Object
134.12296 293.90995 155.52227 322.68784 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
139.28854 311.61912 m
139.65732 314.99093 141.67587 319.73669 145.92954 319.73669 C
148.88069 319.73669 L
150.71556 311.69480 L
139.28854 311.61912 L
@c
134.12296 308.66797 m
134.12296 307.19140 L
134.12296 302.30901 138.03789 293.90995 142.23969 293.90995 C
148.88069 293.90995 L
151.78139 293.90995 155.44970 297.30614 155.52227 300.55096 C
152.58076 299.76491 150.67304 296.12381 148.14340 296.12381 C
147.40526 296.12381 L
140.31638 296.12381 139.28854 301.60573 139.28854 308.66797 C
155.52227 308.66797 L
155.52227 315.07285 152.65304 322.68784 146.66740 322.68784 C
145.92954 322.68784 L
139.77213 322.68784 134.12296 314.69783 134.12296 308.66797 C
@c
F

@rax %Note: Object
286.13197 296.12381 299.41398 319.73669 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
288.34583 297.59924 m
289.19339 296.16038 L
293.51027 296.12381 L
297.65367 296.12381 299.41398 305.25931 299.41398 310.14312 C
299.41398 313.34797 297.13776 316.83600 296.46227 319.73669 C
291.29698 319.73669 L
288.37276 319.73669 286.13197 314.31798 286.13197 310.88183 C
286.13197 302.76482 L
286.13197 302.33707 288.01899 298.27984 288.34583 297.59924 C
@c
F

@rax %Note: Object
221.19562 236.35332 234.32343 260.70435 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
228.57477 236.35332 m
235.62510 236.35332 236.83890 260.70435 228.57477 260.70435 C
223.88712 260.70435 221.19562 253.65685 221.19562 248.89748 C
221.19562 243.55843 222.30170 236.35332 227.83691 236.35332 C
228.57477 236.35332 L
@c
F

@rax %Note: Object
186.51430 293.90995 209.38961 321.94998 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
201.27288 296.12381 m
197.32139 295.07329 L
191.78447 299.82614 L
190.94173 307.92983 L
190.94173 308.66797 L
190.94173 313.63228 192.99600 320.47398 198.32088 320.47398 C
202.80614 320.47398 204.96217 313.09030 204.96217 307.92983 C
204.96217 301.85518 202.14964 299.40661 201.27288 296.12381 C
@c
207.17603 299.07496 m
209.38961 303.50211 L
207.91304 318.26013 L
205.13991 319.00110 203.45528 321.94998 201.27288 321.94998 C
195.36917 321.94998 L
190.80652 321.94998 186.51430 315.97512 186.51430 311.61912 C
186.51430 307.19140 L
186.51430 300.95376 190.16929 293.90995 195.36917 293.90995 C
198.32088 293.90995 L
202.78743 293.90995 205.39814 296.42088 207.17603 299.07496 C
@c
F

@rax %Note: Object
348.11546 293.90995 368.77720 322.68784 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
357.33997 320.10520 m
359.92233 320.47398 L
362.84428 320.47398 364.28570 314.49231 364.34948 311.61912 C
353.28076 311.61912 L
355.12611 317.89134 L
357.33997 320.10520 L
@c
348.11546 310.88183 m
348.11546 304.24025 L
348.11546 300.26806 352.53496 293.90995 358.44661 293.90995 C
360.66047 293.90995 L
364.52409 293.90995 368.43392 296.42457 368.77720 300.55096 C
366.54945 299.95569 362.55231 296.12381 360.66047 296.12381 C
356.12759 296.12381 353.28076 300.03279 353.28076 304.24025 C
353.28076 309.40526 L
368.77720 309.40526 L
368.77720 312.35698 L
368.77720 317.64813 364.46995 320.31780 363.61134 322.68784 C
356.97033 322.68784 L
353.71757 322.68784 348.11546 314.39225 348.11546 310.88183 C
@c
F

@rax %Note: Object
211.60346 277.67565 233.74063 307.92983 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
229.14964 284.34132 m
227.54920 283.13575 226.02586 280.62737 224.14762 280.62737 C
219.71991 280.62737 L
217.32236 280.62737 214.55461 285.18661 214.55461 287.26894 C
214.55461 291.20372 217.64523 293.17181 221.93376 293.17181 C
224.14762 293.17181 L
226.45134 293.17181 228.41802 291.82195 230.13950 290.94491 C
229.14964 284.34132 L
@c
215.29276 306.45411 m
216.19219 303.54491 L
213.80117 302.80507 L
213.81704 296.12381 L
216.03090 293.17181 L
212.89323 292.91046 211.60346 291.32334 211.60346 288.00624 C
211.60346 285.05509 L
211.60346 280.03181 215.54561 281.05569 216.76819 277.67565 C
226.14265 277.67565 233.74063 280.26595 233.74063 289.48224 C
233.74063 303.57921 216.76819 294.68835 216.76819 300.55096 C
216.76110 302.79969 L
221.19562 303.50211 L
221.93376 305.71597 L
218.24476 306.45411 L
216.76819 306.45411 L
216.76819 307.92983 L
215.29276 306.45411 L
@c
F

@rax %Note: Object
348.11546 234.13946 368.77720 262.91792 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
353.28076 251.84920 m
353.36098 255.45657 355.22986 260.70435 358.44661 260.70435 C
359.92233 260.70435 L
362.30740 260.70435 363.61134 258.02504 363.61134 255.53849 C
363.61134 251.11077 L
357.71102 251.86592 L
353.28076 251.84920 L
@c
352.54261 249.63534 m
368.03877 249.63534 L
368.03877 256.27663 L
368.03877 257.69820 363.85257 262.91792 362.13562 262.91792 C
361.39776 262.91792 L
353.29408 262.07490 L
352.67499 260.50649 348.11546 254.61468 348.11546 251.84920 C
348.11546 246.68362 L
348.11546 240.16791 351.96520 234.13946 358.44661 234.13946 C
360.66047 234.13946 L
364.62671 234.13946 368.01014 237.48775 368.77720 240.78047 C
365.61061 240.43380 363.85965 236.35332 359.92233 236.35332 C
356.15367 236.35332 352.54261 241.67367 352.54261 245.20819 C
352.54261 249.63534 L
@c
F

@rax %Note: Object
268.42224 189.86485 293.28888 223.07074 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
272.11124 207.57487 m
272.11124 210.52658 L
272.11124 217.91906 274.73216 218.90211 278.75254 221.59531 C
283.94957 219.10054 286.13197 219.92513 286.13197 211.26387 C
286.13197 207.57487 L
286.13197 203.28661 284.67553 197.98129 280.22825 197.98129 C
274.57172 197.98129 272.11124 202.66809 272.11124 207.57487 C
@c
268.42224 209.78872 m
268.42224 199.46324 275.70359 194.59219 283.91811 196.50614 C
284.95446 194.95899 289.15795 189.86485 291.29698 189.86485 C
291.39619 189.86485 292.75824 190.59109 292.77298 190.60299 C
293.28888 191.20450 L
285.75808 197.66863 L
287.44441 198.97852 L
287.73213 204.29943 289.82126 201.33950 289.82126 204.62287 C
289.82126 213.47773 L
289.82126 218.53332 285.42869 223.07074 280.22825 223.07074 C
273.37323 223.07074 273.47159 219.19946 269.89739 217.90488 C
269.89739 215.69131 L
269.89739 212.46831 268.42224 213.01143 268.42224 209.78872 C
@c
F

@rax %Note: Object
100.17978 293.44422 117.15137 322.68784 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
100.91707 316.04627 m
100.91707 313.83269 L
100.91707 309.75562 103.58589 310.01159 104.60750 307.19140 C
106.82079 307.19140 L
108.16299 307.19140 112.72394 303.96501 112.72394 302.02696 C
112.72394 299.81310 L
112.72394 297.89546 110.08998 296.12381 109.03465 296.12381 C
99.45043 296.12381 105.65575 303.08854 100.91707 303.50211 C
100.72545 301.19443 100.17978 300.88091 100.17978 298.33739 C
100.17978 295.38539 L
111.78170 292.68198 111.43219 291.21789 117.15137 302.02696 C
115.17222 306.15250 116.37751 307.66904 111.98494 310.14227 C
110.18778 311.15367 103.86907 313.86756 103.86907 316.04627 C
103.86907 317.76775 105.83773 319.73669 107.55808 319.73669 C
110.51008 319.73669 L
112.23780 319.73669 113.46236 318.51213 113.46236 316.78469 C
113.46236 314.57083 L
114.93780 314.57083 L
115.32274 316.22570 115.67565 316.26765 115.67565 318.26013 C
115.67565 320.47398 L
112.86000 321.22602 111.85682 322.68784 107.55808 322.68784 C
105.49020 322.68784 100.91707 319.39909 100.91707 316.04627 C
@c
F

@rax %Note: Object
288.51704 344.82472 309.00671 369.17575 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
293.51027 350.72872 m
293.51027 358.06422 290.69008 366.96217 300.15184 366.96217 C
302.66589 366.96217 304.57899 362.85279 304.57899 360.32088 C
304.57899 355.89345 L
304.57899 351.03090 303.41906 346.30129 298.67613 346.30129 C
295.67112 346.30129 294.75780 348.86693 293.51027 350.72872 C
@c
300.15184 344.82472 m
304.80831 344.82472 309.00671 349.97301 309.00671 355.15616 C
309.00671 358.84545 L
309.00671 365.30192 305.13260 369.17575 298.67613 369.17575 C
297.20069 369.17575 L
286.96365 369.17575 283.29761 344.82472 300.15184 344.82472 C
@c
F

@rax %Note: Object
118.62680 293.90995 133.38482 329.32885 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
122.31723 325.63956 m
122.31723 321.21184 L
118.62680 321.21184 L
118.89213 318.02542 119.04350 318.33326 122.31723 318.26013 C
122.31723 301.28825 L
122.31723 297.22961 123.29405 293.90995 127.48167 293.90995 C
131.49184 293.90995 132.07493 294.38419 133.38482 296.86110 C
128.21981 296.86110 L
128.21981 298.33739 L
126.59896 298.34646 L
127.48167 315.30898 L
127.48167 318.99827 L
128.34737 318.76894 129.49313 318.26013 129.69553 318.26013 C
131.38554 318.26013 130.55414 318.51043 132.64753 318.99827 C
132.20816 320.64321 132.47490 321.21184 130.43367 321.21184 C
127.48167 321.21184 L
127.48167 329.32885 L
125.28028 329.14545 122.31723 327.84094 122.31723 325.63956 C
@c
F

@rax %Note: Object
293.11682 346.30129 304.57899 366.96217 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
293.51027 350.72872 m
294.75780 348.86693 295.67112 346.30129 298.67613 346.30129 C
303.41906 346.30129 304.57899 351.03090 304.57899 355.89345 C
304.57899 360.32088 L
304.57899 362.85279 302.66589 366.96217 300.15184 366.96217 C
290.69008 366.96217 293.51027 358.06422 293.51027 350.72872 C
@c
F

@rax %Note: Object
322.11893 344.82472 340.16570 369.17575 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
326.71644 359.58359 m
326.84117 365.16926 327.97134 367.25216 333.35745 367.70031 C
336.74967 359.77096 L
326.71644 359.58359 L
@c
322.28872 360.32088 m
322.11893 358.82731 L
323.02687 349.25244 L
326.84258 347.87197 324.35858 344.82472 329.66844 344.82472 C
331.88173 344.82472 L
336.33638 344.82472 339.65433 346.59128 339.99874 350.72872 C
336.19351 349.71250 337.32028 347.03858 332.62044 347.03858 C
331.14387 347.03858 L
328.44869 347.03858 326.71644 352.04060 326.71644 355.15616 C
326.71644 357.36973 L
340.16570 357.39071 L
339.26145 365.48646 L
336.90104 367.06649 336.32447 369.17575 332.62044 369.17575 C
331.14387 369.17575 L
326.90353 369.17575 322.28872 363.09231 322.28872 360.32088 C
@c
F

@rax %Note: Object
176.18400 219.38173 184.30044 262.17950 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
184.30044 262.17950 m
176.18400 262.17950 L
176.60551 258.89046 176.34614 259.30715 179.87301 259.22750 C
179.87301 231.92561 L
179.87301 224.78230 177.28526 222.70762 176.92214 219.38173 C
182.67534 220.72110 184.30044 226.35808 184.30044 233.40104 C
184.30044 262.17950 L
@c
F

@rax %Note: Object
258.08315 234.13946 276.53896 262.91792 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
262.51909 252.58649 m
262.51909 254.11266 264.98580 259.96564 267.68409 259.96564 C
269.89739 259.96564 L
271.89071 259.96564 271.93266 259.61357 273.58696 259.22750 C
274.45124 253.34646 L
275.80054 253.32463 L
275.80054 259.96564 L
275.80054 262.76939 270.55984 262.91792 267.68409 262.91792 C
257.43288 262.91792 258.09137 249.51090 258.09137 240.78047 C
260.28255 237.50816 262.94854 234.13946 268.42224 234.13946 C
273.02740 234.13946 276.17981 235.72205 276.53896 240.04261 C
274.32510 240.04261 L
274.32510 237.82876 L
269.97846 237.46706 272.78617 236.35332 269.89739 236.35332 C
263.76520 236.35332 265.84838 240.17414 262.51909 241.51776 C
262.51909 252.58649 L
@c
F

@rax %Note: Object
212.16784 302.76482 235.95449 322.68784 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
213.07890 308.66797 m
215.29276 306.45411 L
216.76819 307.92983 L
216.76819 306.45411 L
218.24476 306.45411 L
217.10636 318.23660 L
219.02740 319.27918 219.42198 320.47398 221.19562 320.47398 C
225.67720 320.47398 227.09962 316.57124 227.09962 312.35698 C
227.09962 309.37833 225.16129 307.63162 224.14762 305.71597 C
221.93376 305.71597 L
221.19562 303.50211 L
223.40948 302.76482 L
224.55553 305.60343 231.52677 305.23720 231.52677 313.83269 C
231.52677 315.96265 230.14120 315.67068 230.28945 320.14800 C
235.10466 317.54721 L
235.95449 321.94998 L
233.97534 322.42337 234.56353 322.68784 233.00249 322.68784 C
230.29398 322.68784 229.43537 321.54491 227.83691 320.47398 C
226.31669 321.49247 225.92211 322.68784 224.14762 322.68784 C
219.71991 322.68784 L
215.31798 322.68784 210.00416 315.07654 213.07890 308.66797 C
@c
F

@rax %Note: Object
321.55172 196.58948 338.52331 225.28460 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
331.14387 197.24400 m
327.45458 197.98129 L
327.45458 208.31272 L
327.45458 209.68299 329.27953 212.74044 331.14387 212.74044 C
331.88173 212.74044 L
334.18091 212.74044 335.57102 209.08942 335.57102 206.83616 C
335.57102 202.62161 333.68428 198.94450 331.14387 197.24400 C
@c
321.55172 223.80888 m
323.71200 222.93298 L
323.76529 200.19515 L
323.76529 197.24400 L
331.86444 196.56964 338.52331 194.04312 338.52331 206.83616 C
338.52331 210.95206 335.78419 214.95402 331.88173 214.95402 C
330.14126 214.95402 328.59893 213.50636 327.45458 212.74044 C
327.45458 225.28460 L
321.55172 225.28460 L
321.55172 223.80888 L
@c
F

@rax %Note: Object
329.66844 234.84047 346.63975 262.17950 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
329.66844 261.44135 m
329.66844 259.22750 L
333.35745 259.22750 L
333.35745 240.04261 L
333.35745 236.51802 330.90576 239.51254 329.67865 235.27446 C
339.99874 234.87676 L
342.71972 234.80362 340.36809 234.70044 342.44872 236.12031 C
337.78488 237.82876 L
337.78488 253.32463 L
337.78488 257.12929 339.80088 259.14161 343.31924 258.85899 C
345.90161 257.01392 L
346.40816 257.91449 346.63975 257.80365 346.63975 259.22750 C
346.63975 262.17950 L
341.47531 262.17950 L
339.63959 262.17950 338.69991 260.33471 337.04759 259.22750 C
337.04759 262.17950 L
333.35745 262.17950 L
332.19496 262.17950 330.56164 261.78803 329.66844 261.44135 C
@c
F

@rax %Note: Object
310.48299 345.10904 320.07515 383.19619 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.17 0.13 0.13 0.00 null ] set_fill_color
311.22000 380.98261 m
313.30403 380.80913 314.17200 381.00019 314.17200 378.76904 C
314.13487 347.92781 L
310.48299 347.03858 L
311.33112 343.86151 314.55468 345.56287 320.07515 345.56287 C
319.05723 347.08280 317.86157 347.47880 317.86157 349.25244 C
317.86157 383.19619 L
311.22000 383.19619 L
311.22000 380.98261 L
@c
F

@rax %Note: Object
214.55461 280.62737 230.13950 293.17181 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
230.13950 290.94491 m
228.41802 291.82195 226.45134 293.17181 224.14762 293.17181 C
221.93376 293.17181 L
217.64523 293.17181 214.55461 291.20372 214.55461 287.26894 C
214.55461 285.18661 217.32236 280.62737 219.71991 280.62737 C
224.14762 280.62737 L
226.02586 280.62737 227.54920 283.13575 229.14964 284.34132 C
230.13950 290.94491 L
@c
F

@rax %Note: Object
311.95871 197.98129 323.76529 223.80888 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
314.17200 216.42973 m
314.17200 214.95402 L
317.12400 214.95402 L
320.45783 212.72117 322.28872 211.77269 322.28872 206.09915 C
311.95871 206.09915 L
311.95871 202.40901 L
311.95871 200.53247 314.20517 197.98129 316.38586 197.98129 C
319.22731 197.98129 319.42205 198.39146 320.07515 200.19515 C
322.28872 200.19515 L
323.76529 200.19515 L
323.71200 222.93298 L
321.55172 223.80888 L
320.07515 223.80888 L
319.76050 220.02576 317.48400 219.17140 315.64772 216.42973 C
314.17200 216.42973 L
@c
F

@rax %Note: Object
269.84920 344.82472 287.60740 369.31011 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.12 0.12 0.00 null ] set_fill_color
270.63609 362.53446 m
269.89739 355.89345 L
269.34350 352.19650 273.65414 344.82472 277.27710 344.82472 C
283.17997 344.82472 L
285.46583 344.82472 287.10454 348.10724 287.60740 349.99058 C
282.88261 349.59742 284.93518 347.03858 281.70425 347.03858 C
278.75254 347.03858 L
275.72939 347.03858 274.32510 352.79603 274.32510 355.89345 C
274.32510 360.90652 275.96806 366.96217 280.96611 366.96217 C
281.70425 366.96217 L
284.50403 366.96217 284.85439 364.11222 285.39383 361.79745 C
286.63767 362.66117 286.86926 361.90290 286.86926 364.01131 C
286.84800 368.31231 L
280.96611 369.17575 L
275.17663 370.15455 272.66825 365.57093 270.63609 362.53446 C
@c
F

@rax %Note: Object
278.32139 234.87676 290.55912 262.17950 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
278.75254 259.22750 m
282.44211 259.22750 L
282.15241 238.23213 L
278.32139 235.47713 L
278.75254 234.87676 L
290.55912 234.87676 L
289.32633 239.49439 286.86926 235.13357 286.86926 239.30391 C
286.86926 262.17950 L
280.96611 262.17950 L
278.86564 262.17950 278.75254 261.32485 278.75254 259.22750 C
@c
F

@rax %Note: Object
243.33279 234.87676 255.54926 262.65572 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.12 0.12 0.00 null ] set_fill_color
243.33279 259.96564 m
247.76050 259.22750 L
247.33928 238.37216 L
243.60491 235.47912 L
244.07121 234.87676 L
255.54926 235.48564 L
252.18765 237.09061 L
252.18765 260.70435 L
252.18765 263.62545 244.19112 263.18211 243.33279 259.96564 C
@c
F

@rax %Note: Object
315.64772 234.87676 327.86419 262.17950 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
320.07515 259.22750 m
320.03773 237.97928 L
316.38586 237.09061 L
316.82523 235.44680 316.55849 234.87676 318.59972 234.87676 C
327.86419 235.48564 L
324.50258 237.09061 L
324.31861 240.04261 L
324.50258 243.73162 L
324.50258 257.75235 L
324.50258 259.92935 324.71943 262.17950 322.28872 262.17950 C
315.64772 262.17950 L
315.97625 259.17874 316.49216 259.30800 320.07515 259.22750 C
@c
F

@rax %Note: Object
291.16488 196.02085 309.00671 214.21587 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
298.67613 197.98129 m
296.97562 197.98129 296.46227 198.49493 296.46227 200.19515 C
296.46227 214.21587 L
291.16488 213.24161 L
293.48022 211.94617 L
293.14545 199.46750 L
293.51027 197.24400 L
296.73156 196.49395 300.24822 194.56526 301.62784 197.98129 C
304.76013 197.14564 302.91874 196.50614 305.31713 196.50614 C
309.00671 196.50614 L
309.00671 198.72000 L
306.79285 198.72000 L
306.79285 214.21587 L
303.10356 214.21587 L
300.99543 214.21587 301.75455 213.98428 300.88998 212.74044 C
302.53436 212.30107 303.10356 212.56753 303.10356 210.52658 C
303.10356 201.67172 L
303.10356 199.95024 301.13490 197.98129 299.41398 197.98129 C
298.67613 197.98129 L
@c
F

@rax %Note: Object
236.26006 294.63080 248.32261 322.08605 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.17 0.13 0.13 0.00 null ] set_fill_color
244.80935 315.30898 m
244.07121 318.26013 L
244.05279 322.08605 L
236.26006 320.61175 L
240.38164 318.26013 L
240.38164 304.24025 L
240.38164 300.06028 240.11773 297.03827 236.69178 296.12381 C
237.81487 294.58970 246.83896 293.85865 248.32261 295.80321 C
244.80935 297.59924 L
244.80935 310.88183 L
244.80935 315.30898 L
@c
F

@rax %Note: Object
334.86690 295.38539 346.63975 322.82702 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
334.86690 321.07266 m
334.86888 319.91329 L
338.68715 319.00422 L
338.44025 297.72369 L
335.57102 295.38539 L
346.63975 295.38539 L
346.60261 296.71143 L
342.95046 297.59924 L
342.95046 318.99827 L
342.95046 320.99159 342.59839 321.03326 342.17943 322.82702 C
334.86690 321.07266 L
@c
F

@rax %Note: Object
217.10636 305.71597 227.09962 320.47398 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.01 0.01 0.00 null ] set_fill_color
218.24476 306.45411 m
221.93376 305.71597 L
224.14762 305.71597 L
225.16129 307.63162 227.09962 309.37833 227.09962 312.35698 C
227.09962 316.57124 225.67720 320.47398 221.19562 320.47398 C
219.42198 320.47398 219.02740 319.27918 217.10636 318.23660 C
218.24476 306.45411 L
@c
F

@rax %Note: Object
340.70287 196.50614 354.01918 214.95402 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.12 0.12 0.00 null ] set_fill_color
346.08813 213.39411 m
349.59175 213.47773 L
350.23181 210.73153 352.17326 207.57487 348.85361 207.57487 C
343.50236 207.65849 L
346.08813 213.39411 L
@c
343.67131 206.09575 m
354.01918 206.09915 L
353.91798 210.61984 352.65203 214.95402 348.11546 214.95402 C
339.77367 214.95402 340.73660 206.79109 340.73660 200.19515 C
343.62935 199.14860 343.00885 196.50614 345.90161 196.50614 C
350.32904 196.50614 L
352.59307 196.50614 353.52000 198.32683 354.01918 200.19515 C
351.04535 199.50265 350.33187 197.98129 347.37817 197.98129 C
346.90819 197.98129 345.24879 199.64466 344.61014 200.22491 C
343.67131 206.09575 L
@c
F

@rax %Note: Object
309.00671 195.76800 322.28872 214.95402 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
312.69657 207.57487 m
312.76205 210.51439 313.55263 213.47773 316.38586 213.47773 C
317.28359 213.47773 318.59972 211.95156 318.59972 210.52658 C
318.59972 207.57487 L
312.69657 207.57487 L
@c
322.28872 200.19515 m
320.07515 200.19515 L
319.42205 198.39146 319.22731 197.98129 316.38586 197.98129 C
314.20517 197.98129 311.95871 200.53247 311.95871 202.40901 C
311.95871 206.09915 L
322.28872 206.09915 L
322.28872 211.77269 320.45783 212.72117 317.12400 214.95402 C
314.17200 214.95402 L
312.44315 212.59417 309.00671 211.85546 309.00671 206.83616 C
309.00671 203.88557 L
309.00671 198.89660 311.64633 195.76800 316.38586 195.76800 C
319.22986 195.76800 321.25153 198.23414 322.28872 200.19515 C
@c
F

@rax %Note: Object
327.45458 197.24400 335.57102 212.74044 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
331.14387 197.24400 m
333.68428 198.94450 335.57102 202.62161 335.57102 206.83616 C
335.57102 209.08942 334.18091 212.74044 331.88173 212.74044 C
331.14387 212.74044 L
329.27953 212.74044 327.45458 209.68299 327.45458 208.31272 C
327.45458 197.98129 L
331.14387 197.24400 L
@c
F

@rax %Note: Object
278.01439 279.15137 289.82126 299.07496 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.18 0.14 0.14 0.00 null ] set_fill_color
281.70425 298.33739 m
281.70425 291.63175 283.99833 281.49846 278.01439 281.36523 C
278.01439 279.15137 L
289.82126 279.15137 L
289.38189 280.79575 289.64863 281.36523 287.60740 281.36523 C
285.39383 281.36523 L
285.39383 296.12381 L
287.60740 296.12381 L
288.34583 297.59924 L
286.13197 297.59924 L
286.13197 299.07496 L
281.70425 298.33739 L
@c
F

@rax %Note: Object
297.69931 237.02598 306.79285 248.89748 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
297.93798 245.94548 m
297.69931 242.98498 L
297.99099 237.96652 L
300.16375 237.02598 L
305.31713 237.82876 L
305.93282 240.47036 306.79285 241.29553 306.79285 244.46976 C
306.79285 248.89748 L
302.36513 248.89748 L
299.43609 248.89748 300.91663 247.02435 297.93798 245.94548 C
@c
F

@rax %Note: Object
260.26639 296.86110 269.16038 308.60957 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.01 0.01 0.00 null ] set_fill_color
260.30523 303.50211 m
261.04252 297.59924 L
262.69795 297.21317 262.73962 296.86110 264.73294 296.86110 C
267.12340 296.86110 269.16038 300.06737 269.16038 302.76482 C
269.16038 306.45411 L
269.16038 310.86595 259.57672 307.81276 260.30523 303.50211 C
@c
F

@rax %Note: Object
356.23304 196.50614 368.03877 214.95402 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.12 0.12 0.00 null ] set_fill_color
359.18391 204.62287 m
359.18391 207.99836 359.62328 212.74044 362.87433 212.74044 C
363.61134 212.74044 L
367.14302 212.74044 364.39427 210.36983 368.03877 209.05002 C
368.03877 212.00202 L
368.03877 213.72973 366.81534 214.95402 365.08791 214.95402 C
363.61134 214.95402 L
358.59770 214.95402 356.23304 211.19698 356.23304 206.09915 C
356.23304 201.67172 L
356.23304 199.61546 359.34265 196.50614 361.39776 196.50614 C
362.87433 196.50614 L
366.00973 196.50614 367.37206 197.69839 368.03877 200.19515 C
364.64854 199.29090 366.17641 197.98129 363.61134 197.98129 C
361.39776 197.98129 L
360.60917 200.93613 359.18391 200.39839 359.18391 203.88557 C
359.18391 204.62287 L
@c
F

@rax %Note: Object
347.37817 344.82472 359.34265 365.65200 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.14 0.11 0.11 0.00 null ] set_fill_color
351.06746 346.30129 m
350.46680 348.87855 349.59175 348.78614 349.59175 351.46573 C
349.59175 352.94230 L
349.59175 355.34069 350.23039 353.49931 351.06746 356.63159 C
354.43304 356.55676 355.49461 355.27380 355.49461 352.20444 C
355.49461 348.74929 354.47159 346.58447 351.06746 346.30129 C
@c
353.24362 364.94617 m
355.49461 363.27260 L
355.49461 357.36973 L
353.83975 357.75524 353.79893 358.10731 351.80561 358.10731 C
349.29128 358.10731 347.37817 353.99877 347.37817 351.46573 C
347.37817 348.93439 349.29128 344.82472 351.80561 344.82472 C
352.54261 344.82472 L
354.62126 344.82472 353.90920 345.14447 354.71962 346.05099 C
359.34265 345.72104 L
357.35471 347.80025 L
357.32948 351.46091 L
356.93887 365.65200 L
353.24362 364.94617 L
@c
F

@rax %Note: Object
353.28076 251.11077 363.61134 260.70435 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
353.28076 251.84920 m
357.71102 251.86592 L
363.61134 251.11077 L
363.61134 255.53849 L
363.61134 258.02504 362.30740 260.70435 359.92233 260.70435 C
358.44661 260.70435 L
355.22986 260.70435 353.36098 255.45657 353.28076 251.84920 C
@c
F

@rax %Note: Object
353.28076 311.61912 364.34948 320.47398 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.00 0.00 0.00 null ] set_fill_color
355.12611 317.89134 m
353.28076 311.61912 L
364.34948 311.61912 L
364.28570 314.49231 362.84428 320.47398 359.92233 320.47398 C
357.33997 320.10520 L
355.12611 317.89134 L
@c
F

@rax %Note: Object
139.28854 311.61912 150.71556 319.73669 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.01 0.01 0.00 null ] set_fill_color
139.28854 311.61912 m
150.71556 311.69480 L
148.88069 319.73669 L
145.92954 319.73669 L
141.67587 319.73669 139.65732 314.99093 139.28854 311.61912 C
@c
F

@rax %Note: Object
359.18391 344.82472 368.77720 358.10731 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.14 0.11 0.11 0.00 null ] set_fill_color
362.13562 352.94230 m
362.21272 356.37392 362.22548 356.60551 365.08791 357.36973 C
366.00265 352.97717 L
362.13562 352.94230 L
@c
359.18391 351.46573 m
359.18391 348.06161 361.04230 344.82472 364.34948 344.82472 C
366.62882 344.82472 367.86529 346.41638 368.67005 348.06019 C
363.79899 345.97786 L
361.39776 351.46573 L
368.77720 351.46573 L
368.18277 354.01606 367.96932 358.10731 365.08791 358.10731 C
363.61134 358.10731 L
360.88243 358.10731 359.18391 354.33184 359.18391 351.46573 C
@c
F

@rax %Note: Object
326.71644 359.58359 336.74967 367.70031 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.01 0.01 0.01 0.00 null ] set_fill_color
326.71644 359.58359 m
336.74967 359.77096 L
333.35745 367.70031 L
327.97134 367.25216 326.84117 365.16926 326.71644 359.58359 C
@c
F

@rax %Note: Object
247.02321 204.62287 254.40151 220.11874 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.13 0.10 0.10 0.00 null ] set_fill_color
251.08101 213.84709 m
250.53619 214.53562 L
247.07792 212.63924 L
247.02321 207.57487 L
247.02321 205.84743 248.24665 204.62287 249.97436 204.62287 C
254.40151 204.86863 L
254.40151 220.11874 L
252.18765 220.11874 L
252.18765 214.21587 L
252.18765 211.96800 252.52328 211.51672 252.92608 209.78872 C
251.45915 206.73213 253.28863 206.43676 249.23650 206.09915 C
248.85071 207.75345 248.49865 207.79540 248.49865 209.78872 C
248.86715 211.63351 L
251.08101 213.84709 L
@c
F

@rax %Note: Object
207.17603 296.12381 216.19219 308.66797 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
209.38961 303.50211 m
207.17603 299.07496 L
208.65175 299.81310 L
208.98340 296.75027 L
209.52907 298.57266 L
213.81704 296.12381 L
213.80117 302.80507 L
216.19219 303.54491 L
215.29276 306.45411 L
213.07890 308.66797 L
211.93625 303.42472 L
211.35005 305.90164 L
209.38961 303.50211 L
@c
F

@rax %Note: Object
349.59175 346.30129 355.49461 356.63159 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
351.06746 346.30129 m
354.47159 346.58447 355.49461 348.74929 355.49461 352.20444 C
355.49461 355.27380 354.43304 356.55676 351.06746 356.63159 C
350.23039 353.49931 349.59175 355.34069 349.59175 352.94230 C
349.59175 351.46573 L
349.59175 348.78614 350.46680 348.87855 351.06746 346.30129 C
@c
F

@rax %Note: Object
142.97783 324.54567 152.57112 338.18372 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
142.97783 325.63956 m
142.97783 324.56069 143.88803 324.55701 143.97392 324.54567 C
152.57112 335.96986 L
151.09455 335.96986 L
151.09455 338.18372 L
148.88069 338.18372 L
148.75455 332.48211 142.97783 330.98825 142.97783 325.63956 C
@c
F

@rax %Note: Object
256.01839 204.60557 263.97014 214.23317 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.13 0.10 0.10 0.00 null ] set_fill_color
256.01839 214.23317 m
257.21235 204.60557 L
263.97014 205.52485 L
263.02961 207.30614 263.25638 204.75354 263.25638 207.57487 C
263.25638 213.47773 L
261.78094 213.47773 L
261.78094 209.05002 L
261.78094 206.80866 260.50054 206.54532 258.82923 206.09915 C
258.82923 212.00202 L
258.82923 214.23317 257.96069 214.04239 256.01839 214.23317 C
@c
F

@rax %Note: Object
244.07121 315.30898 253.66422 321.94998 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
244.07121 318.26013 m
244.80935 315.30898 L
246.32646 318.09997 L
249.50183 319.21002 L
252.83735 315.32230 L
253.66422 321.94998 L
249.23650 321.94998 L
247.68113 321.94998 244.95279 319.19102 244.07121 318.26013 C
@c
F

@rax %Note: Object
343.50236 207.57487 350.73921 213.47773 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.02 0.02 0.00 null ] set_fill_color
343.50236 207.65849 m
348.85361 207.57487 L
352.17326 207.57487 350.23181 210.73153 349.59175 213.47773 C
346.08813 213.39411 L
343.50236 207.65849 L
@c
F

@rax %Note: Object
246.12718 268.82050 252.18765 275.61969 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
246.12718 273.40583 m
246.80438 271.01962 246.71197 268.82050 249.23650 268.82050 C
250.96337 268.82050 252.18765 270.04535 252.18765 271.77250 C
252.15052 274.57398 L
248.34076 275.61969 L
246.12718 273.40583 L
@c
F

@rax %Note: Object
318.41150 269.55921 324.50258 276.20022 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
320.07515 274.72365 m
318.41150 274.69332 L
319.33786 269.55921 L
321.55172 269.55921 L
323.27802 269.55921 324.50258 270.78236 324.50258 272.51008 C
324.50258 274.90847 323.86394 273.06709 323.02687 276.20022 C
320.07515 276.20022 L
320.07515 274.72365 L
@c
F

@rax %Note: Object
281.70425 268.82050 286.86926 275.46208 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.12 0.12 0.00 null ] set_fill_color
281.70425 273.24822 m
281.70425 271.77250 L
281.70425 269.14422 283.45351 268.88031 286.13197 268.82050 C
286.51720 270.47594 286.86926 270.51761 286.86926 272.51008 C
286.86926 273.24822 L
286.86926 274.94872 286.35591 275.46208 284.65540 275.46208 C
283.91811 275.46208 L
282.21761 275.46208 281.70425 274.94872 281.70425 273.24822 C
@c
F

@rax %Note: Object
312.69657 207.57487 318.59972 213.47773 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
312.69657 207.57487 m
318.59972 207.57487 L
318.59972 210.52658 L
318.59972 211.95156 317.28359 213.47773 316.38586 213.47773 C
313.55263 213.47773 312.76205 210.51439 312.69657 207.57487 C
@c
F

@rax %Note: Object
179.13572 268.82050 184.30044 275.46208 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
179.13572 273.24822 m
179.13572 271.54261 179.96031 268.82050 181.34929 268.82050 C
183.07616 268.82050 184.30044 270.04535 184.30044 271.77250 C
184.30044 273.24822 L
184.30044 274.94872 183.78737 275.46208 182.08687 275.46208 C
180.66161 275.46208 179.13572 274.14595 179.13572 273.24822 C
@c
F

@rax %Note: Object
337.78488 329.32885 342.95046 335.23257 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.16 0.13 0.13 0.00 null ] set_fill_color
337.78488 334.49443 m
337.78488 330.06699 L
339.76403 329.59361 339.17584 329.32885 340.73660 329.32885 C
342.43710 329.32885 342.95046 329.84306 342.95046 331.54271 C
342.95046 333.01871 L
342.95046 334.22598 342.50882 335.23257 341.47531 335.23257 C
340.31225 335.23257 338.67836 334.84110 337.78488 334.49443 C
@c
F

@rax %Note: Object
253.66422 383.19619 263.25638 390.57506 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.15 0.11 0.11 0.00 null ] set_fill_color
253.66422 383.19619 m
258.09137 385.41005 L
261.04252 385.41005 L
262.88532 388.16050 263.16255 386.35909 263.25638 390.57506 C
260.16520 390.31767 254.33206 385.69946 253.66422 383.19619 C
@c
F

@rax %Note: Object
314.17200 216.42973 320.07515 224.68394 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.14 0.11 0.11 0.00 null ] set_fill_color
314.17200 216.42973 m
315.64772 216.42973 L
317.48400 219.17140 319.76050 220.02576 320.07515 223.80888 C
317.91458 224.68394 L
314.21310 217.87965 L
314.17200 216.42973 L
@c
F

@rax %Note: Object
362.13562 352.94230 366.00265 357.36973 @E
/$fm 0 def
 0 O 0 @g
[ 1.00 0.02 0.01 0.01 0.00 null ] set_fill_color
362.13562 352.94230 m
366.00265 352.97717 L
365.08791 357.36973 L
362.22548 356.60551 362.21272 356.37392 362.13562 352.94230 C
@c
F

%%PageTrailer
@rs
@rs
%%Trailer
@EndSysCorelDict
end
%%DocumentSuppliedResources: procset wCorel14Dict 14.0 0
%%EOF



}bind def 

`
}







    export default {bulletin_create}